var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31 {\n        stroke-width: 0px;\n      }\n\n      .cls-32 {\n        fill: url(#Degradado_sin_nombre_166);\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-32, .cls-33, .cls-34 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .26px;\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-36 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_137-2);\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-19);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-28 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-17);\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-14);\n      }\n\n      .cls-7 {\n        filter: url(#drop-shadow-22);\n      }\n\n      .cls-8 {\n        filter: url(#drop-shadow-20);\n      }\n\n      .cls-9 {\n        filter: url(#drop-shadow-21);\n      }\n\n      .cls-10 {\n        filter: url(#drop-shadow-24);\n      }\n\n      .cls-11 {\n        filter: url(#drop-shadow-23);\n      }\n\n      .cls-12 {\n        filter: url(#drop-shadow-16);\n      }\n\n      .cls-13 {\n        filter: url(#drop-shadow-15);\n      }\n\n      .cls-14 {\n        filter: url(#drop-shadow-13);\n      }\n\n      .cls-15 {\n        filter: url(#drop-shadow-10);\n      }\n\n      .cls-16 {\n        filter: url(#drop-shadow-12);\n      }\n\n      .cls-33 {\n        fill: url(#Degradado_sin_nombre_154);\n      }\n\n      .cls-34 {\n        fill: url(#Degradado_sin_nombre_155);\n      }\n\n      .cls-17 {\n        fill: url(#Degradado_sin_nombre_137);\n      }\n\n      .cls-18 {\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-19 {\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-20 {\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-21 {\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-22 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-23 {\n        fill: #ff00ae;\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-24 {\n        fill: #606060;\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-37 {\n        filter: url(#drop-shadow-18);\n      }\n\n      .cls-38 {\n        filter: url(#drop-shadow-25);\n      }\n\n      .cls-39 {\n        filter: url(#drop-shadow-11);\n      }\n\n      .cls-25 {\n        fill: #f9d656;\n      }\n\n      .cls-26 {\n        fill: #e1991c;\n      }\n\n      .cls-27 {\n        fill: #fdebb6;\n      }\n\n      .cls-29 {\n        fill: #eeae1a;\n      }\n\n      .cls-30 {\n        fill: #fbde7f;\n      }\n\n      .cls-31 {\n        fill: #f1bb16;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.58,
    dy: 6.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 12.26
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb600",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6.86
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a56f16",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_166",
    "data-name": "Degradado sin nombre 166",
    cx: 25.06,
    cy: 39.44,
    fx: 25.06,
    fy: 39.44,
    r: 16.88,
    gradientTransform: "translate(6.1 -3.27) rotate(8.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.41,
    dy: 6.83
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 9.2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9713ce",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_137",
    "data-name": "Degradado sin nombre 137",
    x1: -778.96,
    y1: 164.64,
    x2: -749.53,
    y2: 164.64,
    gradientTransform: "translate(609.84 -2.81) rotate(11.23) scale(.76 .99) skewX(6.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c1e5e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#970d7c",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#920392",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90009c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_137-2",
    "data-name": "Degradado sin nombre 137",
    x1: -16621.88,
    y1: 2532.24,
    x2: -16592.47,
    y2: 2532.24,
    gradientTransform: "translate(2429.96 -5.03) rotate(46.38) scale(.2 .7) skewX(73.77)",
    xlinkHref: "#Degradado_sin_nombre_137"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.04,
    dy: 2.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 4.99
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff83fc",
    floodOpacity: 0.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_154",
    "data-name": "Degradado sin nombre 154",
    cx: -1521.8,
    cy: 3264.24,
    fx: -1521.8,
    fy: 3264.24,
    r: 20.28,
    gradientTransform: "translate(-3.94 -1070.62) rotate(-8.26) scale(.91 .33) skewX(23.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffffc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fefac9",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fdeece",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fcd9d8",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fabde5",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab3ea",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_155",
    "data-name": "Degradado sin nombre 155",
    cx: 35.45,
    cy: 22.12,
    fx: 35.45,
    fy: 22.12,
    r: 18.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#eebdc7",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#eebfc9",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f1c5d0",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f5cfdc",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fadaea",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-11",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-12",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-12",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-13",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-13",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-14",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-14",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-15",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-15",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-16",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-16",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-16",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-17",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-17",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-18",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-18",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-18",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.25,16.81L28.46,4.91c-2.04-.98-4.48-.12-5.46,1.92l-7.27,15.14c-.98,2.04-.12,4.48,1.92,5.46l.79.38,18.37-2.75c2.23-.33,4.32,1.21,4.65,3.44l1.66,11.09c1.87.52,3.91-.36,4.78-2.17l7.27-15.14c.98-2.04.12-4.48-1.92-5.46Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.83,7.96l15.52,7.46s2.51-7.39-2.65-10.19c-5.16-2.8-9.44-1.34-9.44-1.34l-3.43,4.07Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-19",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-19",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-19",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-20",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-20",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-20",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-21",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-21",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-21",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-22",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-22",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-22",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-23",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-23",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-23",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-24",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-24",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-24",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-25",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72,
    dy: 1.49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-25",
    stdDeviation: 2.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-25",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m28.53-41.2l-1.11-.53.03.02h0c-.11-.06-.23-.11-.35-.16-.03-.01-.05-.02-.08-.03-.07-.03-.15-.06-.22-.09,0,0-.02,0-.02,0-.04-.01-.07-.03-.11-.04h0c-.19-.07-.39-.14-.58-.21h0c-.12-.04-.24-.07-.36-.11-.03,0-.05-.01-.08-.02-.12-.03-.23-.06-.35-.09h0c-.27-.07-.54-.12-.82-.16h0c-.42-.07-.85-.11-1.29-.12-.12,0-.23,0-.35,0-.09,0-.19,0-.28,0-.03,0-.06,0-.09,0-.06,0-.12,0-.19,0-.04,0-.07,0-.11,0-.06,0-.11,0-.17.01-.04,0-.08,0-.12.01-.05,0-.11,0-.16.01-.04,0-.08,0-.12.01-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.02-.15.03-.04,0-.08.01-.12.02-.05,0-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.14.04-.04.01-.08.02-.12.03-.05.01-.1.03-.14.04-.04.01-.08.02-.12.03-.05.01-.1.03-.15.04-.04.01-.08.02-.11.03-.05.02-.1.03-.15.05-.04.01-.07.02-.11.04-.05.02-.11.04-.16.06-.03.01-.06.02-.09.03-.07.03-.15.06-.22.09h-.03c-.66.28-1.3.61-1.9.99h0c-.23.15-.46.3-.67.46h0c-.22.16-.43.33-.64.51h0c-2.18,1.86-3.72,4.51-4.17,7.5h0c-.02.11-.03.21-.04.32h0c-.01.11-.02.21-.03.31v.03c-.01.09-.02.18-.03.27,0,.02,0,.04,0,.05,0,.11-.01.21-.02.32h0c0,.11,0,.22,0,.33-.01.74.05,1.46.16,2.15h0c.01.08.03.16.04.23,0,.04.01.07.02.11.02.08.03.15.05.23,0,.02.01.05.02.07.03.15.07.29.11.44,0,.03.02.06.03.1.02.07.04.15.06.22.01.03.02.07.03.1.05.16.1.31.16.46v.02c.03.07.06.15.09.22.01.03.03.07.04.1.03.07.06.14.09.21l.02.04c.06.14.13.29.19.43.01.03.03.06.04.09.03.07.07.14.1.2.01.03.03.06.04.08.07.14.15.28.23.42l.02.03c.04.07.08.13.12.2.02.03.03.06.05.08.04.07.08.13.12.2h0c.24.37.5.71.78,1.05h0s.02.03.04.04c.03.04.06.08.1.11.05.05.09.11.14.16h0c.09.1.18.2.28.3h0c.09.1.19.2.29.29h.01c.05.06.11.11.16.16,0,0,0,0,.01.01.04.04.08.07.13.11h0c.16.14.32.27.48.39h0s.03.02.04.03c.02.02.05.04.07.06.03.03.07.05.1.07.02.02.05.04.07.05.03.02.07.05.1.07.02.02.05.03.07.05.06.04.11.08.17.12.03.02.06.04.09.06.06.04.11.07.17.11.08.05.17.1.25.15.04.02.07.04.11.06.07.04.14.08.21.11.03.02.07.04.1.05.1.05.2.11.31.16h0s-.01,0-.01,0l1.11.53c1.38.66,2.93,1.03,4.58,1.03,6.17,0,11.39-5.18,11.65-11.57.19-4.68-2.33-8.71-6.12-10.54Zm-1.94,1.18h.02s.02.02.02.02h0s-.04-.02-.04-.02h0Zm-.81-.34s.06.02.09.03c.03,0,.05.02.08.03,0,0,0,0,0,0-.03-.01-.05-.02-.08-.03-.03-.01-.06-.02-.08-.03Zm.61.25s.04.02.05.03h0s-.04-.02-.06-.03Zm.46.23h0s.04.02.06.03c-.02-.01-.04-.02-.06-.03Zm-1.45-.6h0s.06.02.1.03c0,0,0,0,0,0-.03-.01-.07-.02-.1-.03Zm-.7-.18h0s.07.02.11.02c0,0,0,0,0,0-.04,0-.07-.02-.11-.02Zm-.71-.13s-.05,0-.08,0c.03,0,.05,0,.08.01.04,0,.07.01.11.02h0s-.07-.01-.11-.02Zm-.38-.04s-.02,0-.02,0c0,0,.01,0,.02,0h0Zm.15.01s.03,0,.04,0c.01,0,.02,0,.03,0-.03,0-.05,0-.08,0Zm6.49,4.06l-.02-.03h0s.02.03.02.03h0Zm.15.24s.02.03.03.05h0s-.02-.03-.02-.03h0Zm.48.91v-.02s-.01,0-.01,0c0,0,0,0,0,0v.02s.04.07.06.11c-.02-.04-.03-.07-.05-.11Zm-.13-.27s.03.07.05.1c-.02-.03-.03-.07-.05-.1-.01-.02-.02-.05-.03-.07.01.02.02.04.03.06h0Zm-.72-1.21s.02.02.03.04c0-.01-.02-.03-.03-.04h0Zm-2.01-2.06s0,0,0,0h0s0,0,0,0Zm1.45,1.35s-.01-.01-.02-.02c0,0,.01.01.02.02h0Zm-.49-.53h0s0,0,.01.01c0,0,0,0-.01-.01Zm.87,1h0s0,0,0,0l.03.04c.04.06.08.11.12.17-.04-.06-.08-.11-.12-.17-.01-.01-.02-.03-.03-.04Zm-1.12-1.23s-.05-.05-.08-.07c.03.02.05.05.08.07l.02.02-.02-.02Zm-.21-.18s-.02-.02-.03-.03c-.07-.06-.15-.12-.22-.18l-.02-.02.02.02c.08.06.15.12.22.18.01,0,.02.02.03.03Zm-.78-.6h-.01s0,0,0,0h.01s0,.01,0,.01c0,0,0,0,0,0Zm-.54-.34h0s0,0,0,0h0Zm-1.45-.67s-.01,0-.02,0c-.02,0-.04-.01-.05-.02.02,0,.04.01.05.02,0,0,.01,0,.02,0h0Zm-2.48-.5s.06,0,.1,0h0s-.07,0-.1,0c-.05,0-.1,0-.16,0-.03,0-.06,0-.09,0-.04,0-.08,0-.11,0,.04,0,.08,0,.12,0,.03,0,.05,0,.08,0,.06,0,.11,0,.17,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: 99,
    height: 88,
    transform: "translate(-19 -12)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 7.21,
    y: 26.95,
    width: 35.69,
    height: 24.98,
    rx: 3.74,
    ry: 3.74,
    transform: "translate(-5.55 4.14) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 11.36,
    y: 45.56,
    width: 22.28,
    height: 3.01,
    rx: 1.05,
    ry: 1.05,
    transform: "translate(-6.71 3.84) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.24,
    y: 43.31,
    width: 4.21,
    height: 3.01,
    rx: 1.05,
    ry: 1.05,
    transform: "translate(-6.21 6.01) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 13.82,
    cy: 35.61,
    r: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 19.74,
    y: 13.9,
    width: 35.69,
    height: 7.55,
    transform: "translate(11.36 -14.53) rotate(25.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m53.25,16.81L28.46,4.91c-2.04-.98-4.48-.12-5.46,1.92l-7.27,15.14c-.98,2.04-.12,4.48,1.92,5.46l.79.38,18.37-2.75c2.23-.33,4.32,1.21,4.65,3.44l1.66,11.09c1.87.52,3.91-.36,4.78-2.17l7.27-15.14c.98-2.04.12-4.48-1.92-5.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.83,12.86h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.47,13.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.05,23.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.17,16.01l.84-1.51c-.09.13-.18.26-.26.39-.22.36-.41.73-.58,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.5,17.79h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.97,12.47h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.24,23.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.2,12.7h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.58,12.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.6,22.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.12,22.89h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.77,22.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.86,23.25h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.91,21.93l-.02-.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.86,20.24s0-.02-.01-.03c0,.01,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.95,20.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.9,20.35v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.8,21.8s-.02-.02-.03-.03c0,.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7,20.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.13,13.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.35,22.16h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "17.01 15.77 17.01 15.76 17.01 15.77 17.01 15.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.08,21.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.66,21.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "16.14 14.24 16.13 14.23 16.13 14.23 16.14 14.23 16.14 14.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "15.33 13.43 15.35 13.45 15.33 13.43 15.33 13.43 15.33 13.43 15.33 13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.04,14.12h0s.02.03.04.04c-.01-.01-.02-.03-.04-.04,0,0-.02-.02-.02-.03,0,0,.02.02.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.92,19.93s0,.02-.01.03c0-.01,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.2,13.34s-.02-.01-.02-.02c-.05-.03-.09-.07-.14-.1.05.03.09.06.14.1,0,0,.02.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.76,13.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.51,13.58s.07.06.11.1l.02.02h0s0,0,0,0c.02.02.04.04.06.06h0s-.04-.04-.07-.06l-.02-.02s-.07-.06-.11-.1c-.01,0-.02-.02-.03-.03-.04-.04-.09-.07-.13-.11.04.03.09.07.13.11.01,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.31,17.04s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.22,16.47s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.26,16.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.12,16.1s0,.02.01.04c0-.01,0-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.18,16.3s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.29,16.85s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.07,15.93s0,.03.01.04c0-.01,0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17,19.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.13,19.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.07,19.53v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.18,19.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.88,15.46s-.02-.04-.03-.06h0s0,0,0,0c0,.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.44,17.74c0-.05,0-.11.01-.16,0,.05,0,.11-.01.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.39,11.5s.04-.01.07-.02c-.02,0-.05.01-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.43,17.96c0-.06,0-.12.01-.19,0,.06,0,.12-.01.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.46,17.56c0-.06.01-.12.02-.17,0,.06-.01.12-.02.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.55,19.53s-.02-.09-.02-.13c0,.04.02.09.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.59,19.73s-.02-.09-.03-.13c0,.04.02.09.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.48,17.38c0-.06.02-.12.03-.18,0,.06-.02.12-.03.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.94,11.65s.03-.01.05-.02c-.02,0-.04.01-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.09,11.6s.04-.01.06-.02c-.02,0-.04.01-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.24,11.55s.04-.01.07-.02c-.02,0-.04.01-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.8,11.71h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.3,12.55c.13-.09.26-.18.39-.27-.13.09-.26.18-.39.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.45,23.43h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.66,20.02c-.02-.08-.04-.17-.06-.26.02.09.04.17.06.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.43,23.01c-.06-.05-.11-.11-.17-.16.05.06.11.11.17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.42,23.77s-.07-.04-.1-.06c.03.02.07.04.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.26,22.84c-.06-.06-.11-.11-.16-.17.05.06.11.12.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.71,20.21s-.03-.09-.04-.13c.01.04.02.09.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.81,23.99s-.04-.02-.06-.03c.02.01.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.63,23.89s-.04-.02-.06-.04c.02.01.04.02.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.49,21.88s-.05-.08-.07-.11c.02.04.05.08.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.95,20.86s-.03-.08-.05-.12c.02.04.03.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.31,21.58c-.05-.08-.09-.16-.13-.24.04.08.09.16.13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.82,20.54c-.03-.09-.06-.18-.09-.27.03.09.06.18.09.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m5.87,20.67s-.03-.08-.05-.13c.02.04.03.08.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.15,21.29s-.04-.08-.06-.12c.02.04.04.08.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.07,21.13c-.04-.08-.08-.16-.11-.25.04.08.07.17.11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.93,12.84c.12-.1.25-.2.37-.3-.13.09-.25.19-.37.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.5,24.62c-.07,0-.14.02-.21.02.07,0,.14-.02.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.29,24.64c-.06,0-.12.01-.19.02.06,0,.13,0,.19-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.29,24.21s.02,0,.04.01c.04.02.08.03.11.05-.04-.01-.08-.03-.11-.05-.01,0-.02,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.67,11.76c.07.03.14.06.2.09-.07-.03-.13-.06-.2-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.7,24.58c-.06.01-.13.02-.19.03.06,0,.13-.02.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.6,23.95s-.09.05-.14.07c.05-.02.09-.05.14-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.05,24.66s-.1,0-.15,0c.05,0,.1,0,.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.3,23.57h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.59,24.33s.04.01.06.02c.02,0,.05.02.07.02-.02,0-.05-.02-.07-.02-.02,0-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.87,23.52h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.71,24.61s-.06,0-.09-.01c-.02,0-.05,0-.07-.01.02,0,.05,0,.07.01.03,0,.06,0,.09.01.02,0,.05,0,.07.01.03,0,.06,0,.09.01-.03,0-.06,0-.09-.01-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.27,24.52s.02,0,.02,0c.01,0,.03,0,.04,0-.01,0-.03,0-.04,0,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.9,24.43s-.03,0-.05-.01c.02,0,.03,0,.05.01.02,0,.05.01.07.02.03,0,.06.02.09.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.19,11.24h0c.07,0,.14,0,.2,0-.07,0-.14,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11,11.35s.05,0,.07-.01c-.02,0-.05,0-.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.16,11.33s.05,0,.07-.01c-.02,0-.05,0-.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.88,11.47c.07.02.14.04.21.06-.07-.02-.14-.04-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.32,11.3s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.69,11.42s.05-.01.07-.02c-.02,0-.05.01-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.85,11.38s.05,0,.07-.01c-.02,0-.05,0-.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.48,11.28s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.15,11.31c.16.02.32.06.47.09-.16-.04-.31-.07-.47-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.54,11.46s.05-.01.07-.02c-.02,0-.05.01-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.63,11.41c.07.02.14.03.21.05-.07-.02-.14-.04-.21-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.81,11.25s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.98,11.24s.04,0,.05,0c-.02,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.64,11.27s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.39,21.71s-.05-.08-.07-.12c.02.04.05.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.39,14.57s.05.08.08.12v.02s.01,0,.01,0v.02s.01,0,.01,0h0s.05.09.08.13h0s0,0,0,0c0,.01.02.03.02.04h0s.03.05.04.07c.01.02.03.05.04.07h0c.03.05.05.1.08.15h0s.01.02.02.04l.62-1.11v-.02s-.03-.02-.03-.02c-.04-.06-.07-.11-.11-.17,0-.01-.02-.03-.03-.04-.03-.05-.07-.09-.1-.14,0,0-.01-.02-.02-.03-.02-.03-.04-.06-.07-.08l-.59,1.06s-.04-.07-.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.5,18.6h0s0,.02,0,.02c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "6.64 19.54 6.64 19.55 6.64 19.54 6.64 19.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.73,14.71s-.02-.03-.02-.05c0-.02-.02-.04-.03-.06,0,.02.02.04.03.06,0,.02.02.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m18.14,15.75v.02s0-.02,0-.02c-.02-.06-.03-.11-.05-.17,0-.02-.01-.03-.02-.05,0,.02.01.03.02.05.02.06.04.11.05.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.48,18.3h0s0,0,0,0c0,.01,0,.03,0,.04,0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.49,17.96h0s0,.1,0,.14c0-.05,0-.1,0-.14h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "16.96 13.5 16.95 13.5 16.94 13.48 16.95 13.5 16.96 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.64,12.36h0,0s-.03,0-.05,0c.02,0,.03,0,.05,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.75,19.92s0-.02,0-.03c.01.04.02.08.04.12-.01-.03-.02-.06-.03-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.8,20.09h0s.01.02.02.04c0-.01,0-.03-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.7,19.75s.03.1.04.15h0s0,0,0,0c-.02-.05-.03-.1-.04-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.34,12.85h0s-.04-.05-.06-.06c.02.02.04.04.06.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.69,19.71h0s0,.02.01.04c0-.01,0-.02-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.64,12.3h0s-.07-.05-.11-.08c.04.02.07.05.11.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.25,12.78s.03.01.04.02c-.01,0-.03-.01-.04-.02-.03-.01-.05-.02-.08-.03h0s.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.08,11.96s-.03-.02-.05-.02c-.03-.01-.05-.03-.08-.04.03.01.05.03.08.04.02,0,.03.02.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m15.18,22.31s-.06.05-.09.07c-.16.13-.33.25-.51.36-.03.02-.06.04-.09.05-.11.07-.23.13-.34.19l-.81,1.46c-.2.06-.4.1-.61.14.6-.1,1.19-.29,1.73-.56-.1.05-.2.1-.31.14l1.03-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.54,24.67l.62-1.11c-.15.01-.31.02-.47.02-.06,0-.12,0-.18,0l-.59,1.06s.03,0,.04,0c.03,0,.06,0,.1,0,.02,0,.05,0,.07,0,.03,0,.07,0,.1,0,.02,0,.05,0,.07,0,.04,0,.08,0,.12,0,.02,0,.04,0,.06,0,.06,0,.12,0,.17,0,.07,0,.13,0,.2,0-.07,0-.13,0-.2,0-.04,0-.07,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.12,12.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.29,12.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.86,13.1h0s.02.02.04.02c-.01,0-.02-.02-.04-.02h-.02s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.71 13.02 14.71 13.02 14.71 13.02 14.72 13.02 14.71 13.02 14.69 13.01 14.71 13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.28,12.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.93,12.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.72,12.37s.02,0,.03,0c-.01,0-.02,0-.03,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m18.35,16.76v-.02s0-.03-.01-.05c0,.02,0,.03,0,.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.07,12.42h0s.05,0,.07.01c.02,0,.04,0,.06.01.02,0,.04,0,.06.01h0s-.04,0-.06-.01c-.02,0-.04,0-.06-.01-.03,0-.05,0-.08-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13,12.41s.04,0,.06.01c-.02,0-.04,0-.06-.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.35,17.67c0,.1,0,.19,0,.29,0,.18-.02.35-.05.53l1.03-1.85s0,.03,0,.05c0-.06-.02-.12-.03-.18,0-.01,0-.03,0-.04-.01-.07-.03-.14-.04-.21,0-.02,0-.03-.01-.05-.01-.06-.03-.11-.04-.17,0-.02,0-.03-.01-.05-.02-.07-.04-.13-.05-.2l-.81,1.46c.01.14.02.28.02.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m18.4,17.23s0,.06,0,.09l-1.57,2.82c-.13.3-.29.58-.47.85,0,.01-.02.03-.03.04l-1.58,2.84s-.1.05-.15.08c2.15-1.11,3.68-3.37,3.79-5.99,0-.08,0-.15,0-.23,0-.02,0-.04,0-.06,0-.07,0-.14,0-.2v-.02c0-.07,0-.15-.01-.22,0-.02,0-.04,0-.06,0-.04,0-.08-.01-.12,0,.04,0,.08.01.12,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.37 12.84 14.38 12.84 14.37 12.84 14.37 12.84 14.37 12.84 14.37 12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.57,14.79c.28-.52.64-1.01,1.07-1.43l.29-.52c-1.27,1.08-2.16,2.62-2.42,4.36l.49-.89c.12-.53.31-1.04.57-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.78,12.35c.12,0,.24-.01.37-.01h.02s.04,0,.06,0c.02,0,.04,0,.07,0,.02,0,.03,0,.05,0,.03,0,.06,0,.1,0,.02,0,.04,0,.06,0h0s0,0,0,0h.01s.04,0,.06,0l.58-1.04c-.25-.04-.5-.06-.75-.07l-.61,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m7.52,21.45h0s-.03-.05-.04-.07h0s0,0,0,0h0s-.01-.02-.02-.03c-.01-.02-.03-.04-.04-.07,0-.01-.02-.02-.02-.03v-.02s-.02-.01-.02-.01h0s-.01-.02-.02-.03h0s-.01-.03-.02-.04c0-.01-.02-.02-.02-.04v-.02s-.02-.02-.03-.03v-.02s-.04-.04-.05-.07h0s0-.02,0-.02h0s0-.02,0-.02c-.02-.03-.04-.06-.05-.1h0s-.01-.04-.02-.05h0s0-.02,0-.02l-.61,1.1c.18.28.39.54.61.79-.05-.06-.11-.12-.16-.18l.58-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.29,12.18c.11-.05.22-.1.32-.15l.18-.33c-.39.16-.76.35-1.11.57l-.21.38c.26-.18.53-.34.81-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.99,24.08h0s0,0,0,0c.02,0,.04.02.05.03-.02,0-.04-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m8.44,22.43h-.01s0-.01,0-.01c-.01,0-.02-.02-.03-.03h-.02s-.04-.05-.07-.07c0,0-.02-.02-.03-.02l-.02-.02-.02-.02s-.03-.03-.05-.05l-.02-.02h0s-.55.98-.55.98c-.06-.05-.12-.11-.18-.16.26.24.53.46.83.65-.13-.08-.25-.17-.37-.26l.54-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m6.51,17.62c.17-1.68,1.04-3.16,2.29-4.12h0s.65-1.18.65-1.18c-.03.01-.05.03-.08.04-.27.15-.53.32-.77.5-.15.11-.3.23-.44.35l-2.74,4.94h0c0,.43.03.84.1,1.25l.99-1.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.47,12.51s-.04-.01-.06-.02c-.02,0-.05-.01-.07-.02.03,0,.05.01.07.02.02,0,.04.01.06.02.03,0,.05.01.07.02.02,0,.04.01.06.02h0s0,0,0,0c.02,0,.05.01.07.02h0s.04.01.06.02c.03,0,.05.02.08.03.02,0,.03.01.05.02.03.01.06.02.08.03.01,0,.03.01.04.02-.01,0-.03-.01-.04-.02-.02,0-.05-.02-.07-.03l.54-.98c.07.03.14.06.2.08-.18-.08-.36-.14-.54-.2l-.55.99s-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.34,21.03s.02-.03.03-.04c0,.01-.02.03-.03.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 16.99,
    y: 19.74,
    width: 0,
    height: 0,
    transform: "translate(-7.37 28.97) rotate(-70.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.77,21.77s.02.02.03.03h0s-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 17.18,
    y: 19.13,
    width: 0,
    height: 0,
    transform: "translate(-5.47 31.3) rotate(-76.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.11,15.99s0,.02,0,.02h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m17.06,19.56v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.91,19.96s0-.02.01-.03h0s0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.83,20.14h0c-.13.3-.29.58-.47.85.18-.27.33-.55.47-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.6,14.89s.03.05.04.07c-.01-.02-.03-.05-.04-.07v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.11,16.07s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.09,18.49s-.02,0-.03,0c.01,0,.02,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.01,18.48s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.14,18.5h-.02s.02,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.27,18.54s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.17,18.51s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.22,18.52s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.33,18.56h-.01s.02,0,.03,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.12,16.15s0,.03,0,.05h0s0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.12,16.23s0,.05,0,.08h0s0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.94,18.48s.04,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.51,21.44s-.03-.04-.04-.06c.01.02.03.04.04.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 16.08,
    y: 21.38,
    width: 0,
    height: 0,
    transform: "translate(-10.67 20.85) rotate(-51.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 17.12,
    y: 19.34,
    width: 0,
    height: 0,
    transform: "translate(-5.99 30.86) rotate(-74.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.01,15.53s0,.03.01.04h0s0-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.98,15.46s0,.02,0,.03h0s0-.01-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m17.01,15.76h0s0,0,0,0h0s0,0,0,0v-.02s-.02-.04-.03-.06v-.02s.01.05.02.08c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.95,15.39v.02s.01.01.01.01c0,0,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.08 15.8 14.08 15.81 14.08 15.79 14.08 15.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.07 15.76 14.07 15.76 14.07 15.77 14.07 15.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.78,15.24s.04.08.06.12c-.02-.04-.04-.08-.06-.12,0-.01-.01-.03-.02-.04h0s.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.92,15.32h0s0,.02,0,.02c0,0,0-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.91,15.52s-.01-.03-.02-.04c0,0,0-.02-.01-.02,0,.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m16.25,14.38h.01s.01.03.02.04c0,0-.01-.02-.02-.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.06,15.71v.02s0-.03,0-.04c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.15,22.98c.12-.06.23-.12.34-.19-.11.07-.23.13-.34.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m15.09,22.38c-.16.13-.33.25-.51.36.18-.11.35-.23.51-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "15.34 22.17 15.35 22.16 15.34 22.17 15.34 22.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m15.18,22.31h0s-.06.05-.09.07c.03-.02.06-.05.09-.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 15.65,
    y: 21.87,
    width: 0.01,
    height: 0,
    transform: "translate(-10.9 17.61) rotate(-45.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.09 15.88 14.09 15.88 14.09 15.88 14.09 15.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "15.21 13.34 15.21 13.34 15.19 13.33 15.21 13.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.91 15.3 13.91 15.3 13.91 15.3 13.91 15.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.1 15.91 14.1 15.93 14.1 15.93 14.1 15.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.89 15.25 13.89 15.26 13.9 15.27 13.89 15.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "11.81 18.48 11.81 18.48 11.83 18.48 11.81 18.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.09 15.83 14.09 15.85 14.09 15.85 14.09 15.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.02,20.13s.02.03.03.05c-.01-.02-.02-.04-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.49,18.41s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.8,20.09s0,.03.01.04c0,.01,0,.02.01.03v-.02s-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.87,19.61s0-.05,0-.07c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 6.5,
    y: 18.75,
    width: 0.02,
    height: 0,
    transform: "translate(-2.7 1.17) rotate(-8.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.06,20.19s.01.02.02.03v.02s0-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.37,20.47s.03.02.04.02h.01s-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.15,20.3s.02.02.02.03h.01s-.03-.01-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.1,20.24s.03.03.04.05c-.01-.02-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.2,20.34s.03.03.05.04h0s-.03-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.33,20.44s.03.02.04.02c-.02-.01-.04-.02-.05-.03h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.26,20.39s.03.02.05.03c-.02-.01-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.75,19.93h0s0,0,0,0c0,.03.02.06.03.09v.02s-.01-.06-.02-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.86,20.23s0-.02-.01-.03h0s0,.02.01.03c0,.01,0,.02.01.03h0s0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "7.37 21.23 7.38 21.24 7.37 21.23 7.37 21.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "7.2 20.95 7.2 20.95 7.2 20.95 7.2 20.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.29,21.1s.01.02.02.04c0,0-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "7.33 21.17 7.34 21.18 7.33 21.18 7.33 21.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.21,20.97s.03.04.04.07c-.01-.02-.02-.03-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.18,20.91s-.01-.02-.02-.03c0-.02-.02-.03-.03-.05.02.03.03.06.05.1h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.89,20.3h0s0,.02.01.03v.02s.01,0,.01,0c0,0,0-.02-.01-.03,0,0,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.93,20.42s0,.02.01.03h0s0,.02,0,.02c0-.02-.01-.03-.02-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m6.99,20.55h0s0,.01,0,.01v.02s0,0,0,0c0,0,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.11,20.79s.01.03.02.04h0s0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 10.04,
    y: 23.31,
    width: 0,
    height: 0,
    transform: "translate(-15.26 25.39) rotate(-71.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 7.9,
    y: 21.9,
    width: 0,
    height: 0.03,
    transform: "translate(-12.71 11.05) rotate(-42.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 10.24,
    y: 23.38,
    width: 0,
    height: 0,
    transform: "translate(-15.03 26.94) rotate(-74.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "11.5 18.43 11.48 18.43 11.51 18.43 11.5 18.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "10.85 23.51 10.87 23.52 10.87 23.52 10.85 23.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.39,18.4s-.02,0-.03,0c.01,0,.03,0,.04.01h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 10.45,
    y: 23.42,
    width: 0,
    height: 0.02,
    transform: "translate(-14.82 27.88) rotate(-75.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 8.6,
    y: 22.55,
    width: 0,
    height: 0,
    transform: "translate(-14.62 15.96) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "11.72 18.47 11.71 18.47 11.72 18.47 11.72 18.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.6,18.45h-.02s.02,0,.03,0h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "9.85 23.24 9.86 23.25 9.86 23.25 9.85 23.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 9.11,
    y: 22.88,
    width: 0,
    height: 0.02,
    transform: "translate(-15.25 19.19) rotate(-59.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.89,19.78s0,.04.01.06c0-.02,0-.04-.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.93,19.93v.02s.02.02.02.03c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.91,19.85h0s.01.04.02.06c0-.02-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.99,20.06s.02.03.03.05c0-.02-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.95,19.99s.02.04.03.06c0-.02-.02-.04-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.88,15.23h0s0,0-.01-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.2,18.34h0s-.03-.01-.04-.02c.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.88,19.7s0,.04,0,.05h0s0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 11.29,
    y: 23.56,
    width: 0,
    height: 0.02,
    transform: "translate(-13.07 33.03) rotate(-85.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.3,18.38h-.01s-.02-.01-.03-.01h0s.03,0,.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m10.88,19.69s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "8.24 22.26 8.26 22.28 8.26 22.28 8.24 22.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m7.44,21.33v-.02s-.03-.03-.04-.04c.01.02.03.04.04.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.32,17.89s.02.02.04.03c-.02-.02-.03-.03-.05-.05h0s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.37,17.94s.04.04.06.06c-.02-.02-.04-.04-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.55,18.14h0s-.03-.03-.05-.05c.01.02.03.03.04.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.6,18.22v.02s-.02-.05-.04-.07c.01.01.02.03.03.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.78,18.52s.02.04.03.06c0-.02-.02-.04-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.82,18.61s.02.06.03.09c-.01-.03-.02-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.45,18.02s.03.04.05.05c-.02-.02-.03-.04-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.73,18.42s.03.05.04.08c-.01-.03-.03-.05-.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.73,15s.02.03.03.04c0-.01-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.24 17.82 13.22 17.81 13.23 17.82 13.24 17.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.25,15.28s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.81,15.1h0s-.02-.03-.03-.04c0,.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.17,17.77s-.02-.01-.03-.02h.02s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.21,17.8s-.03-.02-.04-.03h.01s.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.86,18.71s.02.05.03.08c0-.03-.02-.05-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.3,15.29s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.28,17.86s-.03-.02-.04-.03h.01s.02.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.36,15.3s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.95,19.05s0,.02,0,.03c0-.02,0-.05-.01-.07,0,.01,0,.03,0,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.7,18.37s.02.03.03.05c-.01-.03-.03-.05-.04-.08,0,0,0,.02.01.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.05,15.66s0-.03-.01-.05c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.01,16.32s0,.04,0,.07h0s0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.39,14.62s.03.02.04.03c-.01-.01-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.84,15.16h0s-.02-.02-.02-.03c0,.01.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.85 15.19 13.85 15.19 13.86 15.2 13.85 15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.26,14.53s.03.02.04.03c-.01,0-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.03,14.38s.02.01.03.02h0s.02.02.03.02c-.02-.01-.05-.03-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.96,19.82c0,.05-.02.11-.03.16.01-.05.02-.11.03-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.96,19.12s0,.05.01.08c0-.03,0-.05-.01-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.98,19.21s0,.06,0,.1c0-.03,0-.06,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.92,18.9s.01.06.02.09c0-.03-.01-.06-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.46,15.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.66,18.29v.02s-.01-.04-.02-.06c0,0,.01.02.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.89,18.81s.01.05.02.07c0-.02-.01-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.98,19.33s0,.05,0,.08c0-.03,0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.99,19.44s0,.07,0,.1c0-.03,0-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.11,17.73h0s-.04-.02-.06-.03h.01s.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.01,16.45v.02s0,0,0,0c0-.02,0-.03,0-.05,0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.32,17.11s-.03-.03-.04-.04c.01.01.03.03.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.51,14.73s.02.02.03.03h0s-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.28,17.07s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m8.2,22.21s.03.03.05.05c-.02-.01-.03-.03-.05-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.37,17.15h0s-.03-.02-.04-.03c.01.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.23,17.01s-.02-.03-.03-.04c.01.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.64,14.88h0s.02.03.02.03c0-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 11.43,
    y: 17.2,
    width: 0,
    height: 0,
    transform: "translate(-9.21 16.58) rotate(-54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.1,16.79h0s0,.02,0,.02c0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.19,16.95s-.02-.04-.03-.05c.01.02.02.04.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.08,16.75s0-.02-.01-.03c0,.01,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.58 14.81 13.59 14.81 13.58 14.81 13.58 14.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.05,16.66h0s0,.02,0,.02c0-.01,0-.02,0-.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.59,14.82h0s.02.03.02.03c0,0-.02-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m8.43,22.41h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.54 14.76 13.54 14.77 13.56 14.79 13.54 14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.13,16.86h0s.01.02.02.03c0-.01-.01-.03-.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.02,16.53h0s0,0,0,0c0-.01,0-.03,0-.04,0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "12.97 17.63 12.95 17.63 12.96 17.63 12.97 17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.2,14.48s.03.02.04.03c-.01,0-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.49 14.71 13.49 14.71 13.5 14.73 13.49 14.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.33,14.57s.03.02.04.03c-.01-.01-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.2,15.27s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.07,15.26s.04,0,.05,0c-.02,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.14,15.26s.02,0,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.04,17.68h0s-.05-.03-.08-.04c.01,0,.02.01.03.02.01,0,.02.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.15,23.56h0c-.15.01-.31.02-.47.02-.06,0-.12,0-.18,0,.06,0,.12,0,.18,0,.16,0,.31,0,.47-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m8.31,22.32h0s.04.04.07.06c-.02-.02-.04-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.69,14.93h0s.02.03.02.04c0-.01-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m11.03,16.59h0s0,.02,0,.02c0-.01,0-.02,0-.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.12,14.43h.01s0,0,0,0c.01,0,.02.01.04.02-.02-.01-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.64 14.87 13.64 14.87 13.63 14.87 13.64 14.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m12.94,17.62s-.03-.02-.05-.03c0,0,.02,0,.03.01h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m13.48,14.71h0s-.02-.02-.04-.03c.01,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m14.71,13.02h-.02c-.59-.24-1.23-.37-1.9-.37-3,0-5.53,2.52-5.66,5.62,0,.19,0,.38,0,.57-.01,0-.03-.02-.05-.02.02,0,.03.02.05.02,0,.17.03.34.05.5,0,.02,0,.04,0,.06.06.36.15.72.27,1.05.82.49,1.81.78,2.89.78.06,0,.11,0,.17,0,0,0-.02-.02-.03-.02-.01,0-.02-.02-.03-.03,0,0-.02-.01-.02-.02-.01-.01-.02-.02-.03-.03h-.01s-.06-.07-.08-.1h0s-.02-.04-.04-.05v-.02s-.04-.03-.05-.04v-.02s-.04-.03-.05-.04v-.02s-.03-.03-.04-.05h0c-.06-.11-.12-.22-.16-.33h0s-.02-.05-.02-.07h0s-.02-.05-.02-.07h0c-.04-.12-.07-.25-.09-.37h0c-.02-.13-.02-.26-.02-.4h1.07l.13.06c-.02.4.19.75.5.93h0c.11.04.22.07.35.07s.24-.02.35-.06c.05-.02.09-.04.14-.06.03-.02.06-.03.09-.05.1-.07.18-.15.26-.24.02-.03.04-.06.06-.08.05-.09.1-.18.13-.28.02-.07.03-.14.04-.21,0-.02,0-.04,0-.05,0-.16-.02-.32-.08-.46-.01-.03-.03-.06-.04-.09-.09-.16-.21-.29-.37-.38-.11-.04-.23-.07-.35-.07-.31,0-.6-.07-.86-.19l-.13-.06h.02s-.02,0-.03,0h0s-.04-.02-.06-.03h0c-.21-.11-.39-.26-.55-.44h-.01c-.06-.08-.11-.15-.16-.22h0s-.04-.07-.06-.11v-.02s-.05-.07-.07-.11h0s-.04-.08-.05-.12v-.02s-.03-.07-.05-.1c0,0,0-.02,0-.02-.08-.24-.12-.5-.11-.77.04-.98.71-1.8,1.58-2.07.02,0,.05-.01.07-.02v-.12s.03-.52.03-.52h1.05l.13.06-.03.62c.08.03.16.06.23.1h0s.01.01.01.01c-.02,0-.03-.02-.05-.02l.13.06c.71.34,1.18,1.09,1.15,1.96h-1.07l-.13-.06h0s0-.05,0-.08v-.02s0-.05,0-.07h0s0-.06-.01-.08h0s-.01-.06-.02-.08h0c-.01-.06-.03-.11-.05-.15h0s-.02-.05-.03-.08h0s-.02-.05-.04-.07h0s-.03-.04-.04-.06h0s-.07-.08-.1-.12h0c-.05-.05-.11-.09-.18-.13-.11-.04-.23-.07-.35-.07-.56,0-1.04.47-1.06,1.06-.02.4.18.75.49.93h.02s0,.01,0,.01c.05.02.1.03.15.04h.01s.05,0,.07.01h.01s.05,0,.08,0c.03,0,.07,0,.1,0,.01,0,.02,0,.03,0,.02,0,.04,0,.07,0,.01,0,.03,0,.04,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.04,0,.06.01.01,0,.03,0,.04,0,.02,0,.04,0,.05.01.01,0,.03,0,.04.01.02,0,.04.01.05.02.01,0,.03,0,.04.01.02,0,.04.01.05.02.01,0,.02,0,.04.01.02,0,.04.02.06.03.02,0,.04.02.06.02.01,0,.03.01.04.02h-.02s.13.05.13.05c.71.34,1.18,1.1,1.15,1.97,0,.12-.02.23-.04.34,1.13-.9,1.88-2.2,1.94-3.64.03-.68-.09-1.33-.34-1.92h0s0-.03,0-.03c-.02-.04-.04-.08-.06-.12,0-.01,0-.02-.01-.03,0-.01-.01-.02-.02-.03-.02-.04-.04-.07-.06-.11h0c-.02-.05-.05-.1-.07-.14,0-.01-.01-.02-.02-.04-.03-.04-.05-.09-.08-.13h0s-.06-.09-.08-.14c0-.01-.02-.02-.02-.03-.03-.04-.05-.08-.08-.11v-.02s-.07-.08-.11-.12c0-.01-.02-.02-.02-.03-.03-.03-.06-.07-.08-.1l-.02-.02s-.03-.04-.05-.05h.01s.09.06.13.09c-.02-.01-.04-.03-.06-.04-.02-.02-.05-.03-.07-.05-.01,0-.02-.02-.04-.02h-.02s-.08-.06-.12-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m15.76,13.81s.02.02.03.03c.03.03.07.07.1.1,0,0,.02.02.03.03,0,0-.02-.02-.03-.03-.03-.03-.06-.07-.1-.1,0,0-.02-.02-.03-.03-.02-.02-.04-.04-.06-.05h0s.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.47,21.37h0s.03.05.04.06h0s0,.01,0,.01c-.02-.03-.04-.05-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m13.24,21.12c.06-.06.13-.12.18-.19-.06.07-.12.13-.18.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m12.65,21.51h0c-.05.02-.1.04-.16.06h0c.14-.05.27-.11.4-.19-.08.05-.16.09-.24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.77,21.77s.02.02.03.03h0s-.03-.03-.04-.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "11.03 21.53 11.02 21.53 11.04 21.54 11.03 21.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "12.32 21.97 12.33 21.63 12.34 21.62 12.33 21.63 12.32 21.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.89,21.91l.02.02h0s-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.25,21.05s-.02-.04-.04-.06c0,.02.02.03.03.05v.02s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.29,21.11s.01.02.02.03c0,0,.01.02.02.03h0s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m12.42,21.6h0s.05-.02.08-.03h0s-.05.02-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m8.31,22.32s.04.04.07.06c-.02-.02-.04-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.66,21.63h0s.02.03.03.04c-.01-.02-.03-.03-.04-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m6.83,20.16h0s0,0-.01-.02v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "6.93 20.42 6.93 20.42 6.94 20.42 6.93 20.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.67,23.17h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m6.87,20.26h0s0,.03.01.04h0s-.01-.02-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m12.31,22.24v-.12s0,.12,0,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "7.01 20.58 7.01 20.59 7.01 20.58 7.01 20.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.18,20.92h0s0,.03,0,.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.37,21.23h0s.01.03.02.04c0,.01.02.03.03.04-.02-.03-.04-.06-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m11.29,21.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "11.1 21.57 11.1 21.56 11.12 21.57 11.1 21.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "8.6 22.55 8.6 22.56 8.61 22.56 8.59 22.54 8.6 22.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m13.18,21.18c-.07.06-.14.11-.21.16.07-.05.14-.1.21-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.28 22.99 9.29 22.99 9.29 22.99 9.28 22.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "6.76 19.95 6.75 19.93 6.75 19.93 6.76 19.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m8.26,22.27s-.04-.04-.07-.06c.02.01.03.03.05.04l.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m12.15,23.56h0c.71-.06,1.38-.26,2-.58.12-.06.23-.12.34-.19.03-.02.06-.04.09-.05.18-.11.35-.23.51-.36.03-.02.06-.05.09-.07.05-.04.11-.09.16-.13h.01c.1-.1.2-.2.3-.3h0c.15-.16.29-.32.42-.49h0c.09-.12.17-.23.25-.35,0-.01.02-.03.03-.04.18-.27.33-.55.47-.85.03-.06.05-.12.08-.18,0-.01,0-.02.01-.03.02-.06.05-.12.07-.18h0c.02-.07.04-.13.06-.19v-.02c.03-.06.05-.13.07-.2h0c.02-.07.04-.14.05-.21h0c.05-.22.09-.43.12-.65.02-.17.04-.35.05-.53,0-.1,0-.19,0-.29,0-.14,0-.28-.02-.42h0c0-.06-.01-.12-.02-.18,0-.01,0-.02,0-.03,0-.05-.01-.1-.02-.15,0-.01,0-.02,0-.03,0-.06-.02-.12-.03-.18h0c0-.06-.02-.12-.03-.17,0-.01,0-.03,0-.04-.01-.05-.02-.09-.03-.14,0,0,0-.02,0-.03-.01-.05-.03-.11-.04-.16,0-.01,0-.02-.01-.04-.01-.04-.03-.09-.04-.13,0-.01,0-.03-.01-.04-.02-.05-.04-.11-.05-.16h0s0,0,0,0h0s0-.02,0-.03c0-.03-.02-.05-.03-.08,0-.02-.02-.04-.02-.06,0-.01,0-.02-.01-.03,0-.01-.01-.03-.02-.04,0-.02-.02-.04-.03-.06,0-.02-.02-.04-.03-.06h0s0-.03-.01-.04c-.02-.04-.04-.08-.06-.12,0-.01-.01-.03-.02-.04-.03-.05-.05-.1-.08-.15h0s-.03-.06-.04-.08c-.01-.02-.03-.05-.04-.07v-.02s-.02-.02-.02-.02h0s-.05-.09-.08-.13h0s-.01-.02-.01-.02v-.02s-.07-.08-.09-.12c0-.01-.02-.02-.02-.04v-.02s-.06-.06-.08-.1c0,0-.01-.02-.02-.02h-.01s-.01-.03-.02-.04c-.02-.03-.05-.06-.07-.09,0,0-.02-.02-.02-.03h0s-.04-.04-.05-.07c-.01-.01-.02-.03-.04-.04h0s-.02-.02-.02-.03c-.03-.04-.07-.08-.1-.11h-.01s-.02-.03-.03-.04c-.03-.03-.06-.07-.1-.1,0,0-.02-.02-.03-.03-.02-.02-.04-.04-.06-.06-.02-.02-.04-.04-.06-.06h0s-.02-.02-.02-.02c-.03-.03-.07-.06-.11-.09-.01,0-.02-.02-.03-.03-.04-.04-.09-.07-.13-.11h-.02s0-.01,0-.01c-.04-.03-.08-.06-.12-.09h-.02s-.02-.03-.02-.03c-.05-.03-.09-.07-.14-.1h0s-.09-.06-.13-.09h-.01s.03.03.05.05l.02.02s.06.07.08.1c0,.01.02.02.02.03.03.04.06.08.09.12v.02s.06.08.09.11c0,.01.02.02.02.03.03.04.06.09.08.13h0s.05.09.08.13c0,.01.01.02.02.04.02.04.05.08.07.13h0s.04.08.06.12c0,.01.01.02.02.03,0,.01,0,.02.01.03.02.04.04.08.06.12v.02s.01,0,.01,0c.25.59.37,1.24.34,1.92-.07,1.44-.81,2.74-1.94,3.64-.17.85-.81,1.53-1.61,1.75l-.03.64h-1.05l-.13-.06h0l.03-.62c-.07-.02-.14-.05-.21-.08l-.13-.06h0s0,0,0,0c-.01,0-.03-.01-.04-.02,0,0-.02,0-.03-.01-.02,0-.03-.02-.05-.03h-.02s-.04-.04-.07-.05c0,0-.02-.01-.03-.02-.01,0-.03-.02-.04-.03-.01,0-.02-.01-.03-.02-.01,0-.02-.02-.03-.02-.01,0-.02-.02-.03-.02-.01,0-.02-.02-.03-.02-.01,0-.02-.02-.03-.03h0c-.06,0-.11,0-.17,0-1.08,0-2.07-.29-2.89-.78.43,1.18,1.26,2.16,2.32,2.77.02,0,.04.02.06.02h.01c.06.03.12.05.18.07h0c.06.02.13.04.2.06h0c.06.02.13.04.19.05h.02c.13.04.26.06.4.08h.02c.13.02.27.04.41.05h.02c.07,0,.14.01.21.01.06,0,.12,0,.18,0,.16,0,.31,0,.47-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m8.94,22.79h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.13,20.83h0s0,0,0,0h0s.02.04.03.06c-.01-.02-.02-.04-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m7.44,21.34h0s.01.02.02.03c0-.01-.02-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m13.9,20.08c-.02.08-.05.16-.08.23.03-.07.06-.15.08-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m13.79,20.36s-.04.09-.07.14c.02-.04.04-.09.07-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m13.66,20.62c-.05.09-.11.17-.17.25.06-.08.12-.16.17-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.1,22.88h.02s0,.01,0,.01c0,0-.02-.01-.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m8.04,22.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m8.44,22.43h.01s-.02,0-.03-.01h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "11.18 21.59 11.18 21.59 11.2 21.6 11.18 21.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m15.5,12.15l-.64-.31h.02s0,0,0,0c.03.01.05.03.08.04.03.01.05.03.08.04.02,0,.03.02.05.02.06.03.12.06.18.1h.01c.06.04.11.07.16.1.01,0,.03.02.04.03.02.01.04.02.05.03.04.02.07.05.11.07h0c.06.04.11.08.16.12.01.01.03.02.04.03.05.04.09.07.14.11l.02.02c.05.04.1.08.15.13.01.01.03.02.04.03.02.02.04.04.06.06.02.02.04.04.06.06h0s.02.03.02.03c.05.05.1.09.14.14.01.01.02.02.03.03.04.04.08.08.12.12.01.01.02.02.03.03.05.05.09.1.13.15,0,.01.02.02.03.03.03.04.06.07.09.11l.02.02h0s.02.03.03.04c.02.02.04.05.06.07.02.03.04.06.07.08,0,0,.01.02.02.03.03.05.07.09.1.14,0,.01.02.03.03.04.04.06.08.11.11.17v.02s.03.02.03.02c.03.04.05.09.08.13,0,.02.02.03.03.05.03.06.07.12.1.18h0s.04.09.06.13c0,.02.02.04.03.06,0,.02.02.03.02.05.03.06.06.11.08.17v.02c.04.06.06.13.09.19,0,.02.01.03.02.05.02.06.04.11.07.17,0,0,0,.02.01.03.02.06.05.13.07.2,0,.02.01.03.02.05.02.06.04.11.05.17v.02s.01.02.01.02h0c.02.07.04.13.05.2,0,.02,0,.03.01.05.01.06.03.11.04.17,0,.02,0,.03.01.05.01.07.03.14.04.21,0,.01,0,.03,0,.04.01.06.02.12.03.18,0,.02,0,.03,0,.05v.02c.01.06.02.13.03.19,0,.01,0,.02,0,.04,0,.02,0,.04,0,.06,0,.04,0,.08.01.12,0,.02,0,.04,0,.06,0,.07,0,.15.01.22v.02c0,.07,0,.13,0,.2,0,.02,0,.04,0,.06,0,.08,0,.15,0,.23-.11,2.61-1.64,4.88-3.79,5.99h-.01s-.09.05-.14.08h0c-.54.27-1.12.45-1.73.56h-.02c-.06.01-.13.02-.19.03h-.01c-.07.01-.14.02-.21.03h0c-.06,0-.12.01-.19.02-.02,0-.04,0-.05,0-.05,0-.1,0-.15,0-.02,0-.04,0-.06,0-.07,0-.13,0-.2,0-.06,0-.12,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.05,0-.07,0-.03,0-.07,0-.1,0-.02,0-.05,0-.07,0-.03,0-.06,0-.1,0-.01,0-.03,0-.04,0-.01,0-.02,0-.04,0-.03,0-.06,0-.09-.01-.02,0-.05,0-.07-.01-.03,0-.06,0-.09-.01-.02,0-.05,0-.07-.01-.03,0-.06-.01-.09-.02-.02,0-.05,0-.07-.01-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0,0,0-.02,0-.02,0-.02,0-.03,0-.05-.01-.03,0-.06-.01-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02-.02,0-.03,0-.05-.01-.01,0-.03,0-.04-.01-.02,0-.05-.01-.07-.02h-.02s-.05-.02-.07-.03c-.02,0-.04-.01-.06-.02-.03-.01-.06-.02-.1-.04-.02,0-.04-.01-.06-.02-.04-.01-.08-.03-.11-.05-.01,0-.02,0-.04-.01-.05-.02-.1-.04-.15-.06-.01,0-.03-.01-.04-.02-.02,0-.04-.02-.05-.03-.02,0-.04-.02-.05-.03h0s.64.31.64.31c.8.39,1.7.6,2.66.6,3.58,0,6.61-3.01,6.76-6.72.11-2.72-1.35-5.06-3.55-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m7.47,20.45c-.12-.33-.21-.69-.27-1.05,0-.02,0-.04,0-.06-.02-.17-.04-.33-.05-.5-.02,0-.03-.02-.05-.02.02,0,.03.02.05.02-.01-.19-.01-.38,0-.57.13-3.11,2.66-5.62,5.66-5.62.67,0,1.31.13,1.9.36-.04-.02-.09-.05-.13-.07-.01,0-.03-.01-.04-.02-.04-.02-.09-.05-.13-.07h-.02s-.05-.04-.08-.05c-.01,0-.03-.01-.04-.02-.02-.01-.05-.02-.07-.03h0s-.03-.02-.05-.02h-.02s-.07-.04-.11-.05c-.02,0-.03-.01-.05-.02-.03,0-.05-.02-.08-.03-.02,0-.04-.01-.05-.02-.03,0-.05-.02-.08-.03-.02,0-.04-.01-.06-.02h0s-.05-.02-.07-.02h0s-.04-.01-.06-.02c-.02,0-.05-.01-.07-.02-.02,0-.04-.01-.06-.02-.02,0-.05-.01-.07-.02-.02,0-.04,0-.06-.01h0s0,0,0,0c-.02,0-.04,0-.06-.01-.02,0-.04,0-.06-.01-.02,0-.05,0-.07-.01h0s-.04,0-.06-.01c-.03,0-.05,0-.08-.01-.02,0-.04,0-.06,0-.01,0-.03,0-.05,0-.01,0-.02,0-.03,0-.02,0-.04,0-.06,0-.03,0-.05,0-.08,0h0s-.04,0-.06,0h0s0,0,0,0c-.02,0-.04,0-.06,0h-.01s0,0,0,0c-.02,0-.04,0-.06,0-.03,0-.06,0-.09,0-.02,0-.04,0-.05,0-.02,0-.04,0-.07,0-.02,0-.04,0-.06,0h-.02c-.12,0-.24,0-.37.01-.28.02-.55.06-.81.12h0c-.13.03-.26.06-.39.1h0c-.13.04-.26.08-.38.13h0c-.12.05-.25.1-.37.16h0c-.12.06-.24.12-.36.19h0c-.12.07-.23.14-.34.21h0c-.11.07-.22.15-.33.23-1.25.96-2.12,2.44-2.29,4.12,0,.05,0,.11-.01.16h0c0,.07,0,.12,0,.18h0s0,.1,0,.14c0,.02,0,.03,0,.05,0,.03,0,.07,0,.1,0,.01,0,.03,0,.04h0s0,.01,0,.01c0,.01,0,.03,0,.04,0,.01,0,.03,0,.04v.02s0,0,0,0c0,.01,0,.02,0,.03h0s0,.03,0,.04c0,.04,0,.08,0,.11h0s0,.02,0,.02c0,.01,0,.03,0,.04,0,.01,0,.03,0,.04h0s0,0,0,0h0s0,.02,0,.02h0s0,.02,0,.02h0s0,.03,0,.04c0,.02,0,.04,0,.05,0,.03,0,.05,0,.08,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.06.02.11.03.17,0,.01,0,.02,0,.04,0,.04.01.07.02.1,0,.02,0,.04.01.05,0,.03.01.06.02.09h0s0,.01,0,.01v.02s.03.1.04.15h0s0,.02.01.04c.01.05.03.1.04.15h0s0,.02,0,.03h0s0,.01,0,.01h0s.02.07.03.1c0,.02.01.03.02.05h0s0,0,0,0c0,.02.01.04.02.05,0,0,0,.02.01.03,0,.01,0,.02.01.04,0,0,0,.02.01.03,0,0,0,.02.01.03,0,.01.01.03.02.04,0,0,0,.02.01.03,0,0,0,.02.01.03,0,.02.02.04.03.06h0s.01.04.02.05c.01.03.02.05.04.08,0,0,0,.02.01.03h0c.03.07.06.13.09.2h0s0,0,0,0h0s0,.03.01.04h0s.02.05.03.07c0,0,.01.02.02.03h0s.01.03.02.04h0s0,.01,0,.01h0s0,.03,0,.03c.01.02.02.04.04.06h0s.01.03.02.04v.02s.02,0,.02,0c.01.02.03.04.04.06h0s.01.02.02.04h0s0,.01,0,.01h0s.04.06.06.09v.02s.01,0,.01,0c0,.01.02.02.02.03h0s0,0,0,0c.02.03.04.05.05.08.04.06.08.11.13.17.01.02.03.03.04.05.02.03.05.06.07.09.01.02.03.03.04.05.03.03.06.06.09.1,0,.01.02.02.03.03.04.04.08.08.12.12h0s.09.09.13.13h0s0,0,0,0l.02.02h0s.04.04.07.06h0s.02.02.02.02c0,0,.02.02.03.02h0s.04.04.07.06h.02s.02.03.03.04h0s.02.02.03.02c.04.04.09.07.13.11l.02.02c.05.04.1.07.15.11h0c.05.04.11.08.16.11h.01c.05.04.1.07.15.1,0,0,.02.01.03.02.05.03.1.06.16.09h0s0,0,0,0c.12.06.24.12.36.17h.02s.08.04.12.05c-1.06-.61-1.88-1.58-2.32-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m12.64,14.23s.09.03.13.04l.03-.62-.13-.06-.03.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m12.32,18.56h-.02s-.02-.02-.03-.02h-.02s-.02-.01-.03-.02h-.02s-.02-.01-.03-.01h-.02s-.02,0-.03-.01h-.02s-.02,0-.03,0h-.02s-.02,0-.03,0h-.02s-.03,0-.05,0h0s-.06,0-.1,0h-.02s-.02,0-.02,0c-.02,0-.04,0-.07,0,0,0-.02,0-.03,0h0s-.05,0-.08-.01h-.02s-.02,0-.03,0c-.01,0-.03,0-.04,0-.01,0-.02,0-.03,0h-.02s-.02-.01-.03-.01c-.02,0-.03,0-.05-.01-.01,0-.03,0-.04-.01h-.02s-.03-.02-.04-.02c-.01,0-.03-.01-.04-.02-.02,0-.03-.01-.05-.02h0s-.03-.01-.04-.02c-.02,0-.04-.02-.05-.02h-.02s.13.05.13.05c.26.12.55.19.86.19.13,0,.24.02.35.07-.02-.01-.05-.03-.08-.04,0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m10.87,19.63s0,.04,0,.06h0s0,.05,0,.07v.02s.01.04.02.06h0s.01.05.02.07v.02s.02.03.02.05h0s.02.05.03.07h0s.02.04.03.06h0s.02.05.03.07h0s.02.04.03.05h0s.03.04.04.06h0s.03.03.04.05h.01s.03.04.05.05h0s.03.03.05.04h.01s.04.03.05.04h0s.04.02.06.03c.02.01.05.02.07.03-.31-.18-.51-.53-.5-.93l-.13-.06s0,.05,0,.07v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m11.29,21.63s-.05-.01-.08-.02h0s-.02,0-.02,0c-.02,0-.03-.01-.05-.02h-.01s-.02-.01-.02-.01c-.01,0-.03-.01-.04-.02h-.02s-.02-.02-.02-.02c-.01,0-.03-.01-.04-.02,0,0-.02,0-.03-.01h0s.13.06.13.06c.07.03.14.06.21.08v-.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m13.1,14.42h.02s.03.03.05.04c0,0,.02.01.02.02.01,0,.03.02.04.03,0,0,.02.01.03.02.01,0,.03.02.04.03,0,0,.02.01.03.02.01.01.03.02.04.03l.02.02s.03.02.04.03l.02.02s.02.02.04.03h0s.02.02.02.02h0s.02.02.03.04h0s.02.03.02.03l.02.02h0s0,.01,0,.01c0,0,.02.02.02.03l.02.02h0s0,0,0,0c0,.01.02.02.03.03l.02.02h0s.02.03.03.04c0,0,.01.02.02.03,0,.01.02.03.03.04,0,0,.01.02.02.02,0,.02.02.03.03.05h0s0,.02,0,.02c0,.01.02.03.02.04h0s0,.03,0,.03h0s0,.03.01.04h0s0,.03,0,.03c0,0,0,.02.01.03h0s0,.02,0,.02c0,0,0,.02.01.02,0,0,0,.02.01.03v.02s.02.02.02.03c0,0,0,.02.01.03h0s0,.04.01.05c0,0,0,.02,0,.03h0s0,.04.01.05c0,0,0,.02,0,.02h0s0,.04.01.05c0,0,0,.02,0,.02h0s0,.04.01.05c0,0,0,.02,0,.03h0s0,.03,0,.03v.02s0,.02,0,.03v.02s0,.02,0,.03h0s0,.02,0,.03v.02s0,.02,0,.03c0,0,0,.02,0,.03,0,0,0,.02,0,.03,0,.01,0,.02,0,.03v.02s0,.02,0,.04c0,.01,0,.02,0,.03h0s0,.04,0,.06c0,0,0,.02,0,.03h0s0,.06,0,.09h-1.07l.13.06h1.07c.04-.87-.44-1.62-1.15-1.96l-.13-.06s.03.02.05.02h.02s.05.03.07.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.26,20.95s-.02-.03-.03-.04c.01.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.31,21.01s-.02-.03-.04-.04c.01.01.02.03.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.21,20.89s-.02-.03-.03-.04c.01.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.4,21.11s-.06-.06-.08-.09c.03.03.05.06.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.5,21.2s-.02-.02-.03-.03c.01,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.17,20.83s-.02-.03-.03-.05c.01.02.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.44,21.15s-.02-.02-.03-.03c.01.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.21,20.53s.09-.04.14-.06c-.04.02-.09.05-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.34,20.47s.06-.03.09-.05c-.03.02-.06.04-.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.83,19.08s-.03-.06-.04-.09c.02.03.03.06.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.93,15.33s.01.03.02.04c0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.91,20.3c-.04-.12-.07-.24-.09-.37.02.13.05.25.09.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.96,20.45s-.02-.04-.02-.06c0,.02.02.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.93,20.37s-.02-.04-.02-.07c0,.02.01.04.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.13,20.77c-.06-.1-.12-.2-.16-.31.05.11.1.22.16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.8,19.54c0,.14,0,.27.02.4l.22-.4h-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.26,18.36s-.04-.01-.05-.02c.02,0,.03.01.05.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.41,20.49s.06.03.09.04h0s-.05-.02-.07-.03h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.07,18.28s-.04-.02-.06-.03c.02.01.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.2,18.34s-.08-.03-.12-.05c0,0,.02,0,.03.01.02,0,.03.02.05.02.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.02,15.57s0,.02,0,.03c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.96,15.41s.01.03.02.04c0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.1,15.93s0,.02,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.99,15.49s0,.02.01.04c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.11,16.02s0,.02,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.12 16.31 14.12 16.32 13.05 16.32 13.05 16.32 13.05 16.32 14.12 16.32 14.12 16.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.12,16.1s0,.02,0,.03c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.03,14.38h-.02s-.01-.02-.01-.02c.02.01.04.02.06.03-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.92,17.61s-.02,0-.03-.01h-.02s.03,0,.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.65,14.88s.03.03.04.05l-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.05,16.22v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.7,18.36s0-.02-.01-.03v-.02s-.03-.02-.03-.02c.01.02.03.05.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.08,17.71h-.01s-.02-.02-.02-.02h0s.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "11.01 16.38 11.01 16.4 11.01 16.39 11.01 16.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.72,15.32h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.82,15.29h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.68,15.34h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.77,15.3h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13,17.65s-.02-.01-.03-.02h0s-.01,0-.01,0c.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.03,16.61h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.95,19.05s0-.03,0-.04v-.02s-.02-.06-.03-.09v-.02s-.02-.05-.03-.07c0,0,0-.02,0-.03,0-.03-.02-.05-.03-.08h0s-.02-.07-.03-.1v-.02s-.03-.04-.04-.06c0,0,0-.02-.01-.02-.01-.03-.03-.05-.04-.08h0s-.02-.03-.03-.05c.12.21.21.44.25.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.63,15.36h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.05,16.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.16,15.8v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.43,17.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.13,15.84v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.1,16.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.59,15.38h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.19,15.75v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.65,18.28s-.01-.02-.02-.03v-.02s-.03-.02-.03-.02c.02.02.03.04.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.21,15.71v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.6,18.21s-.02-.03-.03-.04h0s0-.02,0-.02c.02.02.03.04.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.23,17.82h0s-.01-.02-.01-.02c0,0-.02-.01-.03-.02.02.01.03.02.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.31,17.88h0s-.02-.02-.02-.02c0,0-.02-.01-.03-.02.02.01.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.55,18.14s-.03-.03-.04-.05l-.02-.02s-.03-.04-.05-.05h-.01s-.04-.06-.06-.08h-.01s-.02-.04-.04-.05c.08.08.16.16.23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.24,15.67l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.5,15.43h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.46,15.46h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.28,15.63l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.54,15.41h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.42,15.49h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.38,15.53h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.31,15.6l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.35,15.56l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.67,17.49s.02,0,.04.01c-.01,0-.02,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.83,15.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.88,15.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.73,15.51h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.92,15.76h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.09,15.94s0-.02.01-.02c0,0,0,.02-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.07,15.98s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.06,16.03s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.65,17.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.96,15.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.01,15.99h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.21,17.47s-.04-.07-.06-.11c.02.04.04.07.06.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.29,17.59s-.04-.07-.06-.1c.02.03.04.07.06.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.09,17.22s-.03-.07-.04-.1c.01.04.03.07.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.15,17.36s-.04-.08-.05-.12c.02.04.04.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.03,16.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.04,16.08s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.04,16.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.19,17.38s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.77,17.53s.04.02.06.02c-.02,0-.04-.02-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.57,17.46s.03,0,.04.01c-.01,0-.03,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.11,15.89v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.16,17.76h-.02s-.02-.03-.02-.03h0s.03.01.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.01,16.24s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.01,16.47v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.45,17.8c-.06-.07-.11-.13-.16-.21.05.07.1.14.16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.01,16.31s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.02,16.19s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.81,17.36h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.89,17.37h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.03,16.14s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.09,17.38s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.28,17.4s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.38,17.41s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.48,17.44s.03,0,.04.01c-.01,0-.03,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.02,16.53h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.42,21.6s.05-.02.07-.02c-.02,0-.05.02-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.75,21.39s-.02-.01-.03-.02c0,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.68,21.34s-.02-.01-.03-.02c.01,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.91,21.48s-.02,0-.03-.01c0,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.56,21.25s-.02-.02-.03-.03c.01,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.62,21.3s-.02-.02-.03-.02c.01,0,.02.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m12.5,21.57c.05-.02.11-.04.16-.06-.05.02-.1.04-.16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.83,21.44h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.58,17.28h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.54,18.44s-.03,0-.04,0h0s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.34,18.39s-.03-.01-.05-.02h.01s.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.45,18.42s-.04-.01-.06-.02h.01s.03.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.74,18.47s-.02,0-.03,0h0s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.63,18.46s-.02,0-.03,0h.01s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.84,18.48s-.02,0-.03,0h.01s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.9,19.84s0-.04-.01-.06v-.02s0-.01,0-.01c0,.03.01.07.02.1h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.92,19.91s-.01-.04-.02-.06c0,.03.02.07.03.1v-.02s-.01-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.19,20.33h-.01s.05.03.07.05c-.02-.01-.03-.03-.05-.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.3,20.42s-.03-.02-.05-.03h0s0,0,0,0c.03.02.05.04.08.06h-.01s-.01-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.15,20.29s-.03-.03-.04-.05h0s-.01-.03-.01-.03c.03.04.06.08.1.11,0,0-.02-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.01,20.11s-.02-.03-.03-.05h0s-.02-.05-.03-.07h0s0-.03-.01-.04c.02.06.05.12.09.18h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.13,21.58s-.02,0-.03-.01h.02s.01.01.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.06,21.55s-.02,0-.03-.01h.01s.02.01.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m11.21,21.6s-.02,0-.02,0h.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.95,21.5h0s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.43,14.66s-.03-.02-.04-.03l-.02-.02s-.03-.02-.04-.03c0,0-.02-.01-.03-.02-.01,0-.03-.02-.04-.03,0,0-.02-.01-.03-.02-.01,0-.03-.02-.04-.03,0,0-.02-.01-.02-.02-.01,0-.02-.01-.04-.02.12.08.24.16.34.26-.01,0-.02-.02-.03-.03l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.07,15.77h0s0,.02,0,.03h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.5,14.73h-.01s.03.02.04.03c0,0-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.86,15.2h0s.01.02.02.03v-.02s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.56,14.79l-.02-.02s.03.03.04.04h0s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.76,15.04s-.02-.03-.03-.04c0,0-.01-.02-.02-.03,0-.01-.02-.02-.02-.03.04.05.08.11.11.16,0-.01-.02-.03-.03-.04,0,0-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.1,14.42s-.02-.01-.03-.02c.02.01.04.02.06.03h-.01s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.09,15.85h0s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.12,16.2h0s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.62,14.85l-.02-.02s.03.03.04.04h0s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m14.05,15.68s0,.02,0,.03c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.81,15.12s.02.03.03.04c0-.01-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m13.9,15.27h0s.01.01.02.03h0s0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "12.31 22.24 12.31 22.13 12.23 22.27 11.26 22.27 11.26 22.27 12.31 22.27 12.31 22.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m7.1,20.77c-.03-.06-.06-.12-.09-.19h0s-.01-.03-.01-.03h0s0-.01,0-.01c-.01-.03-.02-.05-.04-.08h0s0-.02,0-.02c0-.01,0-.02-.01-.03h0s-.02-.04-.03-.06h0s0-.03,0-.03c0-.01,0-.02-.01-.03,0,0,0-.02-.01-.03,0-.01,0-.02-.01-.03,0-.01,0-.02-.01-.03h0s0-.02-.01-.04h0s0-.03-.01-.04c0-.01-.01-.03-.02-.05,0-.02-.01-.03-.02-.05v-.02s-.03-.08-.05-.12h0s-.03-.1-.04-.15c0-.01,0-.02-.01-.04h0s-.03-.1-.04-.15v-.02s0-.01,0-.01c0-.03-.01-.06-.02-.09,0-.02,0-.04-.01-.05,0-.03-.01-.07-.02-.1,0-.01,0-.02,0-.04-.01-.06-.02-.11-.03-.17,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.02,0-.04,0-.06,0-.03,0-.05,0-.08,0-.02,0-.04,0-.05,0-.01,0-.03,0-.04v-.02s0,0,0,0v-.02s0,0,0,0h0s0-.03,0-.05c0-.01,0-.03,0-.04,0,0,0-.02,0-.02h0s0-.08,0-.11c0-.01,0-.02,0-.04h0s0-.03,0-.04v-.02s0-.03,0-.04c0-.01,0-.03,0-.04h0s0-.04,0-.06c0-.03,0-.07,0-.1,0-.02,0-.03,0-.05,0-.05,0-.1,0-.14h0c0-.06,0-.11,0-.17h0c0-.07,0-.12.01-.17h0s-.99,1.78-.99,1.78h0s.02.09.02.13c0,.02,0,.04.01.07,0,.04.02.09.03.13,0,.01,0,.03,0,.04.02.09.04.17.06.26,0,.02.01.04.02.06.01.04.02.09.04.13,0,.02.01.04.02.06.03.09.06.18.09.27h0c.02.05.03.1.05.14,0,.02.01.04.02.06.02.04.03.08.05.12v.02c.05.08.08.17.12.25,0,.02.02.03.02.05.02.04.04.08.06.12,0,.02.02.03.03.05.04.08.09.16.13.24v.02s.05.08.08.12c0,.02.02.03.03.05.02.04.05.08.07.11h0s.61-1.1.61-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m11.11,11.66c-.58.16-1.13.37-1.65.66l-.65,1.18h0c.11-.08.22-.16.33-.23h0c.11-.07.23-.14.34-.21h0c.12-.07.23-.13.36-.19h0c.12-.06.24-.11.37-.16h0c.12-.05.25-.09.38-.13h0c.13-.04.26-.07.39-.1h0c.26-.06.54-.1.81-.12h0l.61-1.1c-.07,0-.14,0-.2,0-.05,0-.11,0-.16,0-.02,0-.04,0-.05,0-.04,0-.07,0-.11,0-.02,0-.04,0-.06,0-.03,0-.06,0-.1,0-.02,0-.05,0-.07,0-.03,0-.06,0-.09,0-.02,0-.05,0-.07,0-.03,0-.06,0-.09.01-.02,0-.05,0-.07,0-.03,0-.06,0-.09.01-.02,0-.05,0-.07.01-.03,0-.06,0-.09.01-.02,0-.05,0-.07.01-.03,0-.06.01-.08.02-.02,0-.05,0-.07.01-.03,0-.06.01-.08.02-.02,0-.05.01-.07.02-.03,0-.06.01-.08.02-.02,0-.05.01-.07.02-.03,0-.06.02-.08.02-.02,0-.05.01-.07.02-.03,0-.06.02-.09.03-.02,0-.04.01-.07.02-.03,0-.06.02-.09.03-.02,0-.04.01-.06.02-.03.01-.06.02-.09.03-.02,0-.04.01-.05.02-.04.02-.09.03-.13.05h-.02s-.18.33-.18.33c.48-.2.98-.33,1.49-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m8.17,22.19h0s-.09-.08-.13-.13h0s-.08-.08-.12-.13h0s0,0,0,0l-.02-.02h0s0,0,0,0c-.03-.03-.06-.06-.09-.1h0s0,0,0,0c0-.01-.02-.02-.03-.03h0s-.05-.07-.07-.1c0-.01-.02-.02-.03-.03h0s0-.02,0-.02c-.04-.06-.09-.11-.13-.17h0s-.58,1.03-.58,1.03c.05.06.1.12.16.18h0c.05.06.11.12.16.17h0c.05.06.11.11.17.17h0c.06.06.12.11.18.17l.55-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m12.57,12.35h0s0,0,0,0h0s.03,0,.05,0h0s.05,0,.08,0h0s.02,0,.03,0c.01,0,.02,0,.03,0h0s.02,0,.03,0c.02,0,.03,0,.05,0,.02,0,.04,0,.06,0h0s.05,0,.08.01h0s.04,0,.06.01c.03,0,.05,0,.08.01.02,0,.04,0,.06.01.02,0,.04,0,.06.01h0s0,0,0,0c.02,0,.04,0,.06.01.03,0,.05.01.07.02.02,0,.04.01.06.02.02,0,.04.01.06.02l.55-.99h0c-.07-.02-.14-.04-.21-.06-.01,0-.03,0-.04-.01-.07-.02-.14-.04-.21-.05h0c-.16-.04-.31-.07-.47-.09h0l-.58,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m17.3,18.49h0c-.03.22-.07.43-.12.64h0s0,0,0,0h0c-.02.07-.03.14-.05.2h0s0,0,0,0h0c-.02.07-.04.13-.06.2v.02c-.03.06-.05.12-.07.18h0s0,0,0,0h0c-.02.06-.05.12-.07.18h0s0,.02-.01.03c-.02.06-.05.12-.08.18l1.57-2.82s0-.06,0-.09c0-.02,0-.04,0-.06,0-.04,0-.08-.01-.12,0-.02,0-.04,0-.06,0-.01,0-.02,0-.04,0-.06-.01-.13-.02-.19v-.02s0-.03-.01-.05c0-.02,0-.03,0-.05l-1.03,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m16.34,21.03h0c-.08.12-.17.24-.25.35h0s0,0,0,0h0c-.13.17-.27.33-.42.48h0s0,0,0,0h0c-.1.1-.2.19-.3.29h-.01c-.05.06-.1.1-.16.15l-1.03,1.86c.1-.04.21-.09.31-.14h0s.09-.05.14-.07h.01c.05-.03.1-.06.15-.09l1.58-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m7.73,13.27c.23-.22.48-.42.74-.61h.02s.21-.39.21-.39h0c-.13.09-.26.18-.39.27h0c-.13.09-.25.19-.37.3h0s-.29.52-.29.52c.03-.03.06-.06.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m8.17,13.21c-.09.08-.18.16-.27.24-.33.32-.63.67-.9,1.04l-.84,1.51c-.08.19-.15.37-.22.56.01-.09.03-.18.05-.26l-.49.89h0c0,.06-.02.12-.03.18h0c0,.06-.01.12-.02.18v.02c0,.05-.01.11-.02.16,0,.01,0,.02,0,.03,0,.06,0,.12-.01.19h0c0,.06,0,.13,0,.19h0s2.74-4.94,2.74-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m9.04,24.1s.04.02.05.03c.01,0,.02.01.04.02.05.02.1.04.15.06.01,0,.02,0,.04.01.04.02.08.03.11.05.02,0,.04.01.06.02.03.01.06.02.1.04.02,0,.04.01.06.02.02,0,.05.02.07.02h.02s.05.02.07.03c.01,0,.03,0,.04.01.02,0,.03,0,.05.01.02,0,.05.01.07.02.03,0,.06.02.09.02.02,0,.05.01.07.02.03,0,.06.01.09.02.02,0,.03,0,.05.01,0,0,.02,0,.02,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04,0,.02,0,.05.01.07.01.03,0,.06.01.09.02.02,0,.05,0,.07.01.03,0,.06,0,.09.01.02,0,.05,0,.07.01.03,0,.06,0,.09.01.01,0,.02,0,.04,0l.59-1.06c-.07,0-.14,0-.21-.01h-.02s0,0,0,0c-.14-.01-.27-.03-.41-.05h-.02c-.13-.02-.27-.05-.4-.08h-.02s0,0,0,0c-.06-.02-.13-.03-.19-.05h0s0,0,0,0c-.07-.02-.13-.04-.2-.06h0s0,0,0,0h0c-.06-.02-.12-.04-.18-.07h0s-.01,0-.01,0c-.02,0-.04-.02-.06-.02-.04-.02-.08-.03-.12-.05h-.02c-.12-.06-.24-.12-.36-.18h-.01c-.05-.04-.11-.06-.16-.09h0s0,0,0,0h-.02s0,0,0,0h0c-.05-.03-.1-.06-.15-.1h-.01c-.06-.04-.11-.08-.16-.12h0c-.05-.04-.1-.08-.15-.11h0s0,0,0,0h0s-.01-.01-.01-.01c-.05-.03-.09-.07-.13-.11h-.01s-.54.97-.54.97c.12.09.24.18.37.26.02.01.04.02.05.03.03.02.07.04.1.06.05.03.1.06.15.09.02.01.04.02.06.04.04.02.08.04.12.07.02.01.04.02.06.03.06.03.12.06.18.09h0s.04.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m13.88,12.63s.05.02.07.03c.01,0,.03.01.04.02.04.01.08.03.12.05h.01s0,0,0,0c.02,0,.03.01.05.02.03.01.05.02.08.03.01,0,.03.01.04.02h0s.05.03.08.04h0s0,0,0,0h0s0,0,0,0c.04.02.09.04.13.07h0s.03.01.04.02h0s.09.05.13.07h.02s0,.01,0,.01h0s0,0,0,0c.04.02.08.05.12.07h.02s.02.03.04.04h0s.05.03.07.05c.02.01.04.03.07.04h0s.09.07.14.1c0,0,.02.01.02.02h.01s0,0,0,0h0s.08.06.12.09h0s.02.01.02.01c.04.03.09.07.13.11.01,0,.02.02.03.03.04.03.07.06.11.1l.02.02s.04.04.07.06c.02.02.04.03.06.05h0s.02.02.03.03c.03.03.07.07.1.1,0,0,.02.02.02.03h.01s.07.09.1.12h0s.02.02.02.03c.01.01.02.03.04.04.02.02.04.04.05.06h0s.01.01.01.01v.02s.06.06.08.09c.01.01.02.03.03.04l.02.02s.05.06.07.1v.02s.01,0,.01,0c0,.01.02.02.02.04.02.03.04.07.07.1l.59-1.06s-.04-.05-.06-.07c0-.01-.02-.02-.03-.03h0s-.02-.02-.02-.02c-.03-.04-.06-.07-.09-.11,0-.01-.02-.02-.03-.03-.04-.05-.09-.1-.13-.15-.01-.01-.02-.02-.03-.03-.04-.04-.08-.08-.12-.12-.01-.01-.02-.02-.03-.03-.05-.05-.1-.09-.14-.14l-.02-.02h0s-.04-.05-.06-.06c-.02-.02-.04-.04-.06-.06-.01-.01-.03-.02-.04-.03-.05-.04-.1-.09-.15-.13l-.02-.02s-.09-.07-.14-.11c-.01-.01-.03-.02-.04-.03-.05-.04-.11-.08-.16-.12h0s-.07-.05-.11-.08c-.02-.01-.04-.02-.05-.03-.01,0-.03-.02-.04-.03-.05-.03-.11-.07-.16-.1h-.01c-.06-.04-.12-.07-.18-.1-.02,0-.03-.02-.05-.02-.03-.01-.05-.03-.08-.04-.03-.01-.05-.03-.08-.04h0c-.07-.03-.13-.06-.2-.09-.01,0-.03-.01-.04-.02-.07-.03-.14-.06-.2-.08l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m16.78,15.23h0c.02.05.05.1.07.15h0s.02.05.03.08c0,0,0,.02.01.02,0,.01.01.03.02.04,0,.01.01.03.02.04,0,.01,0,.02.01.03,0,.02.02.04.02.06v.02s.02.04.03.06v.02s0,0,0,0h0s0,0,0,0h0c.02.06.04.11.05.16,0,.01,0,.03.01.04.01.04.03.08.04.13,0,.01,0,.02.01.04.02.05.03.11.04.16,0,0,0,.02,0,.03.01.05.02.09.03.14,0,.01,0,.03,0,.04.01.05.02.11.03.16h0c.01.07.02.13.03.18,0,.01,0,.02,0,.03,0,.05.01.1.02.15,0,.01,0,.02,0,.03,0,.06.01.12.02.18h0s.81-1.46.81-1.46h0s0-.02,0-.02v-.02c-.02-.06-.04-.11-.06-.17,0-.02-.01-.03-.02-.05-.02-.07-.04-.13-.07-.2,0,0,0-.02-.01-.03-.02-.06-.04-.11-.07-.17,0-.02-.01-.03-.02-.05-.03-.06-.05-.13-.08-.19v-.02c-.03-.06-.06-.12-.09-.17,0-.02-.02-.03-.02-.05,0-.02-.02-.04-.03-.06-.02-.04-.04-.08-.06-.12h0c-.03-.07-.07-.13-.1-.18,0-.02-.02-.03-.03-.05-.03-.04-.05-.09-.08-.13l-.62,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m14.15,22.98h0c-.61.31-1.29.51-2,.58l-.62,1.11s.07,0,.11,0c.07,0,.13,0,.2,0,.02,0,.04,0,.06,0,.05,0,.1,0,.15,0,.02,0,.04,0,.05,0,.06,0,.13,0,.19-.02h0c.07,0,.14-.02.21-.03h.01c.06-.01.13-.02.19-.03h.02c.21-.04.41-.08.61-.14l.81-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m9.61,12.03c-.11.04-.22.09-.32.15-.28.13-.55.3-.81.47h-.02c-.26.2-.51.4-.74.62-.03.03-.06.06-.09.09-.42.42-.78.91-1.07,1.43-.26.48-.46.99-.57,1.52-.02.09-.04.18-.05.26.07-.19.14-.38.22-.56.17-.39.36-.76.58-1.12.08-.13.17-.26.26-.39.27-.38.57-.72.9-1.04.09-.08.18-.17.27-.24.14-.12.29-.24.44-.35.25-.19.51-.35.77-.5.03-.01.05-.03.08-.04.52-.28,1.07-.5,1.65-.66-.51.05-1.01.18-1.49.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 11.63,
    cy: 17.77,
    r: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m15.16,16.42c0,.07-.14.14-.31.14h-2.67c-.17,0-.38,0-.46.01-.08,0-.22-.07-.13-.22l.77-1.33c.09-.15.28-.2.42-.11l2.11,1.22c.15.09.27.22.27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m11.99,14.45c.06.04.05.19-.04.34l-1.34,2.31c-.09.15-.15.27-.15.27,0,0-.03.06-.06.13-.04.07-.17.16-.26,0l-.77-1.33c-.09-.15-.03-.34.11-.42l2.11-1.22c.15-.09.32-.12.39-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m8.7,16.22c.06-.04.19.05.27.2l1.34,2.31c.09.15.15.27.16.27,0,0,.04.06.08.12.05.07.05.23-.12.23h-1.53c-.17,0-.31-.14-.31-.31v-2.44c0-.17.05-.34.12-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m8.58,19.95c0-.07.14-.14.31-.14h2.67c.17,0,.31,0,.31,0h.15c.16-.03.22.06.13.21l-.77,1.33c-.09.15-.28.2-.42.11l-2.11-1.22c-.15-.09-.27-.22-.27-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m11.75,21.92c-.06-.04-.05-.19.04-.34l1.34-2.31c.09-.15.15-.27.15-.27,0,0,.03-.06.06-.13.04-.07.17-.16.26,0l.77,1.33c.09.15.03.34-.11.42l-2.11,1.22c-.15.09-.32.12-.39.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m15.04,20.15c-.06.04-.19-.05-.27-.2l-1.34-2.31c-.09-.15-.16-.27-.16-.27,0,0-.04-.06-.08-.12-.05-.07-.05-.23.12-.23h1.53c.17,0,.31.14.31.31v2.44c0,.17-.05.34-.12.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m11.87,17.1c-.64,0-1.16.52-1.16,1.16s.52,1.16,1.16,1.16h0c.18,0,.35-.04.51-.12-.26-.03-.46-.25-.46-.52,0-.29.24-.53.53-.53.25,0,.46.17.51.41.05-.13.07-.26.07-.41,0-.64-.52-1.16-1.16-1.16Zm-.44,1.1c-.14,0-.25-.11-.25-.25s.11-.25.25-.25.25.11.25.25-.11.25-.25.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 11.44,
    cy: 17.95,
    r: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.85,49.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.7,49.51h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.7,57.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.05,53.9l-.32-1.7c.01.16.03.31.05.47.06.42.15.83.27,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.44,55.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.48,48.11h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.89,56.96h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.04,48.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.24,48.44h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.1,57.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.72,57.31h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.3,57.37h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.51,57.11h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.17,57.34h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.28,56.71s-.02-.01-.03-.02c0,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.49,56.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.39,56.77h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44,57.32s-.03,0-.04,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.6,56.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.57,49.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m50.04,52.77v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "47.23 46.79 47.23 46.79 47.23 46.79 47.23 46.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m50.11,51.7h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m50.09,52.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.59 46.17 45.57 46.16 45.57 46.16 45.58 46.16 45.59 46.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.45 46.07 44.47 46.07 44.45 46.07 44.45 46.07 44.45 46.07 44.45 46.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.44,46.14h0s.04,0,.06.01c-.02,0-.04,0-.06-.01-.01,0-.02,0-.03,0,.01,0,.02,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.83,50.04s0,.02.01.03c0-.01,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.29,46.07s-.02,0-.03,0c-.06,0-.11,0-.17.01.06,0,.11,0,.17-.01.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.02,46.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.68,46.07s.1,0,.14,0h.03s0,0,0,0h0s.06,0,.09,0h0s-.06,0-.09,0h-.03s-.1,0-.14,0c-.01,0-.03,0-.04,0-.06,0-.11,0-.17,0,.06,0,.11,0,.17,0,.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.28,47.57s.02.02.02.02c0,0-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.84,47.19s.02.02.03.03c-.01,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48,47.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.53,46.97s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.7,47.09s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.14,47.45s.02.02.02.02c0,0-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.38,46.87s.03.02.04.02c-.01,0-.03-.02-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.76,49.85h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.6,49.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.68,49.65v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.51,49.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.94,46.63s-.04-.02-.06-.03h-.01s.01,0,.01,0c.02,0,.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.6,55.7s-.06-.09-.09-.13c.03.04.06.09.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.41,47.74s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.73,55.87s-.07-.1-.11-.15c.04.05.07.1.11.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.49,55.55s-.06-.1-.1-.15c.03.05.06.1.1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.82,57.01s-.07-.06-.1-.09c.03.03.07.06.1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.98,57.13s-.07-.06-.11-.08c.04.03.07.06.11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.4,55.4c-.03-.05-.07-.11-.1-.16.03.05.06.11.1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.16,48.14s.02-.03.03-.05c0,.02-.02.03-.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.24,48s.02-.04.03-.06c-.01.02-.02.04-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.33,47.87s.02-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.09,48.27v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.47,49.88c.04-.15.08-.31.13-.46-.05.15-.09.3-.13.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.09,56.87h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.22,57.31c-.07-.05-.14-.1-.21-.16.07.05.14.11.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.49,58.48c-.08,0-.15-.01-.23-.02.08,0,.15.01.23.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.74,58.43s-.08.01-.12.01c.04,0,.08,0,.12-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.26,58.46c-.08,0-.16-.02-.23-.03.08.01.16.02.23.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.38,57.42s-.07-.05-.11-.08c.04.03.07.05.11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.18,58.35s-.04,0-.06.01c.02,0,.04,0,.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.98,58.39s-.05,0-.07.01c.02,0,.05,0,.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.04,58.21s-.09-.03-.13-.04c.04.01.09.03.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.98,57.77s-.08-.04-.12-.06c.04.02.08.04.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.72,58.1c-.09-.03-.17-.07-.26-.1.08.04.17.07.26.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.68,57.61c-.08-.05-.16-.1-.24-.15.08.05.16.1.24.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.8,57.68s-.08-.04-.12-.07c.04.02.08.04.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.41,57.98s-.08-.04-.12-.05c.04.02.08.04.12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.24,57.9c-.08-.04-.16-.08-.24-.12.08.04.16.08.24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.38,50.34c.03-.16.06-.31.1-.47-.04.15-.07.31-.1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.42,56.48c-.05.05-.09.1-.14.15.05-.05.1-.1.14-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.27,56.63s-.09.09-.13.13c.05-.04.09-.09.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.69,58.22s.03,0,.04-.01c.04-.01.08-.02.12-.04-.04.01-.08.03-.12.04-.01,0-.03,0-.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.87,45.2c.07-.02.14-.04.21-.06-.07.02-.14.04-.21.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.56,56.32s-.08.1-.13.14c.04-.05.09-.09.13-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m50.61,54.62s-.04.1-.06.14c.02-.05.04-.09.06-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.1,56.8s-.07.07-.11.1c.04-.03.07-.07.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.82,56.43h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.99,58.11s.04-.02.06-.02c.02,0,.05-.02.07-.03-.02,0-.05.02-.07.03-.02,0-.04.02-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.46,56.67h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.04,57.61s-.05.03-.08.05c-.02.01-.04.03-.07.04.02-.01.04-.02.07-.04.03-.02.05-.03.08-.05.02-.01.04-.03.06-.04.03-.02.05-.03.08-.05-.03.02-.05.03-.08.05-.02.01-.04.03-.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.64,57.83s.01,0,.02-.01c.01,0,.03-.01.04-.02-.01,0-.03.01-.04.02,0,0-.01,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.3,57.99s-.03.01-.05.02c.02,0,.03-.01.05-.02.02,0,.04-.02.07-.03.03-.01.06-.03.08-.04-.03.01-.06.03-.08.04-.02,0-.04.02-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.64,46.38h0c.05-.04.11-.09.16-.13-.05.04-.11.08-.16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.79,47.23s.03-.04.05-.06c-.02.02-.03.04-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.89,47.11s.03-.04.05-.05c-.02.02-.03.04-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.08,45.49c.07-.03.13-.06.2-.09-.07.03-.13.06-.2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40,46.99s.03-.04.05-.05c-.02.02-.03.04-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.6,47.48s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.69,47.35s.03-.04.05-.06c-.02.02-.03.04-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.11,46.87s.03-.03.05-.05c-.02.02-.03.03-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.42,45.83c.14-.08.28-.16.42-.23-.14.07-.28.15-.42.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.5,47.61s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.84,45.6c.06-.03.13-.06.19-.09-.06.03-.13.06-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.34,46.64s.03-.03.05-.04c-.02.01-.03.03-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.47,46.52s.03-.02.04-.04c-.01.01-.03.02-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.23,46.76s.03-.03.05-.05c-.02.02-.03.03-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.86,58.15s-.08-.03-.13-.04c.04.02.08.03.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.99,46.26s.09.03.14.04h.02s0,0,0,0h.02s0,0,0,0h0s.1.03.14.05h0s0,0,0,0c.01,0,.03,0,.04.01h0s.05.02.08.03c.03.01.05.02.08.03h0c.05.02.1.04.15.07h0s.03.01.04.02l-.24-1.25h-.02s-.02-.02-.02-.02c-.06-.02-.13-.04-.19-.06-.02,0-.03,0-.05-.01-.06-.02-.11-.03-.17-.04-.01,0-.02,0-.03,0-.03,0-.07-.02-.1-.02l.22,1.19s-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.96,55.68h0s.01.01.02.02c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "41.67 56.31 41.68 56.32 41.67 56.31 41.67 56.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.11,45.51s-.03-.01-.05-.02c-.02,0-.04-.02-.06-.02.02,0,.04.02.06.02.02,0,.03.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.08,46.05h.02s-.02,0-.02,0c-.05-.03-.1-.06-.15-.1-.01,0-.03-.02-.04-.03.01,0,.03.02.04.03.05.03.1.06.15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.75,55.46h0s0,0,0,0c0,.01.02.02.03.03,0-.01-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.54,55.2h0s.06.08.09.11c-.03-.04-.06-.08-.09-.11h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.74 45.08 45.74 45.08 45.71 45.07 45.74 45.08 45.74 45.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.7,46.96h0s0,0,0,0c-.01,0-.03.02-.04.03.01,0,.03-.02.04-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.99,56.54s-.02,0-.02-.01c.03.02.07.04.1.07-.03-.02-.05-.03-.08-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.14,56.63h0s.03.01.04.02c-.01,0-.02-.01-.04-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.85,56.44s.08.06.13.08h0s0,0,0,0c-.04-.03-.08-.06-.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.85,44.97h-.01s-.06,0-.08,0c.03,0,.06,0,.08,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.81,56.42h0s.02.01.03.02c-.01,0-.02-.01-.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.96,44.99h-.01s-.08.01-.13.02c.04,0,.08-.01.13-.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.2,46.25s.03,0,.04-.01c-.01,0-.03,0-.04.01-.03,0-.05.02-.08.02h0s.05-.02.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.31,45.09s-.03,0-.05.01c-.03,0-.06.01-.09.02.03,0,.06-.01.09-.02.02,0,.03,0,.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m50,52.99s-.01.08-.02.11c-.04.2-.1.4-.16.6-.01.03-.02.06-.03.1-.04.12-.09.25-.14.37l.31,1.64c-.12.17-.25.34-.38.5.4-.47.72-.98.97-1.53-.05.1-.1.2-.15.3l-.39-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.71,57.14l-.24-1.25c-.11.11-.23.21-.35.31-.05.04-.09.08-.14.11l.22,1.19s.02-.01.03-.02c.03-.02.05-.04.08-.05.02-.01.04-.03.06-.04.03-.02.06-.04.08-.06.02-.01.04-.03.06-.04.03-.02.06-.05.09-.07.01-.01.03-.02.04-.03.05-.04.09-.07.13-.11.05-.04.1-.09.15-.13-.05.04-.1.09-.15.13-.03.02-.06.04-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.07,46.29h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.24,46.24h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.87,46.11h0s.03,0,.04,0c-.01,0-.03,0-.04,0h-.02s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "43.71 46.14 43.71 46.14 43.71 46.14 43.71 46.14 43.71 46.14 43.68 46.14 43.71 46.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.25,46.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.94,46.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.76,46.91s.02-.01.03-.02c0,0-.02.01-.03.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.9,46.69l-.02-.02s-.03-.02-.04-.04c.01.01.03.02.04.04l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.06,46.73h0s.04-.03.07-.04c.02-.01.04-.02.06-.03.02,0,.04-.02.05-.03h0s-.04.02-.06.03c-.02,0-.04.02-.06.03-.02.01-.05.03-.07.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42,46.76s.04-.02.05-.03c-.02.01-.04.02-.05.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.71,48.03c.06.07.12.15.18.23.11.14.21.29.3.44l-.39-2.08s.03.02.04.03c-.04-.04-.09-.08-.13-.12-.01,0-.02-.02-.03-.03-.05-.05-.11-.09-.16-.13-.01,0-.03-.02-.04-.03-.05-.04-.09-.07-.14-.11-.01,0-.03-.02-.04-.03-.06-.04-.11-.08-.17-.12l.31,1.65c.1.1.19.2.28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m49.23,47.02s.04.05.06.07l.6,3.17c.09.31.15.63.18.95,0,.02,0,.03,0,.05l.6,3.19c-.02.05-.04.1-.06.16.94-2.23.68-4.95-.91-7.03-.05-.06-.09-.12-.14-.18-.01-.02-.02-.03-.04-.05-.04-.05-.09-.1-.13-.15l-.02-.02c-.05-.06-.1-.11-.15-.16-.01-.01-.03-.03-.04-.04-.03-.03-.06-.06-.09-.09.03.03.06.06.09.09.01.01.03.03.04.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "43.33 46.22 43.34 46.22 43.33 46.22 43.33 46.22 43.33 46.22 43.33 46.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.58,52.71c-.12-.58-.15-1.19-.09-1.78l-.11-.58c-.29,1.64.01,3.39.92,4.9l-.19-1c-.25-.48-.43-1-.53-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.03,47.5c.09-.08.18-.16.27-.24h.01s.03-.04.05-.05c.02-.01.03-.03.05-.04.01,0,.03-.02.04-.03.03-.02.05-.04.08-.06.02-.01.03-.02.05-.03h0s0,0,0,0h.01s.03-.03.05-.04l-.22-1.17c-.21.13-.42.27-.62.43l.23,1.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.56,57.22h-.01s-.04-.01-.07-.02h0s0,0,0,0h0s-.02,0-.03-.01c-.03,0-.05-.01-.08-.02-.01,0-.03,0-.04-.01h-.02s-.02-.01-.02-.01h0s-.02,0-.04-.01h-.01s-.02-.01-.03-.01c-.01,0-.03,0-.04-.01h-.02s-.02-.01-.03-.02h-.02s-.05-.02-.07-.03h-.01s-.01,0-.01,0h0s-.02,0-.02,0c-.03-.01-.07-.03-.1-.04h0s-.03-.02-.04-.02h0s0,0,0,0l.23,1.24c.32.1.65.17.97.22-.08-.01-.16-.02-.24-.04l-.22-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39,48.96c.05-.11.1-.21.16-.32l-.07-.37c-.2.37-.36.75-.49,1.14l.08.42c.09-.3.19-.6.32-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.37,58.3h0s0,0,0,0c.02,0,.04-.01.06-.02-.02,0-.04.01-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.9,57.39h-.02s0,0,0,0c-.01,0-.03,0-.04,0h-.02s-.06,0-.09,0c-.01,0-.02,0-.04,0h-.03s-.03,0-.03,0c-.02,0-.04,0-.07,0h-.03s-.01,0-.01,0l.21,1.11c-.08,0-.16,0-.24-.01.35.02.7.01,1.05-.03-.15.02-.3.03-.45.03l-.21-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.34,54.92c-.95-1.4-1.22-3.09-.87-4.64h0s-.25-1.32-.25-1.32c-.01.03-.02.05-.03.08-.11.29-.2.58-.27.88-.04.18-.08.36-.11.55l1.05,5.55h0c.27.33.56.63.87.9l-.38-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.43,46.54s-.04.02-.06.03c-.02.01-.05.02-.07.03.02-.01.05-.02.07-.03.02,0,.04-.02.06-.03.02-.01.05-.02.07-.03.02,0,.04-.02.06-.02h0s0,0,0,0c.02-.01.05-.02.07-.03h0s0,0,0,0c.02,0,.04-.02.05-.02.03-.01.05-.02.08-.03.02,0,.03-.01.05-.02.03-.01.06-.02.08-.03.01,0,.03-.01.04-.02-.01,0-.03.01-.04.02-.02,0-.05.02-.07.03l-.21-1.1c.07-.02.14-.04.21-.07-.18.05-.37.12-.55.19l.21,1.11s-.04.02-.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m50.08,51.26s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 49.76,
    y: 49.85,
    width: 0,
    height: 0,
    transform: "translate(-13.91 19.73) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.96,57.31s.03,0,.04,0h0s-.03,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 49.51,
    y: 49.26,
    width: 0,
    height: 0,
    transform: "translate(-16.6 26.74) rotate(-26.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.14,48.81s.01.01.02.02h0s-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m49.69,49.67v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m49.84,50.08s0-.02-.01-.03h0s0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m49.89,50.26h0c.09.31.15.63.18.95-.04-.32-.1-.64-.18-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.36,46.38s.05.02.08.03c-.03-.01-.05-.02-.08-.03h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.2,48.87s.02.02.02.02h0s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.19,52.03s-.01,0-.02.01c0,0,.02-.01.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.12,52.07s.02-.01.03-.02c0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.24,52h-.02s.02,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.36,51.95s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.26,51.99s.02,0,.03-.01c0,0-.02,0-.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.31,51.97s.02,0,.03-.01c0,0-.02,0-.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.42,51.93h-.01s.02,0,.03,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.25,48.93s.02.02.03.03h0s-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.31,48.99s.03.04.05.06h0s-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.07,52.11s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.55,57.22s-.04-.01-.07-.02c.02,0,.04.01.07.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 50.11,
    y: 51.7,
    width: 0,
    height: 0,
    transform: "translate(-1.45 1.44) rotate(-1.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.88,48.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 49.6,
    y: 49.46,
    width: 0,
    height: 0,
    transform: "translate(-16.12 25.23) rotate(-24.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.77,48.53s.02.01.03.02h0s-.03-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.71,48.49s.02,0,.02.01h0s-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.23,46.78h0s0,0,0,0h0s0,0,0,0h-.02s-.04-.03-.06-.04h-.02s.05.02.07.03c0,0,.02,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.64,48.45h.02s.01.02.01.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45 48.68 45 48.69 44.99 48.68 45 48.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.96 48.66 44.97 48.66 44.97 48.66 44.96 48.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.72,46.52s.08.04.12.05c-.04-.02-.08-.04-.12-.05-.01,0-.03-.01-.04-.02h0s.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.57,48.42h.01s.01.01.01.01c0,0-.02,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47,46.66s-.03-.01-.04-.02c0,0-.02,0-.02-.01.02.01.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.76,46.2h.02s.02,0,.03.01c0,0-.02,0-.03,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.93,48.63h.02s-.02,0-.04-.02c0,0,.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m49.64,54.16c.05-.12.1-.24.14-.37-.04.12-.09.25-.14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m49.98,53.1c-.04.2-.1.4-.16.6.06-.2.12-.4.16-.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "50.04 52.79 50.04 52.77 50.04 52.79 50.04 52.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m50,52.99h0s-.01.08-.02.11c0-.04.02-.07.02-.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 50.08,
    y: 52.35,
    width: 0.01,
    height: 0,
    transform: "translate(-6.41 97.71) rotate(-85.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45.06 48.74 45.06 48.74 45.06 48.74 45.06 48.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.3 46.07 44.3 46.07 44.28 46.07 44.3 46.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.55 48.41 44.55 48.41 44.55 48.41 44.55 48.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45.09 48.76 45.1 48.77 45.1 48.77 45.09 48.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.5 48.39 44.51 48.39 44.52 48.39 44.5 48.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.97 52.19 44.96 52.19 44.98 52.18 44.97 52.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45.03 48.71 45.03 48.71 45.04 48.72 45.03 48.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.42,53.97s.04.01.05.02c-.02,0-.04-.01-.06-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.83,55.54s.02.02.03.03c0,0-.01-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.14,56.63s.02.01.04.02c.01,0,.02.01.03.02h-.02s-.03-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.97,53.66s-.03-.04-.04-.05c.01.02.03.04.04.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 41.05,
    y: 55.79,
    width: 0.02,
    height: 0,
    transform: "translate(-27.9 49.26) rotate(-48.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.48,53.99s.02,0,.03,0h.02s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.9,54.01s.03,0,.05,0h.01s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.62,54.01s.02,0,.04,0h.02s-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.55,54s.04,0,.06.01c-.02,0-.04,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.69,54.02s.04,0,.06,0h0s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.85,54.01s.03,0,.05,0c-.02,0-.04,0-.06,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.76,54.02s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.01,56.55h0s0,0,0,0c.03.02.05.03.08.05h.02s-.05-.02-.08-.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.28,56.71s-.02,0-.03-.01h0s.02.01.03.02c0,0,.02.01.03.02h0s-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.3 57.15 43.32 57.15 43.31 57.15 43.3 57.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43 57.04 43 57.04 43 57.04 43 57.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.17,57.1s.03,0,.04.01c-.01,0-.02,0-.03-.01h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.24 57.13 43.25 57.13 43.25 57.13 43.24 57.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.02,57.05s.05.02.07.03c-.02,0-.04-.01-.06-.02h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.96,57.03s-.02,0-.03-.01c-.02,0-.03-.01-.05-.02.03.01.07.03.1.04h-.01s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.34,56.75h0s.02,0,.03.01h.02s0,.01,0,.01c0,0-.02,0-.03-.01,0,0-.02,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.45,56.8s.02.01.03.02h0s.01.01.01.01c-.02,0-.03-.02-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.58,56.87h.01s0,0,0,0h.02s0,0,0,0c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.83,56.98s.03.01.04.02h-.01s-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 46.69,
    y: 57.04,
    width: 0,
    height: 0,
    transform: "translate(-17.41 20.65) rotate(-21.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 44.16,
    y: 57.32,
    width: 0,
    height: 0.03,
    transform: "translate(-18.71 93.18) rotate(-82.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 46.89,
    y: 56.96,
    width: 0,
    height: 0,
    transform: "translate(-19.17 24.1) rotate(-24.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.7 52.36 44.68 52.37 44.7 52.35 44.7 52.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "47.45 56.68 47.46 56.67 47.46 56.67 47.45 56.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.59,52.41s-.02,0-.02.01c.01,0,.03-.01.04-.02h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 47.07,
    y: 56.88,
    width: 0.02,
    height: 0,
    transform: "translate(-20 26.02) rotate(-25.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 45.1,
    y: 57.38,
    width: 0,
    height: 0,
    transform: "translate(-2.94 2.43) rotate(-2.99)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.89 52.25 44.88 52.25 44.89 52.25 44.89 52.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.79,52.31h-.01s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "46.5 57.12 46.51 57.11 46.51 57.11 46.5 57.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 45.7,
    y: 57.32,
    width: 0.02,
    height: 0,
    transform: "translate(-8.74 8.23) rotate(-9.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.09,53.78s.03.02.05.04c-.02-.01-.03-.02-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.21,53.87h.02s.02.02.03.03c-.02,0-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.15,53.83h0s.03.03.05.04c-.02-.01-.04-.02-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.34,53.94s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.27,53.91s.04.02.06.03c-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.48,48.38h0s-.02,0-.03,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.41,52.48h0s-.03,0-.04.01c.02,0,.03,0,.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.03,53.73s.03.03.04.04h.01s-.03-.02-.05-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 47.81,
    y: 56.44,
    width: 0.02,
    height: 0,
    transform: "translate(-23.84 38.08) rotate(-35.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.51,52.44h-.01s-.02.01-.03.02h0s.03,0,.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.02,53.72s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.64 57.38 44.66 57.38 44.66 57.38 44.64 57.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.43,57.19h-.02s-.03-.02-.05-.02c.03,0,.05.02.08.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.75,50.78s.03,0,.05,0c-.02,0-.05,0-.07,0h0s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.82,50.78s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.09,50.83h.01s-.05,0-.07-.01c.02,0,.04,0,.06.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.18,50.85h.02s-.06,0-.09-.02c.02,0,.04,0,.05.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.51,50.97s.04.02.06.03c-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.59,51.01s.05.03.08.04c-.03-.02-.05-.03-.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.93,50.8s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.4,50.92s.06.02.08.04c-.03-.01-.06-.02-.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.22,48.29s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45.64 50.78 45.63 50.78 45.64 50.78 45.64 50.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.26,49.45s.02,0,.03-.01c0,0-.02,0-.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.34,48.33h0s-.03,0-.05-.02c.02,0,.03.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.56,50.78s-.02,0-.03,0h.02s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.61,50.78s-.03,0-.05,0h.02s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.69,51.06s.05.03.07.04c-.02-.01-.05-.03-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.31,49.42s.02,0,.03-.01c0,0-.02,0-.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.7,50.78s-.03,0-.05,0h.02s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.35,49.4s.02,0,.03-.01c0,0-.02,0-.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.98,51.27s.02.01.03.02c-.02-.02-.04-.03-.06-.05.01,0,.02.02.03.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.35,50.9s.03.01.05.02c-.03-.01-.06-.02-.08-.03,0,0,.02,0,.03.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.88,48.6s-.03-.02-.04-.03c.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.97,51.05s.03.03.04.05h0s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.72,48.22s.04,0,.05,0c-.02,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.41,48.35h.01s-.03,0-.05-.01c.01,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.43 48.36 44.44 48.36 44.45 48.36 44.43 48.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.56,48.23s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.29,48.26s.02,0,.03,0h0s.02,0,.04,0c-.03,0-.05,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.47,51.85s.05.09.08.14c-.02-.05-.05-.1-.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.03,51.31s.04.04.06.06c-.02-.02-.04-.04-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.1,51.38s.05.05.07.07c-.02-.02-.04-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.86,51.17s.05.04.07.06c-.02-.02-.05-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.46,49.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.27,50.87h.02s-.04,0-.07-.01c.01,0,.02,0,.03,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.78,51.12s.04.03.06.04c-.02-.01-.04-.03-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.18,51.46s.03.04.05.06c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.25,51.54s.04.05.06.08c-.02-.03-.04-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.49,50.79h.01s-.05,0-.07,0h.02s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.05,51.15h.01s0,.01,0,.01c-.01-.01-.02-.02-.03-.03,0,0,.01.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.72,51.46s-.04,0-.05,0c.02,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.88,48.23s.02,0,.04,0h0s-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.65,51.45s-.04,0-.06-.01c.02,0,.04,0,.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.57,57.38s.04,0,.07,0c-.02,0-.04,0-.07,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.78,51.46h0s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.58,51.44s-.03,0-.05-.01c.02,0,.03,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.07,48.25h.01s.03,0,.03,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 43.86,
    y: 51.45,
    width: 0,
    height: 0,
    transform: "translate(-3.8 3.5) rotate(-4.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.34,51.35h0s.01,0,.01,0c0,0-.02,0-.03-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.51,51.42s-.04-.01-.06-.02c.02,0,.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.29,51.33s-.02-.01-.03-.02c0,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.99 48.24 43.99 48.24 43.98 48.24 43.99 48.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.22,51.29h0s0,0,0,0c0,0-.02-.01-.03-.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44,48.24h0s.03,0,.03,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.88,57.39h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.92 48.23 43.93 48.23 43.95 48.24 43.92 48.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.4,51.38h0s.02,0,.03.01c-.01,0-.03-.01-.04-.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.11,51.2h0s0,0,0,0c-.01,0-.02-.02-.03-.03,0,0,.02.01.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "45.32 50.81 45.3 50.81 45.3 50.81 45.32 50.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.48,48.23s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.85 48.23 43.85 48.23 43.87 48.23 43.85 48.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.64,48.22s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.21,49.48s.02-.01.03-.02c0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.11,49.55s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.17,49.51s.02-.01.03-.02c0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.4,50.79h.01s-.06,0-.09.01c.01,0,.02,0,.04,0,.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m48.48,55.88h0c-.11.11-.23.21-.35.31-.05.04-.09.08-.14.11.05-.04.09-.07.14-.11.12-.1.24-.21.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.73,57.38h0s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.14,48.27h0s.03,0,.04.01c-.01,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.16,51.24h.01s0,0,0,0c0,0-.02-.01-.03-.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.39,48.25h.01s0,0,0,0c.01,0,.03,0,.04,0-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.06 48.25 44.06 48.25 44.06 48.25 44.06 48.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.28,50.81s-.04,0-.05.01c0,0,.02,0,.03,0h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.84,48.23h0s-.03,0-.05,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.71,46.14h-.02c-.6.2-1.17.51-1.69.94-2.31,1.92-2.65,5.47-.76,7.94.12.15.24.3.37.44-.02,0-.03,0-.05.01.02,0,.03,0,.05-.01.12.12.24.24.36.36.01.01.03.03.04.04.28.24.57.46.88.63.95-.15,1.89-.56,2.72-1.25.04-.04.09-.07.13-.11-.01,0-.02,0-.04,0-.01,0-.03,0-.04,0-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0h-.01s-.08-.01-.12-.02h-.01s-.04,0-.05-.01h-.02s-.04-.01-.05-.02h-.02s-.04-.01-.05-.02h-.02s-.04-.02-.06-.02h-.01c-.11-.04-.22-.09-.33-.14h0s-.04-.02-.06-.04h0s-.04-.03-.06-.04h0c-.11-.07-.21-.15-.3-.23h0c-.1-.09-.19-.18-.27-.29l.18-.15.64-.53.14-.03c.24.32.62.46.98.4h0c.11-.04.21-.1.31-.17s.17-.17.23-.28c.03-.04.05-.09.07-.14.01-.03.02-.06.03-.1.03-.11.05-.23.04-.35,0-.03,0-.07,0-.1-.01-.1-.04-.2-.08-.3-.03-.06-.06-.13-.1-.19-.01-.01-.02-.03-.03-.04-.1-.13-.22-.23-.36-.3-.03-.02-.06-.03-.09-.04-.17-.07-.35-.09-.53-.06-.11.04-.22.09-.31.17-.24.2-.5.33-.78.4l-.14.03h.02s-.02,0-.03,0h0s-.04.01-.07.02h0c-.23.05-.47.05-.7.02h-.02c-.09-.02-.17-.04-.25-.06h0s-.08-.03-.11-.04h-.02s-.08-.04-.12-.05h0s-.08-.04-.12-.06h-.02s-.07-.04-.1-.06c0,0-.02,0-.02-.01-.21-.13-.41-.31-.58-.53-.59-.78-.61-1.84-.11-2.6.01-.02.03-.04.04-.06l-.07-.09-.32-.42.21-.17.6-.5.14-.03.38.49c.08-.03.16-.05.24-.07h0s.02,0,.02,0c-.02,0-.03,0-.05.01l.14-.03c.76-.19,1.61.08,2.14.78l-.82.68-.14.03h0s-.03-.04-.05-.06h-.01s-.03-.05-.05-.07h0s-.03-.04-.05-.05h0s-.04-.04-.06-.05h-.01s-.08-.06-.13-.08h-.01s-.04-.03-.07-.03h0s-.05-.02-.07-.03h0s-.05-.01-.07-.02h0s-.1-.02-.15-.02h0c-.07,0-.14,0-.22.01-.11.04-.22.09-.31.17-.43.36-.5,1.03-.14,1.49.24.32.62.46.97.4h.02s0,0,0,0c.05-.02.1-.04.14-.06h.01s.04-.03.06-.05h.01s.04-.04.06-.06c.03-.02.05-.04.08-.06,0,0,.02-.01.03-.02.02-.01.04-.03.06-.04.01,0,.02-.01.03-.02.02-.01.03-.02.05-.03.01,0,.02-.01.04-.02.02,0,.03-.02.05-.03.01,0,.02-.01.04-.02.02,0,.03-.02.05-.02.01,0,.03-.01.04-.02.02,0,.03-.01.05-.02.01,0,.03-.01.04-.02.02,0,.04-.01.05-.02.01,0,.02,0,.04-.01.02,0,.04-.01.07-.02.02,0,.04-.01.06-.02.01,0,.03,0,.04-.01h-.02s.14-.03.14-.03c.76-.19,1.61.09,2.14.78.07.09.13.19.19.29.29-1.42.04-2.89-.83-4.04-.41-.54-.92-.96-1.48-1.26h0s-.02-.01-.02-.01c-.04-.02-.08-.04-.12-.06-.01,0-.02,0-.03-.01-.01,0-.02-.01-.03-.02-.04-.02-.07-.03-.11-.05h-.01s-.09-.04-.13-.06c-.01,0-.03,0-.04-.01-.05-.02-.09-.03-.14-.05h0s-.1-.03-.15-.05c-.01,0-.03,0-.04-.01-.04-.01-.09-.02-.13-.04h-.02c-.05-.02-.1-.03-.15-.04-.01,0-.03,0-.04,0-.04,0-.09-.02-.13-.02h-.03s-.05-.01-.07-.02h.01c.05,0,.11-.01.16-.02-.03,0-.05,0-.08,0-.03,0-.06,0-.08,0-.01,0-.03,0-.04,0h0s-.02,0-.02,0c-.04,0-.09.01-.13.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.02,46.08s.03,0,.04,0c.05,0,.09,0,.14.01.01,0,.02,0,.04,0-.01,0-.02,0-.04,0-.05,0-.09-.01-.14-.01-.01,0-.03,0-.04,0-.03,0-.05,0-.08,0h0s.05,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.48,57.2h0s.04.01.07.02h.01s0,0,0,0c-.03,0-.06-.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.76,53.31c.01-.09.02-.17.02-.26,0,.09,0,.18-.02.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.55,53.99h0c-.02.05-.05.1-.08.15h0c.08-.13.14-.26.19-.4-.03.09-.06.17-.1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.96,57.31s.03,0,.04,0h0s-.04,0-.06,0h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.32 55.05 46.31 55.05 46.33 55.04 46.32 55.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "47.59 54.56 47.38 54.28 47.38 54.27 47.38 54.28 47.59 54.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.14,57.34h.03s0,0,0,0c-.01,0-.03,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.1,57.08s-.04-.02-.07-.02c.02,0,.04.01.06.02h.02s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.17,57.11s.02,0,.03.01c0,0,.02,0,.03,0h.01s-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.43,54.21h0s.03-.04.04-.07h0s-.03.05-.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.73,57.38s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.78,57.27h0s.03,0,.04,0c-.02,0-.04,0-.06-.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.21,56.67h0s-.02,0-.03-.01h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "42.45 56.8 42.45 56.8 42.46 56.8 42.45 56.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.31,57.17h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.3,56.72h0s.02.01.03.02h0s-.03-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.75,54.77l-.07-.09.07.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "42.62 56.88 42.62 56.89 42.61 56.88 42.62 56.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.97,57.03h.01s.02.01.02.01h0s-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.31,57.15h.01s.03.01.04.02c.02,0,.03,0,.05.01-.03,0-.07-.02-.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.57,54.95h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.39 55.02 46.39 55.02 46.41 55.02 46.39 55.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "45.1 57.38 45.1 57.38 45.11 57.38 45.08 57.38 45.1 57.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.74,53.4c-.02.09-.04.17-.06.25.03-.08.05-.17.06-.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "45.9 57.28 45.91 57.28 45.91 57.28 45.9 57.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "42.02 56.55 42.01 56.55 42.01 56.55 42.02 56.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.66,57.38s-.06,0-.09,0c.02,0,.04,0,.07,0h.03s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.48,55.88h0c.5-.5.89-1.08,1.17-1.72.05-.12.1-.24.14-.37.01-.03.02-.06.03-.1.06-.2.12-.4.16-.6,0-.04.02-.07.02-.11.01-.07.02-.14.04-.2v-.02c.02-.14.04-.27.05-.41h0c.02-.23.02-.44.02-.65h0c0-.15-.01-.29-.03-.44,0-.02,0-.03,0-.05-.04-.32-.1-.64-.18-.95-.02-.06-.04-.12-.06-.18,0-.01,0-.02-.01-.03-.02-.06-.04-.12-.06-.19h0c-.02-.07-.04-.13-.07-.19v-.02c-.03-.06-.06-.13-.09-.19h0c-.03-.07-.06-.13-.09-.19h0c-.09-.2-.2-.39-.32-.58-.09-.15-.19-.29-.3-.44-.06-.08-.12-.15-.18-.23-.09-.11-.18-.21-.28-.31h0s-.09-.09-.13-.13c0,0-.02-.02-.02-.02-.04-.03-.07-.07-.11-.1,0,0-.02-.02-.02-.02-.04-.04-.09-.08-.13-.12h0s-.08-.07-.13-.11c-.01,0-.02-.02-.03-.03-.04-.03-.08-.06-.12-.09,0,0-.01-.01-.02-.02-.05-.03-.09-.07-.14-.1-.01,0-.02-.01-.03-.02-.04-.02-.07-.05-.11-.07-.01,0-.03-.02-.04-.02-.05-.03-.09-.06-.14-.09h0s0,0,0,0h0s-.02-.01-.02-.01c-.02-.01-.05-.03-.07-.04-.02-.01-.04-.02-.06-.03-.01,0-.02-.01-.03-.02-.01,0-.03-.01-.04-.02-.02-.01-.04-.02-.06-.03-.02-.01-.04-.02-.06-.03h-.01s-.02-.01-.03-.02c-.04-.02-.08-.04-.12-.05-.01,0-.03-.01-.04-.02-.05-.02-.1-.04-.15-.06h0s-.05-.02-.08-.03c-.03-.01-.05-.02-.08-.03h-.02s-.02-.01-.02-.01h0s-.1-.03-.14-.05h0s-.02,0-.02,0h-.02s-.09-.04-.14-.05c-.01,0-.03,0-.04-.01h-.02s-.08-.03-.12-.04c0,0-.02,0-.03,0h-.02s-.02,0-.03-.01c-.04,0-.08-.02-.11-.02-.01,0-.02,0-.04,0h0s-.05-.01-.08-.02c-.02,0-.04,0-.06-.01h0s-.02,0-.04,0c-.05,0-.1-.01-.15-.02h-.02s-.02,0-.04,0c-.05,0-.09-.01-.14-.01-.01,0-.03,0-.04,0-.03,0-.05,0-.08,0-.03,0-.06,0-.09,0h0s-.03,0-.03,0c-.05,0-.09,0-.14,0-.01,0-.03,0-.04,0-.06,0-.11,0-.17,0h-.02s0,0,0,0c-.05,0-.1,0-.15,0h-.02s-.02,0-.02,0c-.06,0-.11,0-.17.01h0c-.05,0-.11.01-.16.02h-.01s.05,0,.07.01h.03s.09.02.13.03c.01,0,.03,0,.04,0,.05.01.1.02.15.03h.02s.09.03.13.04c.01,0,.03,0,.04.01.05.01.1.03.15.05h0s.09.03.14.05c.01,0,.03,0,.04.01.05.02.09.03.13.05h.01s.08.04.11.05c.01,0,.02.01.03.02.01,0,.02,0,.03.01.04.02.08.04.12.06h.02s0,.01,0,.01c.57.3,1.07.72,1.48,1.26.87,1.15,1.13,2.63.83,4.04.42.76.36,1.7-.12,2.37l.39.51-.81.67-.14.03h0s-.38-.49-.38-.49c-.07.03-.14.05-.21.07l-.14.03h0s0,0,0,0c-.02,0-.03,0-.05.01-.01,0-.02,0-.03,0-.02,0-.04,0-.05.01h-.02s-.05.01-.08.02c-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0-.01,0-.02,0-.04,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0h0s-.08.07-.13.11c-.83.69-1.77,1.1-2.72,1.25,1.09.63,2.35.86,3.55.65.02,0,.04-.01.06-.02h.01c.06-.03.12-.05.18-.07h0c.06-.03.13-.05.19-.08h0c.06-.03.12-.05.18-.08h.02c.12-.07.24-.13.36-.2h.02c.12-.08.23-.15.35-.24h.01c.06-.05.11-.09.17-.13.05-.04.09-.07.14-.11.12-.1.24-.21.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.52,57.34h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.87,56.99h-.01s.01,0,.01,0h0s.03.02.05.02c-.02,0-.04-.02-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.43,57.19h0s.02,0,.03.01c-.01,0-.03,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.6,52.1c.03.08.06.15.08.23-.02-.08-.05-.15-.08-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.69,52.38s.03.1.04.15c-.01-.05-.02-.1-.04-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.76,52.66c.01.1.02.2.02.3,0-.1-.01-.2-.02-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.7,57.32h.02s0,0,0,0c-.01,0-.02,0-.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.35,57.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.9,57.39h.02s-.02,0-.03,0h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.47 54.99 46.47 54.99 46.49 54.99 46.47 54.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m43.76,44.97l-.69.17h.02s0,0,0,0c.03,0,.06-.01.09-.02.03,0,.06-.01.09-.02.02,0,.03,0,.05-.01.07-.01.13-.03.2-.04h.01c.06-.01.13-.02.19-.03.02,0,.03,0,.05,0,.02,0,.04,0,.06,0,.04,0,.08-.01.13-.01h.01c.07,0,.13-.01.2-.02.02,0,.03,0,.05,0,.06,0,.12,0,.18,0h.03c.07,0,.13,0,.2,0,.02,0,.03,0,.05,0,.03,0,.06,0,.08,0,.03,0,.06,0,.08,0h.01s.03,0,.03,0c.07,0,.13,0,.2.01.02,0,.03,0,.05,0,.06,0,.11.01.17.02.01,0,.03,0,.04,0,.07,0,.13.02.2.03.01,0,.03,0,.04,0,.05,0,.09.02.14.03h.03s0,0,0,0c.01,0,.03,0,.04,0,.03,0,.06.01.09.02.03,0,.07.01.1.02.01,0,.02,0,.03,0,.06.01.11.03.17.04.02,0,.03,0,.05.01.06.02.13.04.19.06h.02s.02.02.02.02c.05.02.1.03.15.05.02,0,.03.01.05.02.06.02.13.05.19.07h0s.08.04.12.05c.02,0,.04.02.06.02.02,0,.03.01.05.02.06.03.12.05.17.08h.02c.06.04.12.07.18.1.02,0,.03.02.05.03.05.03.11.06.16.09,0,0,.02.01.03.02.06.03.12.07.18.11.01,0,.03.02.04.03.05.03.1.06.15.1h.02s.02.02.02.02h0c.06.04.11.08.17.12.01,0,.03.02.04.03.05.03.09.07.14.11.01,0,.03.02.04.03.06.04.11.09.16.13.01,0,.02.02.03.03.05.04.09.08.13.12.01.01.03.02.04.04l.02.02s.09.09.14.13c0,0,.02.02.03.03.01.01.03.03.04.04.03.03.06.06.09.09.01.01.03.03.04.04.05.05.1.11.15.16l.02.02c.04.05.09.1.13.15.01.02.02.03.04.05.05.06.09.12.14.18,1.59,2.08,1.85,4.8.91,7.03v.02s-.05.1-.07.14h0c-.25.55-.58,1.07-.97,1.54v.02c-.06.05-.1.1-.14.14h-.01c-.05.06-.09.11-.14.16h0s-.09.09-.13.14c-.01.01-.03.02-.04.04-.04.03-.07.07-.11.1-.01.01-.03.03-.04.04-.05.04-.1.09-.15.13-.04.04-.09.07-.13.11-.01.01-.03.02-.04.03-.03.02-.06.05-.09.07-.02.01-.04.03-.06.04-.03.02-.06.04-.08.06-.02.01-.04.03-.06.04-.03.02-.05.04-.08.05-.01,0-.02.01-.03.02-.01,0-.02.01-.03.02-.03.02-.05.03-.08.05-.02.01-.04.03-.06.04-.03.02-.05.03-.08.05-.02.01-.04.03-.07.04-.03.02-.05.03-.08.05-.02.01-.04.02-.07.04-.01,0-.03.01-.04.02-.01,0-.03.01-.04.02,0,0-.01,0-.02.01-.01,0-.03.02-.04.02-.03.01-.05.03-.08.04-.02.01-.04.02-.07.03-.03.01-.06.03-.08.04-.02,0-.04.02-.07.03-.02,0-.03.01-.05.02-.01,0-.03.01-.04.02-.02,0-.04.02-.07.03h-.02s-.05.03-.07.03c-.02,0-.04.02-.06.02-.03.01-.06.02-.1.03-.02,0-.04.01-.06.02-.04.01-.08.03-.12.04-.01,0-.03,0-.04.01-.05.02-.1.03-.16.05-.01,0-.03,0-.04.01-.02,0-.04.01-.06.02-.02,0-.04.01-.06.02h0s.69-.17.69-.17c.86-.22,1.69-.63,2.43-1.24,2.76-2.29,3.16-6.54.91-9.49-1.65-2.16-4.27-3.03-6.64-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m42.88,56.49c-.31-.18-.6-.39-.88-.63-.01-.01-.03-.03-.04-.04-.12-.11-.24-.23-.36-.36-.02,0-.03,0-.05.01.02,0,.04,0,.05-.01-.13-.14-.25-.28-.37-.44-1.89-2.47-1.55-6.03.76-7.94.52-.43,1.09-.74,1.69-.94-.05,0-.1.02-.14.03-.01,0-.03,0-.04,0-.05.01-.1.02-.14.03h-.02s0,0,0,0c-.03,0-.06.01-.09.02-.02,0-.03,0-.05.01-.02,0-.05.01-.07.02h0s-.03.01-.05.02h-.02s-.07.03-.11.04c-.02,0-.03.01-.05.02-.03,0-.05.02-.08.03-.02,0-.04.01-.05.02-.02,0-.05.02-.07.03-.02,0-.04.02-.06.02h0s-.05.02-.07.03h0s-.04.02-.06.03c-.02.01-.05.02-.07.03-.02,0-.04.02-.06.03-.02.01-.05.02-.07.03-.02,0-.04.02-.06.03h0s0,0,0,0c-.02,0-.03.02-.05.03-.02.01-.04.02-.06.03-.02.01-.04.02-.06.04h0s-.04.02-.06.03c-.02.01-.04.03-.07.04-.02.01-.04.02-.06.03-.01,0-.03.02-.04.02,0,0-.02.01-.03.02-.02.01-.04.02-.05.03-.02.01-.04.03-.07.04h0s-.03.02-.05.04h0s0,0,0,0c-.02.01-.03.02-.05.03h-.01s0,0,0,0c-.02.01-.03.02-.05.04-.02.02-.05.04-.07.05-.01.01-.03.02-.04.03-.02.01-.03.03-.05.04-.02.01-.03.03-.05.04h-.01c-.09.09-.18.17-.27.25-.2.19-.38.39-.55.61h0c-.08.11-.16.22-.23.33h0c-.07.11-.14.23-.21.35h0c-.06.12-.13.24-.18.36h0c-.06.12-.11.25-.16.37h0c-.05.13-.09.25-.13.38h0c-.04.13-.07.26-.1.39-.35,1.54-.07,3.24.87,4.64.03.04.06.09.09.13h0c.03.05.07.1.1.15h0s.06.08.09.11c0,.01.02.02.03.04.02.03.04.05.06.08,0,.01.02.02.03.03h0s0,.01,0,.01c0,.01.02.02.03.03,0,.01.02.02.03.03h.01s0,.02,0,.02c0,0,.01.02.02.02h0s.02.02.03.03c.03.03.05.06.08.08h0s.01.01.02.02c0,0,.02.02.03.03,0,0,.02.02.03.03h0s0,0,0,0h0s.02.02.02.02h0s.01.02.01.02h0s.02.02.03.03c.01.01.03.02.04.04.02.02.04.04.06.06.01.01.03.03.04.04.01.01.02.02.03.03.01.01.02.02.04.03.04.04.09.08.13.11,0,0,.02.02.03.02.03.02.06.05.08.07.01.01.03.02.04.03.02.02.05.04.07.05h0s.01,0,.01,0h.01s.08.07.12.1h0s.02.01.03.02c.04.03.08.06.13.08h0s.02,0,.02.01h0s0,0,0,0h.01s.05.04.08.06c.01,0,.03.02.04.03h0s0,0,0,0c.02,0,.03.02.05.03,0,0,.02.01.03.02.01,0,.02.01.03.02,0,0,.02,0,.03.01,0,0,.02,0,.03.01.01,0,.03.01.04.02,0,0,.02,0,.02.01,0,0,.02,0,.03.01.02.01.04.02.06.03h0s.03.02.05.03c.03.01.05.03.08.04,0,0,.02,0,.03.01h0c.06.03.13.06.19.09h0s0,0,0,0h0s.02.01.03.02h.01s.04.02.06.03c0,0,.02,0,.03.01h0s.02.01.03.02h0s.01,0,.01,0h.01s.02.01.02.01c.02,0,.04.02.07.02h.01s.02.01.03.02h.02s0,0,0,0c.02,0,.05.02.07.02h0s.02,0,.04.01h0s.02,0,.02,0h0s.07.02.1.03h.02s0,0,0,0c.01,0,.03,0,.04.01h0s0,0,0,0c.03,0,.06.02.09.02.07.02.14.03.21.05.02,0,.04,0,.06.01.04,0,.08.01.11.02.02,0,.04,0,.06.01.04,0,.08.01.13.02.01,0,.03,0,.04,0,.06,0,.11.01.17.02h0c.06,0,.12.01.18.02h0s.01,0,.01,0h.03s0,0,0,0c.03,0,.06,0,.09,0h0s0,0,0,0h.03s.02,0,.04,0h0s.06,0,.09,0h.02s.03,0,.04,0h0s.02,0,.03,0c.06,0,.11,0,.17,0h.03c.06,0,.13,0,.19-.01h0c.07,0,.13-.01.2-.02h.01c.06,0,.12-.02.18-.03.01,0,.02,0,.03,0,.06-.01.12-.02.18-.03h0s0,0,0,0c.13-.03.26-.06.38-.1h.02s.08-.03.12-.04c-1.2.21-2.46-.02-3.55-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m42.88,48.4s.08-.04.13-.05l-.38-.49-.14.03.39.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m45.41,51.93h-.02s-.02.01-.03.02h-.02s-.02.01-.03.02h-.02s-.02.02-.03.02h-.02s-.02.02-.03.02h-.02s-.02.02-.03.03h-.02s-.02.02-.03.03h-.02s-.03.03-.04.04h0s-.05.04-.08.06h-.01s-.01.02-.01.02c-.02.01-.04.03-.05.04,0,0-.01,0-.02.01h0s-.05.03-.07.05h-.02s-.02.02-.02.02c-.01,0-.03.01-.04.02-.01,0-.02.01-.03.02h-.02s-.02.02-.03.03c-.01,0-.03.01-.04.02-.01,0-.03.01-.04.02h-.02s-.02.02-.04.02c-.01,0-.03.01-.04.02-.02,0-.03.01-.05.02h0s-.03.01-.04.02c-.02,0-.04.01-.06.02h-.02s.14-.03.14-.03c.28-.07.54-.2.78-.4.1-.08.2-.14.31-.17-.03,0-.06.01-.08.02,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m44.98,53.68s.03.03.04.05h0s.03.04.05.05h.01s.03.04.05.05h0s.04.03.05.04h.01s.03.03.05.04h.01s.04.03.06.03h.01s.03.02.05.03h.01s.04.02.06.02h.01s.03.01.05.02h.02s.04.01.06.01h0s.04,0,.05,0h.02s.04,0,.06,0h0s.04,0,.06,0h.02s.04,0,.06,0h0s.04,0,.06-.01c.03,0,.05-.01.08-.02-.35.06-.73-.08-.98-.4l-.14.03s.03.04.04.05h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m46.57,54.95s-.05.02-.07.03h0s-.02.01-.02.01c-.02,0-.03.01-.05.02h-.01s-.02.01-.02.01c-.01,0-.03,0-.04.01h-.02s-.02.01-.02.01c-.01,0-.03,0-.04.01,0,0-.02,0-.03,0h0s.14-.03.14-.03c.07-.02.14-.04.21-.07v-.02s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m43.37,48.25h.02s.04,0,.06-.01c0,0,.02,0,.03,0,.02,0,.03,0,.05,0,.01,0,.02,0,.03,0,.02,0,.03,0,.05,0,.01,0,.02,0,.03,0,.02,0,.03,0,.05,0h.03s.04,0,.05,0h.03s.03,0,.05,0h0s.02,0,.02,0h0s.03,0,.04,0h0s.03,0,.03,0h.02s.01,0,.01,0h0s.02,0,.04,0h.03s0,0,0,0h0s.03,0,.04,0h.03s0,0,0,0c.02,0,.03,0,.05.01.01,0,.02,0,.03,0,.02,0,.03,0,.05.01,0,0,.02,0,.03,0,.02,0,.03.01.05.02h.01s.01,0,.01,0c.02,0,.03.01.05.02h.01s.02.01.02.01h.01s.02.01.03.02h.02s.02.01.02.01c0,0,.02,0,.03.01h0s.02.01.02.01c0,0,.02,0,.02.01,0,0,.02,0,.03.01h.02s.02.02.03.02c0,0,.02,0,.03.01h.01s.02.02.03.03c0,0,.02,0,.02.01h0s.03.02.04.03c0,0,.01,0,.02.01h0s.03.02.04.03c0,0,.01,0,.02.01h0s.02.02.04.03c0,0,.01.01.02.02h0s.02.02.02.02h.01s.01.02.02.03h.01s.02.02.02.03h0s.01.01.02.02h.02s.02.03.02.04c0,0,.01.01.02.02,0,0,.01.01.02.02,0,0,.02.02.02.02h.01s.02.03.02.04c0,0,.01.02.02.02h0s.02.03.03.05c0,0,.01.01.02.02h0s.03.05.05.07l-.82.68.14-.03.82-.68c-.53-.7-1.37-.97-2.14-.78l-.14.03s.03,0,.05-.01h.02s.05-.01.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.35,55.09s-.04,0-.05-.01c.02,0,.04,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.43,55.1s-.04,0-.05,0c.02,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.28,55.07s-.04,0-.05-.01c.02,0,.04,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.56,55.12s-.08,0-.12-.02c.04,0,.08.01.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.7,55.13s-.03,0-.04,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.2,55.05s-.04-.01-.06-.02c.02,0,.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.62,55.12s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.58,53.52s.05-.09.07-.14c-.02.05-.04.09-.07.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.65,53.38s.02-.06.03-.1c0,.03-.02.06-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.14,52s-.06-.03-.09-.04c.03.01.06.03.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.58,48.42s.03.01.04.02c0,0-.02,0-.03-.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.67,54.81c-.11-.07-.21-.14-.3-.23.1.09.2.16.3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.8,54.89s-.04-.02-.06-.03c.02.01.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.73,54.85s-.04-.02-.06-.04c.02.01.04.02.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.13,55.03c-.11-.04-.22-.08-.33-.14.11.06.22.1.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.1,54.29c.08.11.17.2.27.29l-.08-.44-.18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.47,52.46s-.04.01-.05.02c.02,0,.03-.01.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.95,54s.06-.02.09-.03h0s-.05.02-.08.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.27,52.52s-.04.01-.07.01c.02,0,.04,0,.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.41,52.48s-.08.03-.13.04c.01,0,.02,0,.03,0,.02,0,.04,0,.06-.02.01,0,.03,0,.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.81,48.55s.02.01.03.02c0,0-.01,0-.02-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.66,48.46s.02.01.04.02c0,0-.02,0-.03-.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.1,48.77s.02.02.03.03c0,0-.02-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.73,48.5s.02.01.03.02c0,0-.02,0-.02-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.16,48.83s.02.02.03.03c0,0-.02-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.36 49.06 45.36 49.06 44.54 49.74 44.54 49.74 44.54 49.74 45.36 49.06 45.36 49.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.22,48.9s.02.02.02.03c0,0-.01-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.29,48.26h-.02s-.02,0-.02,0c.02,0,.04,0,.07-.01-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.26,50.82s-.02,0-.03,0h-.02s.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.08,48.26s.04,0,.06.01h-.03s-.03-.01-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.48,49.67h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.34,50.9s-.02,0-.03-.01h-.03s-.02-.02-.02-.02c.03,0,.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.45,50.79h-.02s-.03,0-.03,0h-.01s.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "43.01 51.1 43.02 51.11 43.01 51.1 43.01 51.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.88,49.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.93,49.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.86,49.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.91,49.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.35,50.8s-.02,0-.04,0h0s-.01,0-.01,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.17,51.25h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.98,51.27s-.02-.02-.03-.03h-.02s-.05-.05-.07-.07h-.02s-.04-.04-.06-.05c0,0-.02-.01-.02-.02-.02-.01-.05-.03-.07-.04h-.01s-.05-.04-.08-.05h-.02s-.04-.03-.06-.04c0,0-.02,0-.02-.01-.03-.01-.06-.02-.08-.04h0s-.03-.01-.05-.02c.22.08.44.2.63.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.83,49.91v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.23,51.29h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.75,50.55v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.86,51.45h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.76,50.6v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.35,51.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.81,49.96v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.5v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.26,50.87s-.02,0-.03,0h-.02s-.02-.01-.02-.01c.03,0,.05.01.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.45v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.17,50.85s-.04,0-.05-.01h-.01s-.01,0-.01,0c.03,0,.05.01.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.64,50.78h-.01s-.01,0-.01,0c-.01,0-.02,0-.03,0,.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.73,50.78h0s-.03,0-.03,0c-.01,0-.02,0-.03,0,.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.09,50.83s-.04,0-.06-.01h-.03s-.05-.01-.07-.02h-.02s-.06,0-.09-.01h-.02s-.03,0-.05,0c.11,0,.22.02.33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.4v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.78,50.05v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.77,50.1v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.35v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.8,50v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.76,50.15v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.75,50.2v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.3v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.74,50.25v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.99,50.89s.02,0,.04-.01c-.01,0-.02,0-.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.93,49.35h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.01,49.37h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.78,49.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.08,49.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.79,50.7s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.8,50.75s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.82,50.8s0-.02-.01-.03c0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.1,51.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.16,49.43h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.3,49.51h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.09,52.44s-.08-.03-.12-.05c.04.02.08.03.12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.22,52.48s-.08-.02-.11-.04c.04.01.07.03.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.84,52.33s-.07-.04-.1-.06c.03.02.06.04.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.97,52.39s-.08-.04-.12-.06c.04.02.08.04.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.36,49.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.84,50.85s0-.02-.01-.03c0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.42,49.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.55,51.11s.02-.01.03-.02c-.01,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.1,50.86s.04-.01.06-.02c-.02,0-.04.01-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.9,50.93s.03-.01.04-.02c-.01,0-.03.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.77,50.65v-.03s0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.54,50.78h-.02s-.02,0-.02,0h-.01s.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.92,50.99s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.06,51.16h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.48,52.54c-.09-.01-.17-.03-.25-.06.08.02.17.04.25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.96,51.04s-.02-.03-.03-.04c0,.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.89,50.94s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.24,51.34h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.32,51.29h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.87,50.89s0-.02-.01-.03c0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.47,51.17s.02-.01.03-.02c0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.64,51.06s.02-.01.04-.02c-.01,0-.02.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.72,51.01s.02-.01.04-.02c-.01,0-.02.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.81,50.97s.03-.01.04-.02c-.01,0-.03.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.11,51.21h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.43,54.21s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.01,55.11s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.93,55.12s-.02,0-.04,0c.01,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.19,55.08s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.77,55.13s-.03,0-.04,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.85,55.13s-.03,0-.04,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.47,54.14s.06-.1.08-.15c-.02.05-.05.1-.08.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.11,55.1h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.02,51.43h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.73,52.34s-.02.01-.03.02h0s.02-.01.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.55,52.43s-.03.01-.05.02h.01s.02-.01.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.65,52.38s-.04.02-.06.03h.01s.03-.02.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.91,52.23s-.01.01-.02.01h0s.01-.01.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.81,52.29s-.02,0-.03.01h0s.02-.01.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.99,52.17s-.02.01-.02.02h.01s.01-.02.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.14,53.82s-.03-.02-.05-.04h-.01s-.01-.02-.01-.02c.03.02.05.04.08.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.2,53.86s-.03-.02-.05-.03c.03.02.06.04.09.06h-.02s-.01-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.67,54.02h-.02s.06,0,.1,0c-.02,0-.04,0-.06,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.82,54.02s-.04,0-.06,0h0s0,0,0,0c.03,0,.06,0,.1,0h-.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.61,54.01s-.04,0-.06-.01h-.02s-.02,0-.02,0c.05.01.1.02.14.02-.01,0-.02,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.39,53.96s-.03-.01-.05-.02h-.01s-.04-.02-.06-.03h-.01s-.02-.02-.03-.02c.06.03.12.06.18.08h0s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.42,55.01s-.02,0-.03.01h.02s.01-.01.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.35,55.04s-.02,0-.03,0h.01s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.5,54.98s-.02,0-.02,0h.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.24,55.07h0s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.77,48.22s-.04,0-.05,0h-.03s-.03,0-.05,0c-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0,0,0-.02,0-.03,0-.01,0-.03,0-.04,0,.14-.02.29-.03.43-.02-.01,0-.03,0-.04,0h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.97,48.66h0s.02.01.03.02h0s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.87,48.23h-.02s.04,0,.06,0c-.01,0-.02,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.45,48.36h-.01s.03,0,.04.01h-.02s-.01-.01-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.95,48.24h-.03s.04,0,.06,0h0s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.27,48.3s-.03,0-.05-.01c-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0,.06.01.13.03.19.05-.02,0-.03-.01-.05-.02,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.37,48.25s-.02,0-.04,0c.02,0,.05,0,.07-.01h-.01s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.04,48.72h0s.02.01.03.02h0s-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.29,48.97h0s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.03,48.25h-.03s.04,0,.06,0h0s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.9,48.61s.02.01.02.02c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.36,48.33s.03.01.05.02c-.01,0-.02,0-.03-.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.52,48.39h-.01s.03,0,.04.01h0s-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "47.75 54.77 47.68 54.68 47.71 54.84 46.96 55.46 46.96 55.46 47.77 54.79 47.75 54.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m42.81,56.97c-.06-.03-.13-.06-.19-.08h0s-.02-.01-.02-.01h0s-.01,0-.01,0c-.03-.01-.05-.03-.08-.04h-.01s0-.01,0-.01c-.01,0-.02-.01-.03-.02h0s-.04-.02-.06-.03h0s-.02-.01-.02-.01c-.01,0-.02-.01-.03-.02,0,0-.02,0-.03-.01,0,0-.02-.01-.03-.02,0,0-.02-.01-.03-.02h0s-.02-.01-.03-.02h0s-.02-.02-.03-.02c-.01,0-.03-.02-.04-.02-.01,0-.03-.02-.04-.03h-.02s-.07-.05-.1-.08h0s-.08-.06-.13-.08c-.01,0-.02-.01-.03-.02h0s-.08-.06-.12-.09h-.01s-.01-.02-.01-.02c-.02-.02-.05-.04-.07-.05-.01-.01-.03-.02-.04-.03-.03-.02-.06-.04-.08-.07,0,0-.02-.02-.03-.02-.04-.04-.09-.07-.13-.11-.01-.01-.02-.02-.04-.03-.01-.01-.02-.02-.03-.03-.01-.01-.03-.03-.04-.04-.02-.02-.04-.04-.06-.06-.01-.01-.03-.02-.04-.04,0,0-.02-.02-.03-.03h-.01s0-.02,0-.02l-.02-.02h0s0,0,0,0c0,0-.02-.02-.03-.03,0,0-.02-.02-.03-.03,0,0-.01-.01-.02-.02h0s-.05-.05-.08-.08c0,0-.02-.02-.03-.03h0s-.02-.02-.03-.03h-.01s-.02-.03-.03-.05c0-.01-.02-.02-.03-.03h0s-.02-.03-.03-.04c-.02-.02-.04-.05-.06-.08,0-.01-.02-.02-.03-.04-.03-.04-.06-.08-.09-.11h0s-.07-.09-.1-.14h0c-.03-.05-.06-.1-.09-.14h0s.38,2,.38,2h0s.07.06.1.09c.02.01.03.03.05.04.04.03.07.06.11.08.01,0,.02.02.03.02.07.05.14.11.21.16.02.01.03.02.05.03.04.03.07.05.11.08.02.01.03.02.05.03.08.05.16.1.24.15h.01s.08.05.12.07c.02,0,.04.02.05.03.04.02.08.04.12.06h.02c.08.05.16.09.24.13.02,0,.03.02.05.02.04.02.08.04.12.05.02,0,.03.01.05.02.08.04.17.07.26.1h.02s.08.04.13.05c.02,0,.04.01.05.02.04.01.09.03.13.04h0s-.23-1.24-.23-1.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m40.07,47.4c-.35.49-.63,1.01-.85,1.56l.25,1.32h0c.03-.13.06-.26.1-.39h0c.04-.13.08-.26.13-.38h0c.05-.13.1-.25.16-.37h0c.06-.12.12-.24.18-.36h0c.07-.12.13-.23.21-.35h0c.07-.11.15-.22.23-.33h0c.17-.22.35-.42.55-.61h0s-.23-1.24-.23-1.24c-.05.04-.11.08-.16.13-.04.03-.08.07-.12.11-.01.01-.03.02-.04.04-.03.02-.05.05-.08.07-.02.01-.03.03-.05.04-.02.02-.05.04-.07.07-.02.02-.03.03-.05.05-.02.02-.04.04-.07.07-.02.02-.03.03-.05.05-.02.02-.04.04-.06.07-.02.02-.03.04-.05.05-.02.02-.04.04-.06.07-.02.02-.03.04-.05.05-.02.02-.04.04-.06.07-.02.02-.03.04-.05.06-.02.02-.04.04-.05.07-.02.02-.03.04-.05.06-.02.02-.04.05-.05.07-.01.02-.03.04-.04.06-.02.02-.03.05-.05.07-.01.02-.03.04-.04.06-.02.02-.03.05-.05.07-.01.02-.03.04-.04.06-.02.02-.03.05-.05.07-.01.02-.03.04-.04.06-.02.03-.03.05-.05.08-.01.02-.02.04-.03.06-.02.03-.03.06-.05.09,0,.02-.02.03-.03.05-.02.04-.05.08-.07.12v.02s0,0,0,0l.07.37c.24-.46.55-.88.91-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.53,57.38h0c-.06,0-.12,0-.18-.01h0c-.06,0-.11-.01-.17-.02h0s0,0,0,0h-.03s0,0,0,0h0s-.08-.01-.13-.02h0s0,0,0,0c-.01,0-.03,0-.04,0h0s-.01,0-.01,0c-.04,0-.08-.01-.11-.02-.01,0-.03,0-.04,0h0s-.01,0-.01,0c-.07-.01-.14-.03-.21-.05h0s.22,1.16.22,1.16c.08.01.16.03.24.04h0c.08.01.16.02.23.03h0c.08,0,.15.01.23.02h0c.08,0,.16,0,.24.01l-.21-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m41.64,47h0s0,0,0,0h0s.03-.02.04-.03h0s.04-.03.07-.05h0s.02-.01.03-.02c0,0,.02-.01.03-.02h0s.02-.01.03-.02c.01,0,.03-.02.04-.02.02-.01.04-.02.05-.03h0s.04-.03.07-.04h0s.04-.02.05-.03c.02-.01.04-.03.07-.04.02-.01.04-.02.06-.03.02-.01.04-.02.06-.03h0s0,0,0,0c.02,0,.04-.02.06-.03.02-.01.05-.02.07-.03.02,0,.04-.02.06-.03.02,0,.04-.02.06-.03l-.21-1.11h0c-.07.03-.13.06-.2.09-.01,0-.03.01-.04.02-.06.03-.13.06-.19.09h0c-.14.07-.28.15-.42.23h0s.22,1.17.22,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m49.19,48.69h0c.12.19.22.38.32.57h0s0,0,0,0h0c.03.06.06.13.09.19h0s0,0,0,0h0c.03.06.05.13.08.19v.02c.03.06.06.12.08.18h0s0,0,0,0h0c.02.06.04.12.06.19h0s0,.02.01.03c.02.06.04.12.06.18l-.6-3.17s-.04-.05-.06-.07c-.01-.01-.03-.03-.04-.04-.03-.03-.06-.06-.09-.09-.01-.01-.03-.03-.04-.04,0,0-.02-.02-.03-.03-.05-.04-.09-.09-.14-.13l-.02-.02s-.03-.02-.04-.04c-.01-.01-.03-.02-.04-.03l.39,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m50.08,51.26h0c.01.14.02.29.03.43h0s0,0,0,0h0c0,.21,0,.43-.02.64h0s0,.01,0,.01h0c-.01.14-.03.28-.05.41v.02s0,0,0,0c-.01.07-.02.14-.04.2l.39,2.09c.05-.1.1-.2.15-.3h0c.02-.05.04-.1.06-.15v-.02c.03-.05.05-.1.07-.16l-.6-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m38.5,50.8c.04-.32.1-.63.18-.94v-.02s-.07-.42-.07-.42h0c-.05.15-.09.3-.13.46h0c-.04.15-.07.31-.1.47h0s.11.58.11.58c0-.04,0-.08.01-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m38.8,50.47c-.02.12-.04.24-.05.36-.05.46-.06.92-.03,1.38l.32,1.7c.06.19.12.38.19.57-.05-.08-.09-.16-.13-.24l.19,1h0c.03.05.06.11.1.16h0c.03.05.06.1.1.15v.02s.07.09.1.13c0,0,.01.02.02.03.04.05.07.1.11.15h0c.04.05.08.1.12.15h0s-1.05-5.55-1.05-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m46.43,58.29s.04-.01.06-.02c.01,0,.03,0,.04-.01.05-.01.1-.03.16-.05.01,0,.03,0,.04-.01.04-.01.08-.02.12-.04.02,0,.04-.01.06-.02.03-.01.06-.02.1-.03.02,0,.04-.02.06-.02.02,0,.05-.02.07-.03h.02s.04-.02.07-.03c.01,0,.03-.01.04-.02.02,0,.03-.01.05-.02.02,0,.04-.02.07-.03.03-.01.06-.03.08-.04.02-.01.04-.02.07-.03.03-.01.05-.03.08-.04.01,0,.03-.02.04-.02,0,0,.01,0,.02-.01.01,0,.03-.01.04-.02.01,0,.03-.01.04-.02.02-.01.04-.02.07-.04.03-.01.05-.03.08-.05.02-.01.04-.02.07-.04.03-.02.05-.03.08-.05.02-.01.04-.03.06-.04.03-.02.05-.03.08-.05.01,0,.02-.01.03-.02l-.22-1.19c-.05.04-.11.08-.17.12h0s-.01.01-.01.01h0c-.11.08-.23.16-.35.22h0s-.02.01-.02.01c-.12.07-.24.13-.36.19h0s-.02,0-.02,0h0c-.06.03-.12.06-.18.08h0s0,0,0,0h0c-.06.03-.13.05-.19.08h0s0,0,0,0h0c-.06.02-.12.05-.18.07h0s-.01,0-.01,0c-.02,0-.04.01-.06.02-.04.01-.08.03-.12.04h-.02c-.13.04-.25.07-.38.1h-.01c-.06.02-.12.03-.18.04h0s0,0,0,0h-.02s0,0,0,0h0c-.06.01-.12.02-.18.03h-.01c-.07.01-.13.02-.2.02h0c-.06,0-.13.01-.19.01h0s0,0,0,0h0s0,0,0,0h-.01c-.06,0-.11,0-.17,0h-.02s.21,1.1.21,1.1c.15,0,.3-.02.45-.03.02,0,.04,0,.06,0,.04,0,.08,0,.12-.01.06,0,.11-.02.17-.03.02,0,.05,0,.07-.01.04,0,.09-.02.13-.03.02,0,.04,0,.06-.01.07-.01.13-.03.2-.05h0s.04-.01.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m42.82,46.38s.05-.02.07-.03c.01,0,.03-.01.04-.02.04-.01.08-.03.12-.04h.01s0,0,0,0c.02,0,.03,0,.05-.01.03,0,.05-.02.08-.02.01,0,.03,0,.04-.01h0s.06-.02.09-.02h0s.01,0,.01,0h.01s0,0,0,0c.05-.01.1-.02.14-.03h0s.03,0,.04,0h0s.1-.02.14-.03h.02s0,0,0,0h0s0,0,0,0c.04,0,.09-.01.13-.02h.02s.03,0,.04,0h0s.06,0,.08,0c.03,0,.05,0,.08,0h0c.06,0,.11-.01.17-.01.01,0,.02,0,.03,0h.01s0,0,0,0h0s.1,0,.15,0h0s.02,0,.02,0c.06,0,.11,0,.17,0,.01,0,.03,0,.04,0,.05,0,.1,0,.14,0h.03s.06,0,.09,0c.03,0,.05,0,.08,0h0s.03,0,.04,0c.05,0,.09,0,.14.02.01,0,.02,0,.04,0h.02s.1.02.15.02h0s.02,0,.03,0c.02,0,.04,0,.06.01.03,0,.06,0,.08.01h0s.02,0,.02,0h.02s.08.02.11.03c.02,0,.03,0,.05.01h.03s.08.03.12.04h.02s0,0,0,0c.01,0,.03,0,.04.01.04.01.08.02.12.03l-.22-1.19s-.06-.01-.09-.02c-.01,0-.03,0-.04,0h0s-.03,0-.03,0c-.05,0-.09-.02-.14-.03-.01,0-.03,0-.04,0-.07-.01-.13-.02-.2-.03-.01,0-.03,0-.04,0-.06,0-.11-.01-.17-.02-.02,0-.03,0-.05,0-.07,0-.13-.01-.2-.01h-.03s-.01,0-.01,0c-.03,0-.06,0-.08,0-.03,0-.06,0-.08,0-.02,0-.03,0-.05,0-.07,0-.13,0-.2,0h-.03c-.06,0-.12,0-.18,0-.02,0-.03,0-.05,0-.07,0-.13,0-.2.02h-.01s-.08.01-.13.02c-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0-.06,0-.13.02-.19.03h-.01c-.07.01-.13.03-.2.04-.02,0-.03,0-.05.01-.03,0-.06.01-.09.02-.03,0-.06.01-.09.02h0s0,0,0,0c-.07.02-.14.04-.21.06-.02,0-.03,0-.05.01-.07.02-.14.04-.21.07l.21,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m46.71,46.52h0s.1.05.15.07h.01s.04.03.06.04c0,0,.02,0,.02.01.01,0,.03.01.04.02.01,0,.03.01.04.02.01,0,.02.01.03.02.02.01.04.02.06.03h.02s.04.03.06.04h.02s0,.01,0,.01h0s0,0,0,0h0s.1.06.14.09c.01,0,.03.02.04.02.04.02.07.05.11.07.01,0,.02.01.03.02.05.03.09.06.14.1,0,0,.01.01.02.02.04.03.08.06.12.09.01,0,.02.02.03.03.04.03.08.07.13.1h0s.09.08.13.12c0,0,.02.02.02.02.04.03.07.07.11.1,0,0,.02.02.02.02.04.04.09.08.13.13h0s-.31-1.65-.31-1.65h0s-.02-.01-.02-.01h-.02s-.1-.08-.15-.11c-.01,0-.03-.02-.04-.03-.06-.04-.12-.07-.18-.11,0,0-.02-.01-.03-.02-.05-.03-.11-.06-.16-.09-.02,0-.03-.02-.05-.03-.06-.03-.12-.06-.18-.09h-.02c-.06-.03-.12-.06-.17-.09-.02,0-.03-.01-.05-.02-.02,0-.04-.02-.06-.02-.04-.02-.08-.04-.12-.05h0c-.06-.03-.13-.05-.19-.08-.02,0-.03-.01-.05-.02-.05-.02-.1-.03-.15-.05l.24,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m49.64,54.16h0c-.27.63-.66,1.22-1.17,1.72l.24,1.25s.06-.04.08-.07c.05-.04.1-.09.15-.13.01-.01.03-.02.04-.04.04-.03.07-.07.11-.1.01-.01.03-.02.04-.04.05-.04.09-.09.13-.13h0c.05-.05.1-.1.14-.16h.01c.04-.06.09-.11.13-.15v-.02c.15-.16.28-.32.4-.5l-.31-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m39.16,48.64c-.06.1-.11.21-.16.32-.13.28-.23.58-.32.88v.02c-.09.31-.15.62-.19.94,0,.04,0,.08-.01.12-.05.6-.02,1.2.09,1.78.11.54.28,1.06.53,1.54.04.08.08.16.13.24-.07-.19-.14-.38-.19-.57-.12-.41-.21-.82-.27-1.23-.02-.15-.04-.31-.05-.47-.03-.46-.03-.92.03-1.38.01-.12.03-.24.05-.36.03-.18.07-.37.11-.55.07-.3.17-.59.27-.88.01-.03.02-.05.03-.08.22-.55.5-1.07.85-1.56-.36.36-.67.79-.91,1.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 44.37,
    cy: 51.76,
    r: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m46.23,48.47c.05.06-.02.19-.15.3l-2.05,1.71c-.13.11-.29.24-.35.3-.06.06-.21.08-.24-.08l-.26-1.51c-.03-.17.09-.33.25-.36l2.41-.41c.17-.03.34,0,.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m42.53,48.99c.07-.01.16.11.19.28l.45,2.63c.03.17.05.31.05.31,0,0,.02.06.03.14.02.08-.03.23-.19.17l-1.44-.53c-.16-.06-.24-.24-.18-.4l.85-2.29c.06-.16.17-.3.24-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m41.13,52.45c.03-.07.18-.08.34-.02l2.5.93c.16.06.29.11.29.11,0,0,.06.02.14.04.08.02.18.14.05.25l-1.18.98c-.13.11-.33.09-.44-.04l-1.56-1.88c-.11-.13-.18-.3-.15-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.42,55.39c-.05-.06.02-.19.15-.3l2.05-1.71c.13-.11.24-.2.24-.2h0l.12-.1c.1-.13.21-.09.23.08l.26,1.51c.03.17-.09.33-.25.36l-2.41.41c-.17.03-.34,0-.39-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m47.12,54.88c-.07.01-.16-.11-.19-.28l-.45-2.63c-.03-.17-.05-.31-.05-.31,0,0-.02-.06-.03-.14-.02-.08.03-.23.19-.17l1.44.53c.16.06.24.24.18.4l-.85,2.29c-.06.16-.17.3-.24.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m48.52,51.42c-.03.07-.18.08-.34.02l-2.5-.93c-.16-.06-.29-.11-.29-.11,0,0-.06-.02-.14-.04-.08-.02-.18-.14-.05-.25l1.18-.98c.13-.11.33-.09.44.04l1.56,1.88c.11.13.18.3.15.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m44.13,51.1c-.49.41-.56,1.14-.15,1.64s1.14.56,1.64.15h0c.14-.12.24-.26.31-.41-.22.14-.51.1-.68-.11-.19-.22-.15-.55.07-.74.19-.16.46-.16.65-.01-.04-.13-.11-.25-.2-.36-.41-.49-1.14-.56-1.64-.15Zm.37,1.13c-.11.09-.27.08-.36-.03s-.08-.27.03-.36.27-.08.36.03.08.27-.03.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 44.34,
    cy: 52.03,
    r: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 100,
    height: 99,
    transform: "translate(-4 -36)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.97,5.65h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.57,5.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.27,15.42h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.4,7.2l1.34-1.09c-.13.08-.26.17-.39.26-.34.25-.66.52-.96.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.04,8.97h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.18,5.71h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.43,15.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.37,5.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.78,5.66h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.21,14.18h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.56,14.69v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.32,14.35h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.12,15.29h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.8,13.34v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.46,11.38s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.46,11.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.46,11.5v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.75,13.18s0-.03-.01-.04c0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.47,11.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.17,5.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.61,16.34h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "47.54 11.03 47.54 11.02 47.54 11.02 47.54 11.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.59,15.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.01,16.18h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "47.31 9.29 47.31 9.27 47.31 9.27 47.31 9.27 47.31 9.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "46.86 8.23 46.87 8.25 46.86 8.23 46.86 8.23 46.86 8.23 46.86 8.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.26,9.14h0s.01.04.02.05c0-.02-.01-.04-.02-.05,0-.01,0-.02-.01-.03,0,.01,0,.02.01.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.91,14.85s-.02.02-.02.03c0,0,.02-.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.77,8.09s-.01-.02-.02-.03c-.03-.05-.06-.1-.09-.14.03.05.06.09.09.14,0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.11,8.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.97,8.44s.04.09.06.13v.03s.01,0,.01,0h0s.02.05.04.08h0s-.02-.05-.04-.08v-.03s-.06-.09-.08-.13c0-.01-.01-.02-.02-.04-.03-.05-.05-.1-.08-.15.03.05.05.1.08.15,0,.01.01.02.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.35,12.32s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.47,11.75s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.44,11.96h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.52,11.37s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.5,11.58s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.4,12.14s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.54,11.19s0,.03,0,.05c0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.05,14.71h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.32,14.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.19,14.54l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.45,14.21h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.54,10.69s0-.05,0-.07h0s0,0,0,0c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.08,8.53s.05-.1.07-.14c-.02.05-.05.1-.07.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43,4.59s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.99,8.73c.03-.06.05-.11.08-.17-.03.06-.05.11-.08.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.16,8.37c.03-.05.05-.1.08-.15-.03.05-.06.1-.08.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.51,10.23s.02-.09.03-.13c0,.04-.02.09-.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.47,10.43s.02-.09.02-.13c0,.04-.02.09-.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.24,8.22c.03-.05.06-.11.09-.16-.03.05-.06.11-.09.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.53,4.57s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.68,4.57s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.84,4.58s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.37,4.56h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.67,4.78c.15-.04.31-.07.46-.1-.16.03-.31.06-.46.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.6,15.69h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.43,10.73c.01-.09.02-.17.04-.26-.01.09-.03.17-.04.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.96,14.16c-.03-.07-.06-.14-.09-.21.03.07.06.14.09.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.59,15.23s-.05-.06-.07-.1c.02.03.05.06.07.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.86,13.94c-.03-.07-.06-.15-.09-.22.03.07.06.15.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.41,10.92s0-.09.01-.13c0,.04,0,.09-.01.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.87,15.59s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.74,15.43s-.03-.04-.05-.06c.02.02.03.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.5,12.76s-.02-.09-.02-.13c0,.04.02.09.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.38,11.61s0-.09,0-.13c0,.04,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.45,12.42c-.01-.09-.02-.18-.03-.27,0,.09.02.18.03.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.38,11.27c0-.09,0-.19.02-.28,0,.09-.01.19-.02.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.38,11.42s0-.09,0-.13c0,.05,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.41,12.09s0-.09-.01-.13c0,.04,0,.09.01.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.39,11.91c0-.09,0-.18-.01-.27,0,.09,0,.18.01.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.21,4.92c.15-.05.3-.1.46-.14-.15.04-.31.08-.46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.05,17.55c-.07-.02-.13-.04-.2-.05.07.02.13.04.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.85,17.49c-.06-.02-.12-.04-.18-.06.06.02.12.04.18.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.22,15.97s.02.02.03.03c.03.03.06.06.09.08-.03-.03-.06-.06-.09-.08,0,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.87,6.43c.05.05.1.11.15.16-.05-.05-.1-.11-.15-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.26,17.6c-.06-.01-.12-.03-.19-.04.06.02.12.03.19.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.25,17.72c-.05,0-.1,0-.16.01.05,0,.1,0,.16-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.62,17.42s-.09-.03-.14-.05c.05.02.09.03.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.33,16.12h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.46,16.19s.03.03.05.04c.02.02.04.03.06.05-.02-.02-.04-.03-.06-.05-.02-.01-.03-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.95,15.92h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.4,16.87s-.05-.03-.08-.05c-.02-.01-.04-.03-.06-.04.02.01.04.03.06.04.03.02.05.03.08.05.02.01.04.03.06.04.03.02.06.03.08.05-.03-.02-.06-.03-.08-.05-.02-.01-.04-.03-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.02,16.63s.01,0,.02.01c.01,0,.03.02.04.03-.01,0-.03-.02-.04-.03,0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.71,16.4s-.03-.02-.04-.03c.01.01.03.02.04.03.02.01.04.03.06.04.02.02.05.04.07.06-.02-.02-.05-.04-.07-.06-.02-.01-.04-.03-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.77,5.03h0c.06.03.13.05.19.08-.06-.03-.12-.05-.19-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.62,4.69s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.78,4.72s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.24,5.87c.06.04.11.09.17.14-.06-.05-.11-.09-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.93,4.76s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.31,4.63s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.47,4.66s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.09,4.8s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.63,5.45c.14.08.27.17.41.26-.13-.09-.27-.18-.41-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.15,4.61s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.04,5.72c.06.04.11.08.17.13-.06-.04-.11-.08-.17-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.4,4.89s.04.01.06.02c-.02,0-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.57,4.95s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.25,4.84s.04.01.07.02c-.02,0-.04-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.47,12.57s-.01-.09-.02-.13c0,.04.01.09.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.42,9.68s.02.09.03.14v.02s0,0,0,0v.02s0,0,0,0h0c0,.05.02.1.03.15h0s0,0,0,0c0,.01,0,.03,0,.04h0s0,.06.01.09c0,.03,0,.06.01.08h0c0,.06.01.12.02.17h0s0,.03,0,.04l.99-.8v-.03s0-.02,0-.02c-.01-.07-.03-.13-.04-.2,0-.02,0-.03-.01-.05-.01-.06-.03-.11-.04-.17,0-.01,0-.02,0-.03,0-.03-.02-.07-.03-.1l-.94.76s-.02-.08-.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.74,9.73h0s0,.02,0,.02c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "36.52 10.65 36.52 10.66 36.52 10.65 36.52 10.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.61,10.31s0-.04,0-.05c0-.02,0-.04,0-.06,0,.02,0,.04,0,.06,0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.6,11.43v.02s0-.02,0-.02c0-.06.01-.12.01-.18,0-.02,0-.03,0-.05,0,.02,0,.03,0,.05,0,.06,0,.12-.01.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.84,9.44h0s0,0,0,0c0,.01-.01.03-.02.04,0-.01.01-.03.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.97,9.13h0s-.04.09-.06.13c.02-.04.04-.09.06-.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "48.34 8.91 48.34 8.9 48.33 8.88 48.34 8.9 48.34 8.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.77,6.23h0s0,0,0,0c-.01,0-.03-.02-.05-.02.02,0,.03.02.05.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.47,11.04s0-.02,0-.03c0,.04,0,.08,0,.12,0-.03,0-.06,0-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.46,11.22h0s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.49,10.87c0,.05-.01.1-.01.15h0s0,0,0,0c0-.05,0-.1.01-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.01,8.07h0s-.03-.06-.04-.09c.01.03.03.05.04.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.49,10.83h0s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.57,7.3h0s-.05-.08-.07-.11c.02.03.05.07.07.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.1,7.22s.02.02.03.03c0-.01-.02-.02-.03-.03-.02-.02-.04-.04-.06-.06h0s.04.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.18,6.77s-.02-.03-.03-.04c-.02-.02-.04-.04-.06-.07.02.02.04.04.06.07.01.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.4,16.41s-.07.02-.11.03c-.2.06-.4.11-.61.14-.03,0-.07.01-.1.02-.13.02-.26.04-.39.05l-1.3,1.05c-.21-.02-.41-.06-.62-.1.6.13,1.21.17,1.81.13-.11,0-.22.01-.34.01l1.65-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.14,17.24l.99-.8c-.15-.05-.3-.1-.44-.16-.06-.02-.11-.05-.17-.07l-.94.76s.02.01.03.02c.03.02.06.03.09.05.02.01.04.02.06.03.03.02.06.03.09.05.02,0,.04.02.06.03.03.02.07.03.11.05.02,0,.03.02.05.02.05.02.11.05.16.07.06.02.12.05.19.07-.06-.02-.12-.05-.19-.07-.03-.01-.07-.03-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46,7.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.13,7.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.54,7.75h0s.02.02.03.04c0-.01-.02-.02-.03-.04l-.02-.02v.02s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "46.44 7.61 46.44 7.61 46.44 7.62 46.44 7.62 46.44 7.62 46.43 7.6 46.44 7.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.32,6.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.02,6.37h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.84,6.27s.02,0,.03.01c0,0-.02,0-.03-.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.42,12.45v-.02s.01-.03.02-.05c0,.02,0,.03-.01.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.14,6.44h0s.04.03.06.04c.02.01.04.02.05.03.02.01.03.02.05.03h0s-.04-.02-.06-.03c-.02-.01-.03-.02-.05-.03-.02-.01-.04-.03-.07-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.08,6.41s.04.02.05.03c-.02-.01-.04-.02-.05-.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m47.15,12.92c-.04.09-.07.18-.11.27-.07.16-.15.32-.24.47l1.65-1.33s0,.03-.01.05c.01-.06.03-.12.04-.17,0-.01,0-.03,0-.04.01-.07.03-.14.04-.21,0-.02,0-.03,0-.05,0-.06.02-.12.03-.17,0-.02,0-.03,0-.05,0-.07.02-.14.02-.21l-1.3,1.05c-.04.13-.09.26-.14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m48.28,12.9s-.02.06-.03.09l-2.51,2.03c-.23.23-.48.43-.75.61-.01,0-.03.02-.04.03l-2.52,2.04c-.06,0-.11.01-.17.02,2.41-.23,4.68-1.75,5.75-4.14.03-.07.06-.14.09-.21,0-.02.01-.04.02-.05.03-.06.05-.13.07-.19v-.02c.03-.07.06-.14.08-.21,0-.02.01-.04.02-.05.01-.04.02-.08.04-.12-.01.04-.02.08-.04.12,0,.02-.01.04-.02.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "46.19 7.32 46.2 7.33 46.19 7.32 46.19 7.32 46.19 7.32 46.19 7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.23,6.22c.46-.38.97-.69,1.52-.93l.46-.37c-1.58.53-2.98,1.62-3.87,3.14l.79-.64c.3-.45.68-.85,1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.97,5.9c.12.04.23.08.34.12h.02s.04.02.06.03c.02,0,.04.02.06.03.01,0,.03.01.04.02.03.01.06.03.09.04.02,0,.03.02.05.02h0s0,0,0,0h.01s.03.02.05.03l.92-.75c-.21-.13-.44-.24-.67-.35l-.98.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m36.62,12.75h0s-.01-.06-.02-.08h0s0-.01,0-.01h0s0-.03,0-.04c0-.03-.01-.05-.02-.08,0-.01,0-.03,0-.04v-.02s0-.02,0-.02h0s0-.03,0-.04h0s0-.03,0-.04c0-.01,0-.03,0-.04v-.02s0-.02,0-.03v-.02s-.01-.05-.01-.07h0s0-.03,0-.03h0s0-.02,0-.02c0-.04,0-.07-.01-.11h0s0-.04,0-.05h0s0-.02,0-.02l-.98.79c.07.33.16.65.27.96-.03-.08-.05-.15-.08-.23l.92-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.72,4.81c.12,0,.24-.01.36-.01l.29-.24c-.42,0-.83.04-1.24.11l-.33.27c.3-.07.61-.12.93-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37,15.74h0s0,0,0,0c.01.01.03.03.04.04-.01-.01-.03-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.11,14v-.02s0,0,0,0c0-.01-.01-.02-.02-.04v-.02s-.04-.05-.05-.08c0-.01-.01-.02-.02-.03v-.02s-.02-.02-.02-.02c0-.02-.02-.04-.03-.06v-.02s-.02-.01-.02-.01l-.88.71c-.04-.07-.07-.14-.1-.21.15.32.32.63.52.91-.09-.13-.17-.25-.24-.38l.87-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m37.12,8.82c.78-1.5,2.14-2.54,3.67-2.97h0s1.05-.85,1.05-.85c-.03,0-.06,0-.09,0-.31.04-.61.1-.91.18-.18.05-.36.1-.54.16l-4.39,3.55h0c-.17.39-.29.79-.38,1.19l1.58-1.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.48,6.68s-.03-.02-.05-.04c-.02-.02-.04-.03-.06-.04.02.01.04.03.06.04.02.01.03.02.05.04.02.02.04.03.06.05.02.01.03.02.05.04h0s0,0,0,0c.02.02.04.03.06.05h0s0,0,0,0c.02.01.03.02.05.04.02.02.04.04.06.05.01.01.03.02.04.04.02.02.04.04.07.06.01.01.02.02.03.03-.01-.01-.02-.02-.03-.03-.02-.02-.04-.03-.06-.05l.87-.7c.05.05.11.1.16.15-.14-.14-.28-.27-.43-.39l-.88.71s-.03-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.95,15.66s.03-.02.04-.03c-.01,0-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 46.04,
    y: 14.71,
    width: 0,
    height: 0,
    transform: "translate(4.33 39.13) rotate(-48.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.73,13.14s0,.03.01.04h0s0-.03-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 46.44,
    y: 14.21,
    width: 0,
    height: 0,
    transform: "translate(7.84 43.68) rotate(-54.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.77,10.15s0,.02,0,.02h0s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.17,14.56l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.88,14.88s.02-.02.02-.03h0s-.02.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m45.75,15.02h0c-.23.23-.48.43-.75.61.26-.18.51-.39.75-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.49,10.06s0,.06.01.08c0-.03,0-.06-.01-.08v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.75,10.23s0,.02-.01.03h0s0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.97,11.72s-.02,0-.02-.01c0,0,.02.01.03.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.89,11.68s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.01,11.74h-.02s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.11,11.83s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.03,11.76s.02.01.02.02c0,0-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.07,11.79s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.16,11.87h-.01s.01,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.72,10.3s-.01.03-.02.04h0s.01-.03.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.69,10.38s-.02.05-.03.07h0s.02-.05.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.83,11.65s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.61,12.74s-.01-.04-.02-.07c0,.02.01.04.02.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 44.58,
    y: 15.89,
    width: 0,
    height: 0,
    transform: "translate(-1.98 24.39) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.06,7.96h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 46.32,
    y: 14.38,
    width: 0,
    height: 0,
    transform: "translate(6.96 42.73) rotate(-53.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.85,9.69s0,.03,0,.04h0s0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.85,9.61s0,.02,0,.03h0s0-.01,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.54,11.02h0s0,0,0,0h0s0,0,0,0v-.02s0-.04,0-.06v-.02s0,.06,0,.08c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.85,9.53v.02s0,.01,0,.01c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.81 9.96 44.81 9.97 44.82 9.95 44.81 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.82 9.92 44.82 9.92 44.82 9.93 44.82 9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.53,10.45s0,.09,0,.13c0-.04,0-.09,0-.13,0-.02,0-.03,0-.04h0s0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.85,9.46h0s0,.03,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.55,10.76s0-.03,0-.04c0,0,0-.02,0-.03,0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.36,9.45v.02s.01.02.01.03c0,0,0-.02,0-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.83,9.87v.02s0-.03,0-.05c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.2,16.65c.13-.01.26-.03.39-.05-.13.02-.26.04-.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.29,16.44c-.2.06-.4.11-.61.14.2-.04.41-.08.61-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.6 16.34 43.61 16.34 43.6 16.34 43.6 16.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.4,16.41h0s-.07.02-.11.03c.04-.01.07-.02.11-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 44,
    y: 16.18,
    width: 0.01,
    height: 0,
    transform: "translate(-2.81 18.77) rotate(-23.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.8 10.04 44.8 10.04 44.8 10.04 44.8 10.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "46.78 8.11 46.78 8.1 46.77 8.09 46.78 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.85 9.44 44.85 9.44 44.85 9.43 44.85 9.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.79 10.07 44.78 10.09 44.78 10.09 44.79 10.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.84 9.38 44.84 9.39 44.84 9.4 44.84 9.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "41.71 11.6 41.71 11.59 41.72 11.6 41.71 11.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.81 10 44.8 10.01 44.8 10.01 44.81 10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.36,12.83s0,.04.01.05c0-.02,0-.04-.01-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.8,9.54s0,.02-.01.04c0,0,0-.02.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.46,11.22s0,.03,0,.04c0,.01,0,.02,0,.04v-.02s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.42,12.3s.02-.04.03-.07c0,.02-.02.04-.03.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 36.69,
    y: 9.86,
    width: 0,
    height: 0.02,
    transform: "translate(18.57 43.26) rotate(-76.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.38,12.9s0,.02,0,.03v.02s0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.56,13.28s.02.03.03.04h0s-.03-.02-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.42,13.04s0,.02.01.03v.02s0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.39,12.97s.01.04.02.06c0-.02-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.45,13.1s.02.04.03.05h0s-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.53,13.24s.02.03.03.04c-.01-.02-.03-.03-.04-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.48,13.16s.02.03.03.05c-.01-.02-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.47,11.06h0s0,0,0,0c0,.03,0,.06,0,.09v.02s0-.06,0-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.46,11.38s0-.02,0-.03h0s0,.02,0,.03c0,.01,0,.02,0,.03h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.56 12.48 36.56 12.5 36.56 12.49 36.56 12.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.51 12.16 36.51 12.17 36.51 12.17 36.51 12.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.53,12.34s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.55 12.41 36.55 12.43 36.55 12.43 36.55 12.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.51,12.19s0,.05.01.07c0-.02,0-.04,0-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.5,12.12s0-.02,0-.03c0-.02,0-.04,0-.05,0,.04,0,.07.01.11v-.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.46,11.45h0s0,.02,0,.03v.02s0,0,0,0c0-.01,0-.02,0-.03,0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.46,11.57s0,.02,0,.03h0s0,.02,0,.02c0-.02,0-.04,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.47,11.72h0s0,.01,0,.01v.02s0,0,0,0c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.49,11.98s0,.03,0,.04h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 38.26,
    y: 15.42,
    width: 0,
    height: 0,
    transform: "translate(1.67 34.47) rotate(-49.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 36.8,
    y: 13.31,
    width: 0,
    height: 0.03,
    transform: "translate(-2.34 13.67) rotate(-20.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 38.43,
    y: 15.56,
    width: 0,
    height: 0,
    transform: "translate(2.66 36.52) rotate(-52.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "41.44 11.44 41.42 11.43 41.44 11.44 41.44 11.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.94 15.91 38.95 15.92 38.95 15.92 38.94 15.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.34,11.37s-.01-.01-.02-.02c.01,0,.02.02.03.03h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 38.59,
    y: 15.67,
    width: 0,
    height: 0.02,
    transform: "translate(3.23 37.69) rotate(-54.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 37.21,
    y: 14.17,
    width: 0,
    height: 0,
    transform: "translate(-1.95 21.41) rotate(-31.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "41.63 11.55 41.62 11.55 41.63 11.55 41.63 11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.52,11.49h-.01s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.11 15.28 38.12 15.29 38.12 15.29 38.11 15.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 37.55,
    y: 14.67,
    width: 0,
    height: 0.02,
    transform: "translate(-1.13 26.04) rotate(-37.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.37,12.46s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.35,12.61v.02s0,.02,0,.03c0-.02,0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.36,12.53h0s0,.05,0,.07c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.35,12.76s0,.04,0,.05c0-.02,0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.35,12.68s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.84,9.36h0s0-.01,0-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.2,11.24h0s-.02-.02-.03-.03c.01.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.39,12.38s0,.04-.01.05h0s.01-.03.02-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 39.32,
    y: 16.11,
    width: 0,
    height: 0.02,
    transform: "translate(7.44 44.22) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.27,11.31h0s-.02-.02-.02-.03h0s.02.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.39,12.37s.01-.04.02-.06c0,.02-.01.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.99 13.77 37 13.79 37 13.79 36.99 13.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.59,12.61v-.02s-.01-.03-.01-.05c0,.03.01.05.02.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.33,11.62s.01.03.02.04c0-.02-.02-.04-.03-.06h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.36,11.68s.02.05.03.08c-.01-.03-.02-.06-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.45,11.94h0s-.01-.04-.02-.06c0,.02.01.04.02.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.47,12.03v.02s0-.06-.02-.09c0,.02,0,.04.01.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.52,12.37s0,.05,0,.07c0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.52,12.47s0,.06,0,.09c0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.4,11.78s.02.04.02.07c0-.02-.02-.04-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.51,12.26s0,.06,0,.09c0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.79,9.09s0,.03.01.05c0-.02,0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.28 11.52 43.27 11.51 43.28 11.52 43.28 11.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.32,8.79s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.82,9.21h0s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.23,11.45s-.01-.02-.02-.03v.02s.02.01.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.26,11.49s-.02-.03-.03-.04h0s.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.52,12.58s0,.05,0,.08c0-.03,0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.36,8.82s.02.01.02.02c0,0-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.31,11.57s-.02-.03-.02-.05v.02s.02.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.4,8.85s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.48,12.93s0,.02,0,.03c0-.02.01-.05.02-.07,0,.01,0,.03,0,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.5,12.2s0,.03,0,.05c0-.03,0-.06-.01-.09,0,0,0,.02,0,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.84,9.82s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.77,9.29s-.02.04-.02.06h0s.02-.04.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.61,8.61s.02.03.02.05c0-.02-.02-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.83,9.28h0s0-.02,0-.04c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.83 9.31 44.83 9.31 44.84 9.32 44.83 9.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.53,8.47s.02.03.03.04c0-.01-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.37,8.26s.01.02.02.03h0s.02.03.02.04c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.2,13.64s-.06.09-.09.14c.03-.04.06-.09.09-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.47,12.99s-.01.05-.02.08c0-.03.01-.05.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.44,13.09s-.02.06-.03.09c.01-.03.02-.06.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.51,12.78s0,.06-.01.09c0-.03.01-.06.01-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.49,8.93h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.49,12.12v.03s0-.05,0-.07c0,.01,0,.02,0,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.52,12.68s0,.05,0,.07c0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.41,13.2s-.02.05-.03.07c0-.02.02-.05.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.37,13.3s-.03.06-.04.09c.01-.03.03-.06.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.2,11.39h0s-.02-.03-.04-.05h0s.01.04.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.72,9.42v.02s0,0,0,0c0-.02,0-.03.01-.05,0,0,0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.77,10.15s-.01-.03-.02-.05c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.68,8.75s0,.02.01.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.74,10.09s-.01-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m36.96,13.71s.02.04.03.06c0-.02-.02-.04-.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.8,10.2h0s-.02-.03-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.72,10.01s0-.03-.01-.05c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.75,8.94h0s0,.04,0,.04c0-.01,0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 41.84,
    y: 10.27,
    width: 0,
    height: 0,
    transform: "translate(1.08 24.24) rotate(-32.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.68,9.77h0s0,.02,0,.02c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.7,9.95s0-.04-.01-.06c0,.02,0,.04.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.68,9.72s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.72 8.86 44.73 8.86 44.72 8.85 44.72 8.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.68,9.63h0s0,.02,0,.02c0-.01,0-.02,0-.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.73,8.87h0s0,.03,0,.03c0-.01,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m37.1,13.98v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.7 8.8 44.7 8.8 44.71 8.83 44.7 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.68,9.84h0s0,.02,0,.03c0-.02,0-.03,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.7,9.5h0s0,0,0,0c0-.01,0-.03,0-.04,0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.1 11.25 43.09 11.23 43.09 11.24 43.1 11.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.49,8.41s.02.03.03.04c0-.01-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.67 8.73 44.67 8.73 44.68 8.75 44.67 8.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.58,8.54s.02.03.02.04c0-.01-.02-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.27,8.76s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.15,8.71s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.22,8.74s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.15,11.31h0s-.04-.04-.05-.06c0,0,.01.02.02.03,0,.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m40.13,16.44h0c-.15-.05-.3-.1-.44-.16-.06-.02-.11-.05-.17-.07.05.02.11.05.17.07.15.06.29.11.44.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m37.03,13.85h0s.03.05.04.08c-.01-.03-.03-.05-.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.77,9.01h0s0,.03.01.04c0-.01,0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m41.69,9.56h0s0,.02,0,.02c0-.01,0-.02,0-.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.44,8.34h0s0,.01,0,.01c0,.01.02.02.03.03-.01-.02-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.75 8.93 44.75 8.93 44.75 8.93 44.75 8.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.08,11.22s-.02-.03-.04-.04c0,0,.01.02.02.02l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m44.67,8.72h0s-.01-.02-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m46.44,7.61v-.02c-.47-.43-1.02-.79-1.64-1.04-2.78-1.12-6.07.27-7.35,3.1-.08.18-.15.35-.21.53-.01-.01-.02-.03-.04-.04.01.01.02.03.04.04-.05.16-.1.32-.14.49,0,.02,0,.04-.01.06-.08.36-.13.72-.14,1.07.58.76,1.39,1.4,2.39,1.8.05.02.1.04.16.06,0-.01-.01-.02-.02-.03,0-.01-.01-.03-.02-.04,0,0,0-.02-.01-.03,0-.01-.01-.03-.02-.04h0c-.02-.05-.03-.09-.04-.13h0s-.01-.05-.02-.06v-.02s-.02-.03-.02-.05v-.02s-.01-.04-.02-.05v-.02s-.01-.04-.02-.06h0c-.02-.13-.03-.25-.03-.37h0s0-.05,0-.08h0s0-.06,0-.08h0c0-.13.03-.26.06-.38h0c.03-.13.07-.25.13-.37l.22.09.77.31.1.11c-.16.37-.11.76.11,1.05h0c.08.08.18.15.3.19s.23.07.35.07c.05,0,.1,0,.15,0,.03,0,.07,0,.1-.02.12-.03.23-.07.33-.13.03-.02.06-.04.09-.06.08-.06.16-.13.22-.22.04-.06.08-.12.11-.18,0-.02.02-.03.02-.05.07-.15.1-.3.1-.46,0-.03,0-.07,0-.1-.02-.18-.09-.35-.2-.49-.09-.08-.19-.15-.3-.19-.29-.11-.53-.29-.72-.5l-.1-.11.02.02s-.01-.02-.02-.02h0s-.03-.04-.04-.06h0c-.15-.18-.27-.39-.34-.61v-.02c-.03-.08-.06-.16-.08-.25h0s-.01-.09-.02-.12v-.02s-.01-.08-.02-.12h0s0-.09,0-.13v-.02s0-.07,0-.11c0,0,0-.02,0-.03.02-.25.08-.51.19-.76.4-.89,1.33-1.41,2.24-1.33.03,0,.05,0,.08,0l.05-.11.22-.48.25.1.72.29.1.11-.26.57c.06.06.12.11.18.18h0s.01.02.01.02c-.01-.01-.02-.03-.03-.04l.1.11c.53.58.69,1.45.33,2.25l-.99-.4-.1-.11h0s.02-.05.03-.07v-.02s.02-.05.03-.07h0s.01-.06.02-.08h0s0-.06.01-.08h0c0-.06,0-.11,0-.16h0s0-.06,0-.08h0s0-.05-.01-.08h0s-.01-.05-.02-.08h0c-.01-.05-.03-.1-.05-.15h0c-.03-.07-.07-.13-.11-.19-.08-.08-.18-.14-.3-.19-.52-.21-1.14.05-1.38.58-.16.36-.11.76.11,1.04l.02.02h0s.08.07.12.1h.01s.04.03.07.04h.01s.05.03.07.04c.03.01.06.03.09.04.01,0,.02,0,.03.01.02,0,.04.02.06.03.01,0,.02.01.03.02.02,0,.04.02.05.03.01,0,.02.01.04.02.02.01.03.02.05.03.01,0,.02.02.04.02.02.01.03.02.05.03.01,0,.02.02.03.03.01.01.03.02.04.03.01,0,.02.02.03.03.01.01.03.03.04.04,0,0,.02.02.03.03.02.02.03.03.05.05.01.01.03.03.04.04,0,.01.02.02.03.03l-.02-.02.1.11c.53.58.69,1.46.33,2.26-.05.11-.1.21-.16.3,1.39-.41,2.56-1.34,3.16-2.65.28-.62.41-1.27.4-1.9h0s0-.03,0-.03c0-.05,0-.09,0-.14,0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.04,0-.08-.01-.12h0c0-.06-.01-.11-.02-.16,0-.01,0-.03,0-.04,0-.05-.01-.1-.02-.15h0c0-.06-.02-.11-.03-.16,0-.01,0-.03,0-.04,0-.05-.02-.09-.03-.14v-.02c-.02-.05-.03-.1-.05-.15,0-.01,0-.03-.01-.04-.01-.04-.03-.08-.04-.13v-.03s-.02-.05-.03-.07h0c.03.05.06.1.09.14-.01-.02-.03-.04-.04-.06-.02-.02-.03-.05-.05-.07,0-.01-.02-.02-.03-.04h0s-.01-.02-.01-.02c-.03-.04-.05-.07-.08-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m47.11,8.74s.01.02.02.04c.02.04.04.09.05.13,0,.01,0,.02.01.03,0-.01,0-.02-.01-.03-.02-.04-.03-.09-.05-.13,0-.01-.01-.02-.02-.04-.01-.02-.02-.05-.03-.07h0s.02.04.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.6,12.66h0s.01.05.02.08h0s0,.02,0,.02c0-.03-.01-.06-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.05,14.59c.08-.03.16-.07.24-.11-.08.04-.16.08-.24.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.36,14.73h0c-.06,0-.11,0-.17,0h0c.15,0,.3,0,.44-.03-.09.01-.18.02-.27.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.73,13.14s0,.03.01.04h0s-.01-.03-.02-.05h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.84 14.14 39.83 14.13 39.85 14.15 39.84 14.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "40.87 15.03 41.02 14.71 41.03 14.71 41.02 14.71 40.87 15.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.79,13.31v.03s.01,0,.01,0c0-.01-.01-.03-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.52,12.28s0-.05-.01-.07c0,.02,0,.04,0,.06v.02s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.53,12.35s0,.02,0,.03c0,.01,0,.02,0,.03h0s0-.04-.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.1,14.72h0s.05,0,.08,0h0s-.05,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.03,13.85s.03.05.04.08c-.01-.03-.03-.05-.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.68,12.97h0s0,.03.01.05c0-.02-.01-.04-.02-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.46,11.3h0s0-.01,0-.02v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.46 11.57 36.46 11.57 36.46 11.58 36.46 11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.97,15.15h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.46,11.4h0s0,.03,0,.04h0s0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.76,15.28l.05-.11-.05.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.47 11.76 36.47 11.76 36.47 11.75 36.47 11.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.5,12.13v.02s0,.02,0,.02h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.56,12.49h0s0,.04,0,.05c0,.02,0,.03.01.05,0-.03-.01-.07-.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.05,14.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.9 14.2 39.9 14.19 39.91 14.21 39.9 14.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "37.21 14.17 37.21 14.18 37.21 14.19 37.2 14.16 37.21 14.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.97,14.62c-.08.03-.17.05-.25.07.09-.02.17-.04.25-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "37.68 14.83 37.69 14.84 37.68 14.84 37.68 14.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.47 11.07 36.47 11.06 36.47 11.06 36.47 11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37,13.79s-.03-.05-.04-.08c0,.02.02.04.03.06v.02s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.13,16.44h0c.68.21,1.38.27,2.07.21.13-.01.26-.03.39-.05.03,0,.07-.01.1-.02.2-.04.41-.08.61-.14.04-.01.07-.02.11-.03.07-.02.13-.04.2-.07h.02c.13-.05.26-.1.39-.16h.01c.2-.09.39-.19.57-.3h0c.12-.07.25-.15.37-.23.01,0,.03-.02.04-.03.26-.18.51-.39.75-.61.05-.04.09-.09.14-.14,0,0,.02-.02.02-.03.05-.05.09-.09.13-.14h0c.04-.05.09-.1.13-.15l.02-.02c.04-.05.09-.11.13-.16h0c.04-.06.08-.11.13-.17h0c.13-.18.24-.36.35-.55.09-.15.17-.31.24-.47.04-.09.08-.18.11-.27.05-.13.1-.26.14-.39h0c.02-.06.04-.12.05-.18,0-.01,0-.02,0-.03.01-.05.03-.1.04-.15,0-.01,0-.02,0-.03.01-.06.03-.12.04-.17h0c.01-.06.02-.12.03-.17,0-.01,0-.03,0-.04,0-.05.02-.1.02-.14,0,0,0-.02,0-.03,0-.06.01-.11.02-.17,0-.01,0-.03,0-.04,0-.04,0-.09.01-.13,0-.02,0-.03,0-.05,0-.06,0-.11,0-.17h0s0,0,0,0h0s0-.02,0-.03c0-.03,0-.06,0-.08,0-.02,0-.05,0-.07,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.02,0-.05,0-.07,0-.02,0-.05,0-.07h0s0-.03,0-.04c0-.04,0-.09,0-.13,0-.02,0-.03,0-.05,0-.06,0-.11-.02-.17h0s0-.06-.01-.09c0-.03,0-.06-.01-.08v-.02s0-.02,0-.02h0c0-.05-.02-.1-.03-.15h0s0-.02,0-.02v-.02s-.02-.09-.03-.14c0-.01,0-.03,0-.04v-.02s-.02-.08-.03-.12c0,0,0-.02,0-.03v-.02s-.01-.02-.01-.03c-.01-.04-.02-.07-.03-.11,0-.01,0-.02-.01-.04h0s-.02-.06-.03-.08c0-.02-.01-.04-.02-.05h0s0-.02-.01-.03c-.02-.05-.03-.09-.05-.14h0s0-.04-.01-.05c-.02-.04-.03-.09-.05-.13,0-.01-.01-.02-.02-.04-.01-.03-.02-.05-.03-.07-.01-.03-.02-.05-.04-.08h0s-.01-.03-.01-.03c-.02-.04-.04-.09-.06-.13,0-.01-.01-.03-.02-.04-.03-.05-.05-.1-.08-.15v-.02s-.01,0-.01,0c-.02-.04-.05-.09-.08-.13v-.02s-.02-.02-.02-.02c-.03-.05-.06-.09-.09-.14h0c-.03-.05-.06-.1-.09-.14h0s.02.03.02.06v.03s.04.08.05.13c0,.01,0,.03.01.04.01.05.03.1.04.15v.02s.03.09.04.14c0,.01,0,.03,0,.04.01.05.02.1.03.15h0c0,.06.02.1.02.15,0,.01,0,.03,0,.04,0,.05.01.1.02.14h0c0,.05,0,.09.01.14,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,.05,0,.09,0,.14v.02s0,0,0,0c0,.64-.12,1.29-.4,1.9-.6,1.31-1.78,2.24-3.16,2.65-.47.73-1.32,1.12-2.15,1.02l-.26.59-.97-.39-.1-.11h0s.26-.57.26-.57c-.06-.05-.11-.1-.16-.15l-.1-.11h0s0,0,0,0c-.01-.01-.02-.02-.03-.04,0,0-.01-.02-.02-.02-.01-.01-.02-.03-.03-.04l-.02-.02s-.03-.04-.05-.06c0,0-.01-.02-.02-.03,0-.01-.02-.03-.03-.04,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.04h0c-.05-.02-.1-.04-.16-.06-1-.4-1.81-1.04-2.39-1.8-.04,1.26.36,2.48,1.11,3.43.02.02.03.03.05.05h.01c.05.05.1.1.14.14h0c.05.05.1.09.16.14h0c.05.04.11.08.16.12h.01c.11.09.22.16.34.23h.02c.12.08.24.15.36.21h.02c.06.04.12.07.19.1.05.02.11.05.17.07.15.06.29.11.44.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.44,14.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.49,12.03h0s0,0,0,0h0s0,.05,0,.06c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.59,12.62h0s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.04,13.87c-.05.06-.11.13-.16.18.06-.06.11-.12.16-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.84,14.09s-.07.07-.11.1c.04-.03.08-.07.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.62,14.28c-.08.06-.16.11-.25.16.09-.05.17-.1.25-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.55,14.67v.02s.02,0,.02,0c0,0-.01-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.87,13.51h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.11,14h0s-.01,0-.02-.02v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.96 14.25 39.96 14.25 39.98 14.27 39.96 14.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m47.49,7.11l-.48-.53v.02s.01,0,.01,0c.02.02.04.04.06.07.02.02.04.04.06.07.01.01.02.03.03.04.04.05.09.1.13.16h0c.04.06.08.11.11.16.01.01.02.03.03.04.01.02.02.03.04.05.02.03.05.07.07.1h0c.04.07.07.12.11.18,0,.01.02.03.03.04.03.05.06.1.09.15v.02c.05.06.08.12.11.18,0,.02.02.03.02.05.01.03.03.05.04.08.01.03.03.05.04.08h0s.01.03.01.03c.03.06.06.12.08.18,0,.01.01.03.02.04.02.05.04.1.06.15,0,.01.01.03.02.04.02.06.05.12.07.19,0,.01,0,.03.01.04.02.04.03.09.04.13v.03s0,0,0,0c0,.01,0,.03.01.04,0,.03.02.06.03.09,0,.03.02.07.03.1,0,.01,0,.02,0,.03.01.06.03.11.04.17,0,.02,0,.03.01.05.01.07.03.13.04.2v.02s0,.03,0,.03c0,.05.02.1.03.15,0,.02,0,.04,0,.05.01.07.02.14.03.2h0c0,.05,0,.1.01.14,0,.02,0,.04,0,.06,0,.02,0,.04,0,.05,0,.06,0,.13.01.19v.02c0,.07,0,.14,0,.21,0,.02,0,.04,0,.05,0,.06,0,.12,0,.18,0,.01,0,.02,0,.03,0,.07,0,.14,0,.21,0,.02,0,.03,0,.05,0,.06,0,.12-.01.18v.02s0,.02,0,.02h0c0,.07-.02.14-.02.21,0,.02,0,.03,0,.05,0,.06-.02.12-.03.17,0,.02,0,.03,0,.05-.01.07-.03.14-.04.21,0,.01,0,.03,0,.04-.01.06-.03.12-.04.17,0,.02,0,.03-.01.05v.02c-.02.06-.04.12-.06.19,0,.01,0,.02-.01.03,0,.02-.01.04-.02.06-.01.04-.02.08-.04.12,0,.02-.01.04-.02.05-.02.07-.05.14-.07.21v.02c-.03.06-.06.13-.08.19,0,.02-.01.04-.02.05-.03.07-.06.14-.09.21-1.08,2.38-3.34,3.91-5.75,4.14h-.02c-.05,0-.1.01-.16.01h0c-.6.04-1.21,0-1.81-.13h-.02c-.06-.02-.12-.03-.19-.05h-.01c-.07-.02-.13-.04-.2-.06h0c-.06-.02-.12-.04-.18-.06-.02,0-.03-.01-.05-.02-.05-.02-.09-.03-.14-.05-.02,0-.04-.01-.05-.02-.06-.02-.12-.05-.19-.07-.05-.02-.11-.04-.16-.07-.02,0-.03-.02-.05-.02-.04-.02-.07-.03-.11-.05-.02,0-.04-.02-.06-.03-.03-.01-.06-.03-.09-.05-.02-.01-.04-.02-.06-.03-.03-.01-.06-.03-.09-.05-.01,0-.02-.01-.03-.02-.01,0-.02-.01-.03-.02-.03-.02-.06-.03-.08-.05-.02-.01-.04-.03-.06-.04-.03-.02-.05-.03-.08-.05-.02-.01-.04-.03-.06-.04-.03-.02-.05-.03-.08-.05-.02-.01-.04-.03-.06-.04-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03,0,0-.01,0-.02-.01-.01,0-.03-.02-.04-.03-.03-.02-.05-.04-.07-.05-.02-.01-.04-.03-.06-.04-.02-.02-.05-.04-.07-.06-.02-.01-.04-.03-.06-.04-.01-.01-.03-.02-.04-.03-.01,0-.02-.02-.03-.03-.02-.01-.04-.03-.05-.04h-.01s-.04-.05-.06-.06c-.02-.01-.03-.03-.05-.04-.03-.02-.05-.05-.08-.07-.01-.01-.03-.03-.04-.04-.03-.03-.06-.06-.09-.08,0,0-.02-.02-.03-.03-.04-.04-.08-.08-.11-.12,0,0-.02-.02-.03-.03-.01-.01-.03-.03-.04-.04-.01-.01-.03-.03-.04-.04h0s.48.52.48.52c.6.66,1.35,1.19,2.24,1.55,3.32,1.34,7.25-.32,8.78-3.7,1.12-2.48.64-5.2-1.01-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m36.94,11.8c.01-.36.06-.72.14-1.07,0-.02,0-.04.01-.06.04-.16.09-.32.14-.49-.01-.01-.02-.03-.04-.04.01.01.03.03.04.04.06-.18.13-.36.21-.53,1.28-2.83,4.57-4.22,7.35-3.1.63.25,1.17.61,1.63,1.04-.03-.04-.06-.08-.09-.11,0-.01-.02-.02-.03-.03-.03-.04-.06-.07-.1-.11l-.02-.02h0s-.04-.04-.06-.06c-.01-.01-.02-.02-.03-.03-.02-.02-.04-.04-.05-.05h0s-.02-.03-.04-.04h-.01s-.06-.07-.08-.09c-.01-.01-.03-.02-.04-.03-.02-.02-.04-.04-.06-.06-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.06-.05-.02-.01-.03-.03-.05-.04h0s-.04-.03-.06-.05h0s-.03-.03-.05-.04c-.02-.02-.04-.03-.06-.05-.02-.01-.03-.03-.05-.04-.02-.01-.04-.03-.06-.04-.02-.01-.04-.02-.05-.04h0s0,0,0,0c-.02-.01-.03-.02-.05-.03-.02-.01-.04-.02-.05-.04-.02-.01-.04-.03-.06-.04h0s-.04-.02-.06-.03c-.02-.01-.04-.03-.07-.04-.02-.01-.04-.02-.06-.03-.01,0-.03-.01-.04-.02,0,0-.02-.01-.03-.02-.02-.01-.04-.02-.06-.03-.02-.01-.05-.02-.07-.04h0s-.04-.02-.06-.03h0s0,0,0,0c-.02,0-.03-.02-.05-.03h-.01s0,0,0,0c-.02,0-.04-.02-.05-.03-.03-.01-.05-.03-.08-.04-.02,0-.03-.01-.05-.02-.02,0-.04-.02-.06-.03-.02,0-.04-.02-.06-.02h-.02c-.11-.05-.23-.09-.34-.13-.26-.09-.53-.15-.8-.19h0c-.13-.02-.27-.04-.4-.05h0c-.13-.01-.27-.02-.4-.02h0c-.13,0-.27,0-.4,0h0c-.13,0-.27.02-.4.04h0c-.13.02-.26.04-.4.07h0c-.13.03-.26.06-.39.09-1.52.42-2.88,1.47-3.67,2.97-.03.05-.05.1-.07.15h0c-.02.06-.05.11-.07.16h0s-.04.09-.06.13c0,.01-.01.03-.02.04-.01.03-.03.06-.04.09,0,.01-.01.03-.02.04h0s0,.01,0,.01c0,.01-.01.03-.02.04,0,.01-.01.03-.02.04v.02s0,0,0,0c0,0,0,.02-.01.03h0s0,.03-.01.04c-.01.04-.02.07-.04.11h0s0,.02,0,.02c0,.01,0,.03-.01.04,0,.01,0,.03-.01.04h0s0,0,0,0h0s0,.02,0,.02h0s0,.02,0,.02h0s0,.03-.01.04c0,.02,0,.03-.01.05,0,.03-.01.05-.02.08,0,.02,0,.04-.01.05,0,.01,0,.03-.01.04,0,.02,0,.03-.01.05-.01.06-.03.11-.04.17,0,.01,0,.02,0,.04,0,.04-.01.07-.02.11,0,.02,0,.04,0,.05,0,.03,0,.06-.01.09h0s0,.01,0,.01v.02c0,.05-.02.1-.02.15h0s0,.03,0,.04c0,.05-.01.1-.01.15h0s0,.02,0,.03h0s0,.01,0,.01h0s0,.07,0,.1c0,.02,0,.03,0,.05h0s0,0,0,0c0,.02,0,.04,0,.06,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,0,0,.02,0,.03,0,.01,0,.03,0,.04,0,0,0,.02,0,.03,0,.01,0,.02,0,.03,0,.02,0,.04,0,.06h0s0,.04,0,.06c0,.03,0,.06,0,.09,0,.01,0,.02,0,.03h0c0,.08,0,.15.02.22h0s0,0,0,0h0s0,.03,0,.04h0s0,.06,0,.08c0,.01,0,.02,0,.03h0s0,.03,0,.04h0s0,.01,0,.01h0s0,.03,0,.03c0,.02,0,.05.01.07h0s0,.03,0,.05v.02s0,0,0,0c0,.03,0,.05.01.08h0s0,.03,0,.04h0s0,.02,0,.02h0s.01.07.02.11v.02s0,0,0,0c0,.01,0,.03,0,.04h0s0,0,0,0c0,.03.01.06.02.09.02.07.04.14.06.21,0,.02.01.04.02.06.01.04.02.07.04.11,0,.02.01.04.02.06.01.04.03.08.04.12,0,.01,0,.03.01.04.02.05.04.11.06.16h0c.02.06.05.12.07.17h0s0,.01,0,.01v.02s.01,0,.01,0c.01.03.03.05.04.08h0s0,0,0,0v.02s.02.02.03.03h0s.03.05.04.08v.02s.02.02.03.04h0s.01.02.02.03c.03.05.06.1.09.15v.02c.05.05.08.11.12.16h0c.04.06.07.11.11.17h0c.03.06.07.11.11.15,0,0,.01.02.02.02.04.05.07.09.11.14h0s0,.01,0,.01c.08.1.17.2.27.29h.01s.06.07.09.1c-.76-.96-1.15-2.17-1.11-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m44.06,7.96s.07.06.11.09l.26-.57-.1-.11-.26.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m42.15,11.86l-.02-.02s-.01-.01-.02-.02l-.02-.02s-.01-.01-.02-.02h-.02s-.02-.03-.02-.03h-.02s-.02-.02-.02-.03h-.02s-.02-.02-.03-.03h-.02s-.02-.02-.03-.03h-.02s-.03-.02-.05-.03h0s-.06-.03-.09-.04h-.01s-.02-.01-.02-.01c-.02,0-.04-.02-.06-.03,0,0-.02,0-.02-.01h0s-.05-.03-.07-.04h-.02s-.02-.02-.02-.02c-.01,0-.03-.02-.04-.02,0,0-.02-.01-.03-.02h-.02s-.02-.03-.03-.03c-.01,0-.03-.02-.04-.03-.01,0-.02-.02-.03-.03h-.02s-.02-.03-.03-.04c-.01-.01-.02-.02-.04-.03-.01-.01-.03-.02-.04-.04h0s-.02-.03-.03-.04c-.01-.01-.03-.03-.04-.04l-.02-.02.1.11c.19.21.44.38.72.5.12.05.22.11.3.19-.02-.02-.04-.04-.06-.06,0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m40.41,12.31s-.01.04-.02.06h0s-.01.05-.02.07v.02s-.01.04-.01.06h0s0,.05,0,.08v.02s0,.04,0,.05h0s0,.06,0,.08h0s0,.05,0,.07h0s0,.06.01.08h0s0,.05.01.06v.02s.02.04.03.06h0s.01.04.02.06h0s.02.05.03.07h0s.02.04.03.05h0s.02.05.04.06h0s.03.03.04.05c.02.02.04.04.05.06-.22-.28-.28-.68-.11-1.05l-.1-.11s-.02.04-.03.07v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m40.05,14.32s-.04-.03-.06-.05h0s-.02-.02-.02-.02c-.01-.01-.03-.02-.04-.03h-.01s-.02-.02-.02-.02c-.01-.01-.02-.02-.03-.03l-.02-.02h-.01s-.02-.03-.03-.04c0,0-.01-.01-.02-.02h0s.1.1.1.1c.05.05.1.11.16.15v-.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m44.42,8.32v.02s.04.03.05.05c0,0,.01.02.02.02,0,.01.02.03.03.04,0,0,.01.02.02.03,0,.01.02.03.03.04,0,0,.01.02.02.03,0,.01.02.03.02.04v.03s.03.03.04.05v.02s.03.03.03.04h0s0,.02,0,.02h0s.01.03.02.05h0s.01.03.01.03v.02s.01.01.01.01h0s0,.03.01.04v.03s0,0,0,0h0s0,.03.01.05v.03s0,0,0,0c0,.01,0,.03.01.04,0,.01,0,.02,0,.03,0,.02,0,.03.01.05,0,0,0,.02,0,.03,0,.02,0,.04,0,.05h0s0,.03,0,.03c0,.02,0,.03,0,.05h0s0,.03,0,.03h0s0,.03,0,.04v.02s0,.02,0,.02c0,0,0,.02,0,.03h0s0,.03,0,.03c0,0,0,.02,0,.03,0,.01,0,.02,0,.03v.02s0,.02,0,.03c0,0,0,.02,0,.03h0s0,.04,0,.05c0,0,0,.02,0,.03h0s0,.04,0,.06c0,0,0,.02,0,.03h0s0,.04,0,.06c0,0,0,.02,0,.02h0s0,.04,0,.05c0,0,0,.02,0,.03h0s0,.03,0,.03v.02s0,.02,0,.03h0s0,.04,0,.05h0s0,.02,0,.03v.02s-.01.02-.01.03c0,0,0,.02,0,.02,0,0,0,.02,0,.03,0,.01,0,.02,0,.03v.02s-.01.02-.02.03c0,.01,0,.02-.01.03h0s-.01.04-.02.06c0,0,0,.02-.01.03h0s-.02.06-.03.08l-.99-.4.1.11.99.4c.36-.8.2-1.67-.33-2.25l-.1-.11s.02.03.03.04h.01s.03.05.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.35,13.31s-.01-.03-.01-.05c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.37,13.38s-.01-.03-.02-.05c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.33,13.24s0-.04-.01-.05c0,.02,0,.04.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.42,13.51s-.03-.07-.04-.11c.01.04.03.08.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.47,13.63s-.01-.03-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.31,13.16s0-.04-.01-.06c0,.02,0,.04.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.44,13.56s-.01-.03-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.31,13.65c.05,0,.1,0,.15,0-.05,0-.1,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.46,13.64s.07,0,.1-.02c-.03,0-.07.01-.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.43,12.54s0-.07,0-.1c0,.03,0,.07,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.85,9.47s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.26,12.58c0-.12.03-.25.06-.38-.03.13-.05.25-.06.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.26,12.73s0-.05,0-.07c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.26,12.65s0-.05,0-.07c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.29,13.09c-.02-.12-.03-.23-.03-.35,0,.12.01.24.03.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.45,11.83c-.06.12-.1.25-.13.37l.35-.28-.22-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.24,11.28s-.03-.03-.04-.04c.01.01.03.02.04.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.59,13.32s.04.05.07.07h0s-.04-.04-.05-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.1,11.14s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.19,11.24s-.06-.06-.09-.1c0,0,.01.02.02.02.01.01.03.03.04.04.01.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.84,9.73s0,.02,0,.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.85,9.55s0,.03,0,.04c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.78,10.09s0,.02,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.85,9.64s0,.03,0,.04c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.76,10.17s0,.02-.01.03c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.66 10.45 44.66 10.45 43.67 10.05 43.67 10.05 43.67 10.05 44.66 10.45 44.66 10.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.73,10.26s0,.02-.01.03c0-.01,0-.02.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.37,8.26h-.01s-.01-.03-.01-.03c.02.02.03.03.04.05,0,0-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.06,11.2s-.01-.02-.02-.02h-.01s.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.76,8.95s.01.04.02.06v-.03s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.7,9.97v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.5,12.2s0-.02,0-.03v-.03s0-.03,0-.03c0,.03,0,.05.01.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.18,11.36h0s-.01-.04-.01-.04h0s.02.02.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "41.75 9.35 41.74 9.37 41.74 9.36 41.75 9.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.81,8.64h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.91,8.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.76,8.64h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.86,8.64h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.12,11.28s-.01-.02-.02-.03h0s0-.01,0-.01c.01.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.69,9.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.48,12.93s0-.03,0-.04v-.02s.01-.06.02-.09v-.02s0-.05.01-.07c0,0,0-.02,0-.03,0-.03,0-.05,0-.08h0s0-.08,0-.11v-.02s0-.05,0-.07c0,0,0-.02,0-.03,0-.03,0-.06,0-.09h0s0-.04,0-.05c.03.24.03.48-.02.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.71,8.64h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.68,9.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.11,8.87l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.84,10.27h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.07,8.9l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.68,9.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.66,8.64h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.15,8.84h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.49,12.1s0-.02,0-.03v-.02s-.01-.02-.01-.02c0,.03.01.05.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.19,8.81h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.47,12.02s0-.04-.01-.05h0s0-.03,0-.03c0,.03.01.05.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.28,11.52h0s0-.02,0-.02c0,0-.01-.02-.02-.03,0,.02.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.32,11.6h0s-.01-.03-.01-.03c0-.01-.01-.02-.02-.03,0,.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.45,11.93s-.01-.04-.02-.06v-.03s-.02-.04-.03-.07v-.02s-.03-.06-.04-.08v-.02s-.02-.03-.03-.04c.05.1.09.21.12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.23,8.78h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.56,8.66h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.51,8.67h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.28,8.76h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.61,8.65h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.46,8.68h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.41,8.7h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.32,8.74h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.37,8.72h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.87,11s.02.02.03.03c0,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.72,9.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.74,9.41h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.67,9.19h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.75,9.49h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.99,8.97s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.96,9.01s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.92,9.05s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.99,10.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.76,9.58h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.75,9.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.6,10.06s-.01-.08-.01-.12c0,.04,0,.08.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.63,10.2s-.01-.08-.02-.12c0,.04.01.08.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.58,9.79s0-.07,0-.11c0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.59,9.94s0-.09,0-.13c0,.04,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.74,9.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.89,9.09s.01-.02.02-.02c0,0-.01.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.72,9.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.47,10.72s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.95,11.08s.03.03.04.04c-.01-.01-.03-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.79,10.94s.02.02.03.03c-.01,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.03,8.93l.02-.02s-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m43.23,11.44v-.02s-.02-.02-.02-.02h0s.02.02.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.8,9.23s.01-.02.02-.03c0,0-.01.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.72,9.43v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.7,10.46c-.03-.08-.05-.17-.07-.25.02.09.04.17.07.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.77,9.29s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.83,9.18s.01-.02.02-.03c0,0-.01.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.12,10.55h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.2,10.6h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.86,9.13s.01-.02.02-.02c0,0-.01.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.38,10.68s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.55,10.77s.02.01.04.02c-.01,0-.02-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.64,10.82s.02.02.04.02c-.01,0-.02-.02-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m42.72,10.88s.02.02.03.03c-.01,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.7,9.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.1,14.72s.05,0,.08,0c-.03,0-.05,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.64,13.9s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.59,13.83s-.01-.02-.02-.03c0,.01.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.75,14.04s-.01-.02-.02-.02c0,0,.01.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.51,13.7s-.01-.02-.02-.04c0,.01.01.02.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.55,13.77s-.01-.02-.02-.03c0,.01.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.19,14.73c.06,0,.11,0,.17,0-.06,0-.11,0-.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.7,13.98l-.02-.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.94,10.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.47,11.46s-.02-.01-.03-.02h0s.02.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.31,11.34s-.03-.02-.04-.03h0s.02.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.4,11.41s-.03-.03-.05-.04h.01s.03.03.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.65,11.57s-.02,0-.02-.01h0s.02,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.55,11.51s-.02-.01-.02-.02h0s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m41.74,11.61s-.02,0-.03-.01h.01s.01.01.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.36,12.52s0-.04,0-.06v-.02s0-.01,0-.01c0,.03-.01.07-.02.1h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.35,12.6s0-.04,0-.06c0,.03,0,.07,0,.1v-.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.44,13.09v-.02s.02.06.04.09c-.01-.02-.02-.04-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.51,13.21s-.02-.03-.03-.05h0s0,0,0,0c.02.03.03.06.05.08h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.41,13.03s-.01-.04-.02-.06v-.02s-.01-.02-.01-.02c.01.05.03.09.05.14,0-.01,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m40.36,12.81s0-.04,0-.05h0s0-.06,0-.08h0s0-.03,0-.04c0,.07,0,.13.01.2h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.92,14.22s-.02-.01-.02-.02h.01s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.86,14.16s-.02-.02-.02-.02h0s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.98,14.27s-.01-.01-.02-.02h.01s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.78,14.08h0s.01.02.02.02c0,0-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.64,8.66s-.02-.03-.02-.05v-.03s-.03-.03-.04-.04c0,0-.01-.02-.02-.03,0-.01-.02-.03-.03-.04,0,0-.01-.02-.02-.03,0-.01-.02-.03-.03-.04,0,0-.01-.02-.02-.02,0-.01-.02-.02-.03-.03.09.12.16.24.22.37,0-.01-.01-.03-.02-.04v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.82,9.93h0s0,.02,0,.03h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.68,8.75v-.02s0,.04.02.06c0-.01,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.84,9.32h0s0,.02,0,.03v-.02s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.71,8.83v-.02s0,.04.01.05h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.8,9.14s0-.03-.01-.05c0-.01,0-.02,0-.03,0-.01,0-.03-.01-.04.02.06.03.13.04.2,0-.02,0-.03,0-.05,0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.42,8.32s-.02-.02-.02-.03c.01.02.03.04.04.05h0s-.01-.03-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.8,10.01h0s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.7,10.35h0s0,.02-.01.03c0,0,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.74,8.9v-.03s0,.04,0,.06h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.83,9.84s0,.02,0,.03c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.82,9.23s0,.03,0,.05c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m44.84,9.4h0s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "40.76 15.28 40.81 15.17 40.68 15.27 39.78 14.91 39.78 14.91 40.75 15.3 40.76 15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m36.48,11.97c0-.07-.01-.14-.02-.21h0s0-.03,0-.03h0s0-.01,0-.01c0-.03,0-.06,0-.09v-.02s0,0,0,0c0-.01,0-.02,0-.03h0s0-.04,0-.07h0s0-.03,0-.03c0-.01,0-.02,0-.04,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0-.01,0-.02,0-.03h0s0-.03,0-.04h0s0-.03,0-.05c0-.02,0-.03,0-.05,0-.02,0-.03,0-.05v-.02s0-.08,0-.12h0c0-.05,0-.1.01-.15,0-.01,0-.03,0-.04h0c0-.05.01-.1.02-.15v-.02s0-.01,0-.01c0-.03,0-.06.01-.09,0-.02,0-.04,0-.05,0-.04.01-.07.02-.11,0-.01,0-.02,0-.04.01-.06.02-.11.04-.17,0-.02,0-.03.01-.05,0-.01,0-.03.01-.04,0-.02,0-.04.01-.05,0-.03.01-.05.02-.08,0-.02,0-.03.01-.05,0-.01,0-.02.01-.04v-.02s0,0,0,0v-.02s0,0,0,0h0s0-.03.01-.04c0-.01,0-.03.01-.04,0,0,0-.02,0-.02h0s.02-.07.04-.11c0-.01,0-.02.01-.04h0s0-.03.01-.04v-.02s.02-.03.02-.04c0-.01.01-.03.02-.04h0s.01-.04.02-.05c.01-.03.02-.06.04-.09,0-.01.01-.03.02-.04.02-.04.04-.09.06-.13h0c.02-.05.05-.1.07-.15h0c.02-.06.05-.11.07-.16h0s-1.58,1.28-1.58,1.28h0s-.02.09-.03.13c0,.02,0,.04-.01.07,0,.04-.02.09-.02.13,0,.01,0,.03,0,.04-.01.09-.03.17-.04.26,0,.02,0,.04,0,.06,0,.04,0,.09-.01.13,0,.02,0,.04,0,.06,0,.09-.01.19-.02.28h0c0,.06,0,.1,0,.15,0,.02,0,.04,0,.06,0,.04,0,.09,0,.13v.03c0,.09,0,.18.01.27,0,.02,0,.04,0,.06,0,.04,0,.09.01.13,0,.02,0,.04,0,.05,0,.09.02.18.03.27v.02s.02.09.02.13c0,.02,0,.04,0,.06,0,.04.02.09.02.13h0s.98-.79.98-.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m43.6,5.01c-.6-.07-1.19-.08-1.78,0l-1.05.85h0c.13-.04.26-.07.39-.09h0c.13-.03.26-.05.4-.07h0c.13-.02.27-.03.4-.04h0c.13,0,.27-.01.4,0h0c.13,0,.27,0,.4.02h0c.13.01.27.03.4.05h0c.27.04.53.11.8.19h0s.98-.79.98-.79c-.06-.03-.12-.05-.19-.08-.05-.02-.1-.04-.15-.06-.02,0-.03-.01-.05-.02-.03-.01-.07-.02-.1-.04-.02,0-.04-.01-.06-.02-.03-.01-.06-.02-.09-.03-.02,0-.04-.01-.07-.02-.03,0-.06-.02-.09-.03-.02,0-.05-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.01-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.01-.08-.02-.02,0-.05,0-.07-.01-.03,0-.06-.01-.08-.02-.02,0-.05,0-.07-.01-.03,0-.06,0-.09-.01-.02,0-.05,0-.07-.01-.03,0-.06,0-.09-.01-.02,0-.05,0-.07,0-.03,0-.06,0-.09,0-.02,0-.05,0-.07,0-.03,0-.06,0-.09,0-.02,0-.05,0-.07,0-.03,0-.06,0-.09,0-.02,0-.04,0-.06,0-.03,0-.07,0-.1,0-.02,0-.04,0-.06,0-.05,0-.09,0-.14,0h-.02s0,0,0,0l-.29.24c.52,0,1.03.06,1.53.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m36.94,13.67h0c-.03-.06-.05-.11-.07-.17h0c-.02-.06-.04-.11-.06-.16h0s0,0,0,0v-.03s-.01,0-.01,0h0s-.03-.09-.04-.13h0s0,0,0,0c0-.01,0-.03-.01-.04h0s0-.01,0-.01c-.01-.04-.02-.07-.04-.11,0-.01,0-.03-.01-.04h0s0-.02,0-.02c-.02-.07-.04-.14-.06-.21h0s-.92.74-.92.74c.02.08.05.15.08.23h0c.03.08.06.15.09.22h0c.03.08.06.15.09.22h0c.03.08.07.15.1.22l.88-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.7,6.2h0s0,0,0,0h0s.03.02.05.03h0s.05.03.07.04h0s.02.01.03.02c0,0,.02,0,.03.01h0s.02.01.03.02c.01,0,.03.01.04.02.02.01.04.02.05.03h0s.04.03.07.04h0s.04.02.05.03c.02.01.04.03.07.04.02.01.04.02.05.03.02.01.04.02.06.04h0s0,0,0,0c.02.01.03.02.05.04.02.01.04.03.06.04.02.01.03.02.05.04.02.01.03.03.05.04l.88-.71h0c-.06-.05-.11-.09-.17-.14-.01,0-.02-.02-.04-.03-.06-.04-.11-.08-.17-.13h0c-.13-.1-.27-.18-.41-.27h0s-.92.75-.92.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m46.8,13.66h0c-.11.19-.23.37-.35.55h0s0,0,0,0h0c-.04.06-.08.11-.13.17h0s0,0,0,0h0c-.04.05-.08.11-.13.16l-.02.02s-.08.1-.13.15h0s0,0,0,0h0s-.09.1-.13.14h0s-.02.02-.02.03c-.04.05-.09.09-.14.14l2.51-2.03s.02-.06.03-.09c0-.02.01-.04.02-.05.01-.04.02-.08.04-.12,0-.02.01-.04.02-.06,0-.01,0-.02.01-.03.02-.06.03-.12.05-.19v-.02s.01-.03.02-.05c0-.02,0-.03.01-.05l-1.65,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.95,15.66h0c-.12.08-.24.16-.37.23h0s0,0,0,0h0c-.19.11-.38.2-.57.29h0s-.01,0-.01,0h0c-.13.06-.26.11-.39.15h-.02s0,0,0,0c-.06.02-.13.04-.2.07l-1.65,1.34c.11,0,.23,0,.34-.01h0c.05,0,.1,0,.16-.01h.02c.06,0,.11-.01.17-.02l2.52-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m39.87,5.24c.3-.12.6-.22.91-.29h.02s.33-.27.33-.27h0c-.16.03-.31.06-.46.1h0c-.15.04-.31.09-.46.14h0s-.46.37-.46.37c.04-.02.08-.03.11-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m40.3,5.35c-.11.04-.23.08-.34.13-.43.17-.84.38-1.22.63l-1.34,1.09c-.14.14-.28.29-.41.44.05-.08.1-.15.15-.23l-.79.64h0c-.03.05-.06.11-.09.16h0c-.03.05-.06.11-.08.16v.02s-.06.1-.08.14c0,0,0,.02-.01.03-.03.06-.05.11-.08.17h0c-.03.06-.05.12-.08.18h0s4.39-3.55,4.39-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m37.04,15.78s.03.03.04.04c0,0,.02.02.03.03.04.04.08.08.11.12,0,0,.02.02.03.03.03.03.06.06.09.08.01.01.03.03.04.04.03.02.05.05.08.07.02.01.03.03.05.04.02.02.04.03.06.05h.01s.04.04.05.06c.01,0,.02.02.03.03.01.01.03.02.04.03.02.01.04.03.06.04.02.02.05.04.07.06.02.01.04.03.06.04.02.02.05.04.07.05.01,0,.03.02.04.03,0,0,.01,0,.02.01.01,0,.03.02.04.03.01,0,.03.02.04.03.02.01.04.03.06.04.03.02.05.03.08.05.02.01.04.03.06.04.03.02.05.03.08.05.02.01.04.03.06.04.03.02.06.03.08.05.01,0,.02.01.03.02l.94-.76c-.06-.03-.13-.06-.19-.09h0s-.02,0-.02,0h0c-.12-.06-.24-.13-.36-.2h0s-.02-.01-.02-.01c-.12-.07-.23-.15-.34-.22h0s-.01,0-.01,0h0c-.05-.04-.11-.08-.16-.12h0s0,0,0,0h0c-.05-.04-.11-.09-.16-.13h0s0,0,0,0h0s-.1-.08-.14-.13h0s-.01,0-.01,0c-.02-.02-.03-.03-.05-.05-.03-.03-.06-.06-.09-.09h-.01c-.09-.11-.18-.2-.27-.3h0c-.04-.06-.08-.1-.11-.15h0s0,0,0,0v-.02s-.01,0-.01,0h0c-.04-.05-.07-.1-.11-.15h0c-.04-.07-.08-.12-.11-.17h0c-.03-.06-.07-.11-.1-.16h0s0,0,0,0h0s0,0,0,0h0c-.03-.06-.06-.11-.09-.16h0s-.87.69-.87.69c.08.13.16.26.24.38.01.02.02.03.04.05.02.03.05.06.07.1.03.05.07.09.1.14.02.02.03.04.05.06.03.04.06.07.09.11.01.02.03.03.04.05.04.05.09.1.13.15h0s.03.03.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m45.81,6.95s.04.03.06.05c.01.01.02.02.03.03.03.03.06.06.09.09h0s0,0,0,0c.01.01.02.02.04.04.02.02.04.04.06.06.01.01.02.02.03.03h0s.04.05.06.07h0s0,0,0,0h0s0,0,0,0c.03.04.07.07.1.11h0s.02.02.03.03h0s.06.08.09.11v.02s.02,0,.02,0h0s0,0,0,0c.03.04.05.07.08.11l.02.02s.02.02.03.04h0s.03.05.05.07c.01.02.03.04.04.06h0c.03.05.06.1.09.15,0,0,.01.02.02.03h0s0,.01,0,.01h0s.05.08.08.13h0s.01.02.01.02c.03.05.05.1.08.15,0,.01.01.02.02.04.02.04.04.09.06.13v.03s.04.06.05.08c.01.02.02.05.03.07h0s.01.02.02.04c.02.04.04.09.05.13,0,.01,0,.02.01.03v.02s.04.09.06.14h0s0,.02.01.03c0,.02.01.04.02.05,0,.03.02.05.03.08h0s0,.02,0,.02v.02s.03.07.04.11c0,.02,0,.03.01.05v.03s.03.08.04.12v.02s0,0,0,0c0,.01,0,.03,0,.04,0,.04.02.08.02.12l.94-.76s-.02-.06-.03-.09c0-.01,0-.03-.01-.04h0s0-.03,0-.03c-.01-.04-.03-.09-.04-.13,0-.01,0-.03-.01-.04-.02-.06-.04-.13-.07-.19,0-.01-.01-.03-.02-.04-.02-.05-.04-.1-.06-.15,0-.01-.01-.03-.02-.04-.03-.06-.05-.12-.08-.18v-.02s-.02-.01-.02-.01c-.01-.03-.03-.05-.04-.08-.01-.03-.02-.05-.04-.08,0-.02-.02-.03-.02-.05-.03-.06-.06-.12-.1-.18v-.02c-.04-.05-.07-.1-.1-.15,0-.01-.02-.03-.03-.04-.04-.06-.07-.11-.11-.17h0s-.05-.08-.07-.11c-.01-.02-.02-.04-.04-.05-.01-.01-.02-.03-.03-.04-.04-.05-.08-.1-.11-.15h0c-.04-.06-.08-.11-.13-.17-.01-.01-.02-.03-.03-.04-.02-.02-.04-.04-.06-.07-.02-.02-.04-.04-.06-.07h0s0,0,0,0c-.05-.05-.1-.11-.15-.16-.01-.01-.02-.02-.03-.03-.05-.05-.1-.1-.16-.15l-.87.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m47.53,10.45h0c0,.06,0,.11,0,.16h0s0,.06,0,.08c0,0,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04,0,.02,0,.05,0,.07v.02s0,.04,0,.06v.02s0,0,0,0h0s0,0,0,0h0c0,.06,0,.12,0,.17,0,.02,0,.03,0,.05,0,.04,0,.09-.01.13,0,.01,0,.03,0,.04,0,.06-.01.11-.02.17,0,0,0,.02,0,.03,0,.05-.01.1-.02.14,0,.01,0,.03,0,.04,0,.05-.02.11-.03.16h0c-.01.07-.02.12-.04.18,0,.01,0,.02,0,.03-.01.05-.02.1-.04.15,0,.01,0,.02,0,.03-.02.06-.03.12-.05.18h0s1.3-1.05,1.3-1.05h0s0-.02,0-.02v-.02c0-.06.01-.12.02-.18,0-.02,0-.03,0-.05,0-.07,0-.14,0-.21,0-.01,0-.02,0-.03,0-.06,0-.12,0-.18,0-.02,0-.04,0-.05,0-.07,0-.14,0-.21v-.02c0-.06,0-.13-.01-.19,0-.02,0-.04,0-.05,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13h0c0-.08-.02-.14-.03-.21,0-.02,0-.04,0-.05,0-.05-.02-.1-.03-.15l-.99.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m42.2,16.65h0c-.69.06-1.39,0-2.07-.21l-.99.8s.07.03.1.04c.06.02.12.05.19.07.02,0,.04.01.05.02.05.02.09.03.14.05.02,0,.03.01.05.02.06.02.12.04.18.06h0c.07.02.13.04.2.06h.01c.06.02.12.03.19.05h.02c.2.05.41.08.62.11l1.3-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m42.08,4.8c-.12,0-.24,0-.36.01-.31.02-.62.07-.93.14h-.02c-.31.08-.62.18-.91.29-.04.02-.08.03-.11.05-.55.23-1.07.55-1.52.93-.42.35-.8.75-1.1,1.2-.05.07-.1.15-.15.23.13-.15.27-.3.41-.44.3-.3.62-.58.96-.82.13-.09.26-.18.39-.26.39-.25.8-.46,1.22-.63.11-.05.22-.09.34-.13.18-.06.36-.12.54-.16.3-.08.6-.14.91-.18.03,0,.06,0,.09,0,.59-.07,1.18-.06,1.78,0-.49-.15-1.01-.21-1.53-.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 41.81,
    cy: 10.87,
    r: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m45.58,10.94c-.03.07-.18.07-.34.01l-2.48-1c-.16-.06-.35-.14-.43-.16-.08-.03-.18-.15-.04-.25l1.21-.94c.13-.11.33-.08.44.05l1.51,1.92c.11.13.17.3.14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m43.38,7.93c.05.06-.03.19-.16.3l-2.1,1.65c-.13.11-.24.19-.24.19,0,0-.05.04-.11.1-.06.05-.22.08-.24-.09l-.21-1.52c-.02-.17.09-.33.26-.35l2.42-.34c.17-.02.34,0,.39.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.67,8.34c.07-.01.15.12.18.29l.37,2.64c.02.17.04.31.04.31,0,0,.01.07.03.14.02.08-.04.23-.2.16l-1.42-.57c-.16-.06-.24-.25-.17-.4l.91-2.26c.06-.16.18-.3.25-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m38.16,11.75c.03-.07.18-.07.34-.01l2.48,1c.16.06.29.12.29.12h0l.14.06c.16.03.18.14.04.24l-1.21.94c-.13.11-.33.08-.44-.05l-1.51-1.92c-.11-.13-.17-.3-.14-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m40.37,14.76c-.05-.06.03-.19.16-.3l2.1-1.65c.13-.11.24-.19.24-.19,0,0,.05-.04.11-.1.06-.05.22-.08.24.09l.21,1.52c.02.17-.09.33-.26.35l-2.42.34c-.17.02-.34,0-.39-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m44.08,14.36c-.07.01-.15-.12-.18-.29l-.37-2.64c-.02-.17-.04-.31-.04-.31,0,0-.01-.07-.03-.14-.02-.08.04-.23.2-.16l1.42.57c.16.06.24.25.17.4l-.91,2.26c-.06.16-.18.3-.25.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m42.28,10.34c-.59-.24-1.27.05-1.51.64s.05,1.27.64,1.51h0c.17.07.34.09.51.08-.23-.13-.33-.41-.23-.65.11-.27.41-.4.68-.29.23.09.36.33.32.57.09-.1.17-.22.22-.35.24-.59-.05-1.27-.64-1.51Zm-.82.86c-.13-.05-.19-.2-.14-.33s.2-.19.33-.14.19.2.14.33-.2.19-.33.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 41.56,
    cy: 10.97,
    r: 0.3
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.abce31690fb9b9387a39edeaaf6f964c.svg";
export { ForwardRef as ReactComponent };